import css from 'styled-jsx/css';

const styles = css.global`.dss-icon-ban-001:before {
    content: "\\e900"
}

.dss-icon-ban-001-b:before {
    content: "\\e901"
}

.dss-icon-ban-001-c:before {
    content: "\\e902"
}

.dss-icon-ban-002:before {
    content: "\\e903"
}

.dss-icon-ban-002-b:before {
    content: "\\e904"
}

.dss-icon-ban-002-c:before {
    content: "\\e905"
}

.dss-icon-ban-003:before {
    content: "\\e906"
}

.dss-icon-ban-004:before {
    content: "\\e907"
}

.dss-icon-ban-004-b:before {
    content: "\\e908"
}

.dss-icon-ban-004-c:before {
    content: "\\e909"
}

.dss-icon-ban-005:before {
    content: "\\e90a"
}

.dss-icon-ban-006:before {
    content: "\\e90b"
}

.dss-icon-ban-007:before {
    content: "\\e90c"
}

.dss-icon-ban-008:before {
    content: "\\e90d"
}

.dss-icon-ban-008-b:before {
    content: "\\e90e"
}

.dss-icon-ban-008-c:before {
    content: "\\e90f"
}

.dss-icon-ban-009:before {
    content: "\\e910"
}

.dss-icon-ban-010:before {
    content: "\\e911"
}

.dss-icon-ban-010-b:before {
    content: "\\e912"
}

.dss-icon-ban-011:before {
    content: "\\e913"
}

.dss-icon-ban-011-b:before {
    content: "\\e914"
}

.dss-icon-ban-012:before {
    content: "\\e915"
}

.dss-icon-ban-013:before {
    content: "\\e916"
}

.dss-icon-ban-014:before {
    content: "\\e917"
}

.dss-icon-ban-015:before {
    content: "\\e918"
}

.dss-icon-ban-016:before {
    content: "\\e919"
}

.dss-icon-ban-017:before {
    content: "\\e91a"
}

.dss-icon-ban-018:before {
    content: "\\e91b"
}

.dss-icon-ban-019:before {
    content: "\\e91c"
}

.dss-icon-ban-020:before {
    content: "\\e91d"
}

.dss-icon-ban-021:before {
    content: "\\e91e"
}

.dss-icon-ban-023:before {
    content: "\\e91f"
}

.dss-icon-ban-024:before {
    content: "\\e920"
}

.dss-icon-ban-024-b:before {
    content: "\\e921"
}

.dss-icon-ban-024-c:before {
    content: "\\e922"
}

.dss-icon-ban-025:before {
    content: "\\e923"
}

.dss-icon-ban-026:before {
    content: "\\e924"
}

.dss-icon-ban-027:before {
    content: "\\e925"
}

.dss-icon-ban-028:before {
    content: "\\e926"
}

.dss-icon-ban-029:before {
    content: "\\e927"
}

.dss-icon-ban-030:before {
    content: "\\e928"
}

.dss-icon-ban-034:before {
    content: "\\e929"
}

.dss-icon-ban-035:before {
    content: "\\e92a"
}

.dss-icon-ban-036:before {
    content: "\\e92b"
}

.dss-icon-ban-037:before {
    content: "\\e92c"
}

.dss-icon-ban-038:before {
    content: "\\e92d"
}

.dss-icon-ban-039:before {
    content: "\\e92e"
}

.dss-icon-ban-040:before {
    content: "\\e92f"
}

.dss-icon-ban-041:before {
    content: "\\e930"
}

.dss-icon-ban-042:before {
    content: "\\e931"
}

.dss-icon-ban-042-b:before {
    content: "\\e932"
}

.dss-icon-ban-042-c:before {
    content: "\\e933"
}

.dss-icon-ban-043:before {
    content: "\\e934"
}

.dss-icon-ban-044:before {
    content: "\\e935"
}

.dss-icon-ban-045:before {
    content: "\\e936"
}

.dss-icon-ban-045-b:before {
    content: "\\e937"
}

.dss-icon-ban-045-c:before {
    content: "\\e938"
}

.dss-icon-ban-046:before {
    content: "\\e939"
}

.dss-icon-ban-046-b:before {
    content: "\\e93a"
}

.dss-icon-ban-046-c:before {
    content: "\\e93b"
}

.dss-icon-ban-047:before {
    content: "\\e93c"
}

.dss-icon-ban-047-b:before {
    content: "\\e93d"
}

.dss-icon-ban-047-c:before {
    content: "\\e93e"
}

.dss-icon-ban-048:before {
    content: "\\e93f"
}

.dss-icon-ban-048-b:before {
    content: "\\e940"
}

.dss-icon-ban-048-c:before {
    content: "\\e941"
}

.dss-icon-ban-049:before {
    content: "\\e942"
}

.dss-icon-ban-050:before {
    content: "\\e943"
}

.dss-icon-ban-051:before {
    content: "\\e944"
}

.dss-icon-ban-052:before {
    content: "\\e945"
}

.dss-icon-ban-053:before {
    content: "\\e946"
}

.dss-icon-ban-053-b:before {
    content: "\\e947"
}

.dss-icon-ban-053-c:before {
    content: "\\e948"
}

.dss-icon-ban-054:before {
    content: "\\e949"
}

.dss-icon-ban-054-b:before {
    content: "\\e94a"
}

.dss-icon-ban-054-c:before {
    content: "\\e94b"
}

.dss-icon-ban-055:before {
    content: "\\e94c"
}

.dss-icon-ban-055-b:before {
    content: "\\e94d"
}

.dss-icon-ban-055-c:before {
    content: "\\e94e"
}

.dss-icon-ban-056:before {
    content: "\\e94f"
}

.dss-icon-ban-057:before {
    content: "\\e950"
}

.dss-icon-ban-057-b:before {
    content: "\\e951"
}

.dss-icon-ban-058:before {
    content: "\\e952"
}

.dss-icon-ban-059:before {
    content: "\\e953"
}

.dss-icon-ban-060:before {
    content: "\\e954"
}

.dss-icon-ban-060-b:before {
    content: "\\e955"
}

.dss-icon-ban-060-c:before {
    content: "\\e956"
}

.dss-icon-ban-061:before {
    content: "\\e957"
}

.dss-icon-ban-062:before {
    content: "\\e958"
}

.dss-icon-ban-062-b:before {
    content: "\\e959"
}

.dss-icon-ban-062-c:before {
    content: "\\e95a"
}

.dss-icon-ban-063:before {
    content: "\\e95b"
}

.dss-icon-ban-064:before {
    content: "\\e95c"
}

.dss-icon-ban-065:before {
    content: "\\e95d"
}

.dss-icon-ban-066:before {
    content: "\\e95e"
}

.dss-icon-ban-066-b:before {
    content: "\\e95f"
}

.dss-icon-ban-066-c:before {
    content: "\\e960"
}

.dss-icon-ban-067:before {
    content: "\\e961"
}

.dss-icon-ban-068:before {
    content: "\\e962"
}

.dss-icon-ban-069:before {
    content: "\\e963"
}

.dss-icon-ban-070:before {
    content: "\\e964"
}

.dss-icon-ban-071:before {
    content: "\\e965"
}

.dss-icon-ban-072:before {
    content: "\\e966"
}

.dss-icon-ban-073:before {
    content: "\\e967"
}

.dss-icon-ban-074:before {
    content: "\\e968"
}

.dss-icon-ban-075:before {
    content: "\\e969"
}

.dss-icon-ban-075-b:before {
    content: "\\e96a"
}

.dss-icon-ban-076:before {
    content: "\\e96b"
}

.dss-icon-ban-076-b:before {
    content: "\\e96c"
}

.dss-icon-ban-076-c:before {
    content: "\\e96d"
}

.dss-icon-ban-077:before {
    content: "\\e96e"
}

.dss-icon-ban-078:before {
    content: "\\e96f"
}

.dss-icon-ban-079:before {
    content: "\\e970"
}

.dss-icon-ban-080:before {
    content: "\\e971"
}

.dss-icon-ban-081:before {
    content: "\\e972"
}

.dss-icon-ban-082:before {
    content: "\\e973"
}

.dss-icon-ban-083:before {
    content: "\\e974"
}

.dss-icon-ban-084:before {
    content: "\\e975"
}

.dss-icon-ban-084-b:before {
    content: "\\e976"
}

.dss-icon-ban-084-c:before {
    content: "\\e977"
}

.dss-icon-ban-085:before {
    content: "\\e978"
}

.dss-icon-ban-086:before {
    content: "\\e979"
}

.dss-icon-ban-087:before {
    content: "\\e97a"
}

.dss-icon-ban-088:before {
    content: "\\e97b"
}

.dss-icon-ban-089:before {
    content: "\\e97c"
}

.dss-icon-ban-090:before {
    content: "\\e97d"
}

.dss-icon-ban-092:before {
    content: "\\e97e"
}

.dss-icon-ban-093:before {
    content: "\\e97f"
}

.dss-icon-ban-094:before {
    content: "\\e980"
}

.dss-icon-ban-095:before {
    content: "\\e981"
}

.dss-icon-ban-096:before {
    content: "\\e982"
}

.dss-icon-ban-097:before {
    content: "\\e983"
}

.dss-icon-ban-097-b:before {
    content: "\\e984"
}

.dss-icon-ban-097-c:before {
    content: "\\e985"
}

.dss-icon-ban-098:before {
    content: "\\e986"
}

.dss-icon-ban-099:before {
    content: "\\e987"
}

.dss-icon-ban-100:before {
    content: "\\e988"
}

.dss-icon-ban-101:before {
    content: "\\e989"
}

.dss-icon-ban-102:before {
    content: "\\e98a"
}

.dss-icon-ban-103:before {
    content: "\\e98b"
}

.dss-icon-ban-104:before {
    content: "\\e98c"
}

.dss-icon-ban-104-b:before {
    content: "\\e98d"
}

.dss-icon-ban-104-c:before {
    content: "\\e98e"
}

.dss-icon-chan-001:before {
    content: "\\e98f"
}

.dss-icon-chan-002:before {
    content: "\\e990"
}

.dss-icon-chan-002-b:before {
    content: "\\e991"
}

.dss-icon-chan-002-c:before {
    content: "\\e992"
}

.dss-icon-chan-003:before {
    content: "\\e993"
}

.dss-icon-chan-004:before {
    content: "\\e994"
}

.dss-icon-chan-005-b:before {
    content: "\\e995"
}

.dss-icon-chan-005-c:before {
    content: "\\e996"
}

.dss-icon-chan-005-d:before {
    content: "\\e997"
}

.dss-icon-chan-006:before {
    content: "\\e998"
}

.dss-icon-chan-007:before {
    content: "\\e999"
}

.dss-icon-chan-008:before {
    content: "\\e99a"
}

.dss-icon-chan-010:before {
    content: "\\e99b"
}

.dss-icon-chan-011:before {
    content: "\\e99c"
}

.dss-icon-chan-012:before {
    content: "\\e99d"
}

.dss-icon-chan-013:before {
    content: "\\e99e"
}

.dss-icon-chan-014:before {
    content: "\\e99f"
}

.dss-icon-chan-015:before {
    content: "\\e9a0"
}

.dss-icon-chan-016:before {
    content: "\\e9a1"
}

.dss-icon-chan-017:before {
    content: "\\e9a2"
}

.dss-icon-chan-018:before {
    content: "\\e9a3"
}

.dss-icon-chan-019:before {
    content: "\\e9a4"
}

.dss-icon-chan-020:before {
    content: "\\e9a5"
}

.dss-icon-chan-022:before {
    content: "\\e9a6"
}

.dss-icon-chan-023:before {
    content: "\\e9a7"
}

.dss-icon-chan-024:before {
    content: "\\e9a8"
}

.dss-icon-chan-025:before {
    content: "\\e9a9"
}

.dss-icon-chan-026:before {
    content: "\\e9aa"
}

.dss-icon-chan-027:before {
    content: "\\e9ab"
}

.dss-icon-chan-028:before {
    content: "\\e9ac"
}

.dss-icon-chan-029:before {
    content: "\\e9ad"
}

.dss-icon-chan-030:before {
    content: "\\e9ae"
}

.dss-icon-chan-031:before {
    content: "\\e9af"
}

.dss-icon-chan-032:before {
    content: "\\e9b0"
}

.dss-icon-chan-033:before {
    content: "\\e9b1"
}

.dss-icon-chan-034:before {
    content: "\\e9b2"
}

.dss-icon-chan-035:before {
    content: "\\e9b3"
}

.dss-icon-chan-036:before {
    content: "\\e9b4"
}

.dss-icon-chan-037:before {
    content: "\\e9b5"
}

.dss-icon-chan-038:before {
    content: "\\e9b6"
}

.dss-icon-chan-040:before {
    content: "\\e9b7"
}

.dss-icon-chan-041:before {
    content: "\\e9b8"
}

.dss-icon-chan-042:before {
    content: "\\e9b9"
}

.dss-icon-chan-043:before {
    content: "\\e9ba"
}

.dss-icon-chan-044:before {
    content: "\\e9bb"
}

.dss-icon-chan-045:before {
    content: "\\e9bc"
}

.dss-icon-chan-046:before {
    content: "\\e9bd"
}

.dss-icon-chan-047:before {
    content: "\\e9be"
}

.dss-icon-chan-048:before {
    content: "\\e9bf"
}

.dss-icon-chan-049:before {
    content: "\\e9c0"
}

.dss-icon-chan-050:before {
    content: "\\e9c1"
}

.dss-icon-chan-051:before {
    content: "\\e9c2"
}

.dss-icon-chan-052:before {
    content: "\\e9c3"
}

.dss-icon-chan-053:before {
    content: "\\e9c4"
}

.dss-icon-chan-055:before {
    content: "\\e9c5"
}

.dss-icon-chan-056:before {
    content: "\\e9c6"
}

.dss-icon-chan-057:before {
    content: "\\e9c7"
}

.dss-icon-chan-058:before {
    content: "\\e9c8"
}

.dss-icon-chan-059:before {
    content: "\\e9c9"
}

.dss-icon-chan-060:before {
    content: "\\e9ca"
}

.dss-icon-chan-061:before {
    content: "\\e9cb"
}

.dss-icon-chan-062:before {
    content: "\\e9cc"
}

.dss-icon-chan-063:before {
    content: "\\e9cd"
}

.dss-icon-chan-064:before {
    content: "\\e9ce"
}

.dss-icon-chan-065:before {
    content: "\\e9cf"
}

.dss-icon-chan-066:before {
    content: "\\e9d0"
}

.dss-icon-chan-067:before {
    content: "\\e9d1"
}

.dss-icon-chan-068:before {
    content: "\\e9d2"
}

.dss-icon-chan-069:before {
    content: "\\e9d3"
}

.dss-icon-doc-001:before {
    content: "\\e9d4"
}

.dss-icon-doc-002:before {
    content: "\\e9d5"
}

.dss-icon-doc-003:before {
    content: "\\e9d6"
}

.dss-icon-doc-004:before {
    content: "\\e9d7"
}

.dss-icon-doc-005:before {
    content: "\\e9d8"
}

.dss-icon-doc-005-b:before {
    content: "\\e9d9"
}

.dss-icon-doc-005-c:before {
    content: "\\e9da"
}

.dss-icon-doc-006:before {
    content: "\\e9db"
}

.dss-icon-doc-006-b:before {
    content: "\\e9dc"
}

.dss-icon-doc-006-c:before {
    content: "\\e9dd"
}

.dss-icon-doc-007:before {
    content: "\\e9de"
}

.dss-icon-doc-008:before {
    content: "\\e9df"
}

.dss-icon-doc-008-b:before {
    content: "\\e9e0"
}

.dss-icon-doc-008-c:before {
    content: "\\e9e1"
}

.dss-icon-doc-009:before {
    content: "\\e9e2"
}

.dss-icon-doc-010:before {
    content: "\\e9e3"
}

.dss-icon-doc-010-b:before {
    content: "\\e9e4"
}

.dss-icon-doc-010-c:before {
    content: "\\e9e5"
}

.dss-icon-doc-011:before {
    content: "\\e9e6"
}

.dss-icon-doc-011-b:before {
    content: "\\e9e7"
}

.dss-icon-doc-011-c:before {
    content: "\\e9e8"
}

.dss-icon-doc-012:before {
    content: "\\e9e9"
}

.dss-icon-doc-013:before {
    content: "\\e9ea"
}

.dss-icon-doc-013-b:before {
    content: "\\e9eb"
}

.dss-icon-doc-013-c:before {
    content: "\\e9ec"
}

.dss-icon-doc-014:before {
    content: "\\e9ed"
}

.dss-icon-doc-015:before {
    content: "\\e9ee"
}

.dss-icon-doc-016:before {
    content: "\\e9ef"
}

.dss-icon-doc-017:before {
    content: "\\e9f0"
}

.dss-icon-doc-018:before {
    content: "\\e9f1"
}

.dss-icon-doc-019:before {
    content: "\\e9f2"
}

.dss-icon-doc-020:before {
    content: "\\e9f3"
}

.dss-icon-doc-021:before {
    content: "\\e9f4"
}

.dss-icon-doc-022:before {
    content: "\\e9f5"
}

.dss-icon-doc-023:before {
    content: "\\e9f6"
}

.dss-icon-doc-027:before {
    content: "\\e9f7"
}

.dss-icon-doc-024:before {
    content: "\\e9f8"
}

.dss-icon-doc-026:before {
    content: "\\e9f9"
}

.dss-icon-doc-025:before {
    content: "\\e9fa"
}

.dss-icon-func-001:before {
    content: "\\e9fb"
}

.dss-icon-func-002:before {
    content: "\\e9fc"
}

.dss-icon-func-002-b:before {
    content: "\\e9fd"
}

.dss-icon-func-002-c:before {
    content: "\\e9fe"
}

.dss-icon-func-003:before {
    content: "\\e9ff"
}

.dss-icon-func-004:before {
    content: "\\ea00"
}

.dss-icon-func-005:before {
    content: "\\ea01"
}

.dss-icon-func-006:before {
    content: "\\ea02"
}

.dss-icon-func-007:before {
    content: "\\ea03"
}

.dss-icon-func-008:before {
    content: "\\ea04"
}

.dss-icon-func-009:before {
    content: "\\ea05"
}

.dss-icon-func-010:before {
    content: "\\ea06"
}

.dss-icon-func-011:before {
    content: "\\ea07"
}

.dss-icon-func-013:before {
    content: "\\ea08"
}

.dss-icon-func-014:before {
    content: "\\ea09"
}

.dss-icon-func-015:before {
    content: "\\ea0a"
}

.dss-icon-func-016:before {
    content: "\\ea0b"
}

.dss-icon-func-017:before {
    content: "\\ea0c"
}

.dss-icon-func-018:before {
    content: "\\ea0d"
}

.dss-icon-func-019:before {
    content: "\\ea0e"
}

.dss-icon-func-019-b:before {
    content: "\\ea0f"
}

.dss-icon-func-019-c:before {
    content: "\\ea10"
}

.dss-icon-func-020:before {
    content: "\\ea11"
}

.dss-icon-func-021:before {
    content: "\\ea12"
}

.dss-icon-func-022:before {
    content: "\\ea13"
}

.dss-icon-func-023:before {
    content: "\\ea14"
}

.dss-icon-func-024:before {
    content: "\\ea15"
}

.dss-icon-func-025:before {
    content: "\\ea16"
}

.dss-icon-func-026:before {
    content: "\\ea17"
}

.dss-icon-func-027:before {
    content: "\\ea18"
}

.dss-icon-func-028:before {
    content: "\\ea19"
}

.dss-icon-func-029:before {
    content: "\\ea1a"
}

.dss-icon-func-030:before {
    content: "\\ea1b"
}

.dss-icon-func-031:before {
    content: "\\ea1c"
}

.dss-icon-func-032:before {
    content: "\\ea1d"
}

.dss-icon-func-033:before {
    content: "\\ea1e"
}

.dss-icon-func-034:before {
    content: "\\ea1f"
}

.dss-icon-func-035:before {
    content: "\\ea20"
}

.dss-icon-func-036:before {
    content: "\\ea21"
}

.dss-icon-func-037:before {
    content: "\\ea22"
}

.dss-icon-func-038:before {
    content: "\\ea23"
}

.dss-icon-func-039:before {
    content: "\\ea24"
}

.dss-icon-func-040:before {
    content: "\\ea25"
}

.dss-icon-func-041:before {
    content: "\\ea26"
}

.dss-icon-func-042:before {
    content: "\\ea27"
}

.dss-icon-func-043:before {
    content: "\\ea28"
}

.dss-icon-func-044:before {
    content: "\\ea29"
}

.dss-icon-func-045:before {
    content: "\\ea2a"
}

.dss-icon-func-046:before {
    content: "\\ea2b"
}

.dss-icon-func-047:before {
    content: "\\ea2c"
}

.dss-icon-func-048:before {
    content: "\\ea2d"
}

.dss-icon-func-049:before {
    content: "\\ea2e"
}

.dss-icon-func-050:before {
    content: "\\ea2f"
}

.dss-icon-func-051:before {
    content: "\\ea30"
}

.dss-icon-func-052:before {
    content: "\\ea31"
}

.dss-icon-func-053:before {
    content: "\\ea32"
}

.dss-icon-func-054:before {
    content: "\\ea33"
}

.dss-icon-func-055:before {
    content: "\\ea34"
}

.dss-icon-func-056:before {
    content: "\\ea35"
}

.dss-icon-func-057:before {
    content: "\\ea36"
}

.dss-icon-func-058:before {
    content: "\\ea37"
}

.dss-icon-func-059:before {
    content: "\\ea38"
}

.dss-icon-func-060:before {
    content: "\\ea39"
}

.dss-icon-func-061:before {
    content: "\\ea3a"
}

.dss-icon-func-062:before {
    content: "\\ea3b"
}

.dss-icon-func-063:before {
    content: "\\ea3c"
}

.dss-icon-func-064:before {
    content: "\\ea3d"
}

.dss-icon-func-065:before {
    content: "\\ea3e"
}

.dss-icon-func-066:before {
    content: "\\ea3f"
}

.dss-icon-func-067:before {
    content: "\\ea40"
}

.dss-icon-func-068:before {
    content: "\\ea41"
}

.dss-icon-func-069:before {
    content: "\\ea42"
}

.dss-icon-func-070:before {
    content: "\\ea43"
}

.dss-icon-func-071:before {
    content: "\\ea44"
}

.dss-icon-func-072:before {
    content: "\\ea45"
}

.dss-icon-func-073:before {
    content: "\\ea46"
}

.dss-icon-func-074:before {
    content: "\\ea47"
}

.dss-icon-func-075:before {
    content: "\\ea48"
}

.dss-icon-func-076:before {
    content: "\\ea49"
}

.dss-icon-func-077:before {
    content: "\\ea4a"
}

.dss-icon-func-078:before {
    content: "\\ea4b"
}

.dss-icon-func-079:before {
    content: "\\ea4c"
}

.dss-icon-func-080:before {
    content: "\\ea4d"
}

.dss-icon-func-081:before {
    content: "\\ea4e"
}

.dss-icon-func-082:before {
    content: "\\ea4f"
}

.dss-icon-func-083:before {
    content: "\\ea50"
}

.dss-icon-func-084:before {
    content: "\\ea51"
}

.dss-icon-func-085:before {
    content: "\\ea52"
}

.dss-icon-func-086:before {
    content: "\\ea53"
}

.dss-icon-func-087:before {
    content: "\\ea54"
}

.dss-icon-func-087-b:before {
    content: "\\ea55"
}

.dss-icon-func-088:before {
    content: "\\ea56"
}

.dss-icon-func-089:before {
    content: "\\ea57"
}

.dss-icon-func-090:before {
    content: "\\ea58"
}

.dss-icon-func-091:before {
    content: "\\ea59"
}

.dss-icon-func-092:before {
    content: "\\ea5a"
}

.dss-icon-func-094:before {
    content: "\\ea5b"
}

.dss-icon-func-095:before {
    content: "\\ea5c"
}

.dss-icon-func-096:before {
    content: "\\ea5d"
}

.dss-icon-func-097:before {
    content: "\\ea5e"
}

.dss-icon-func-098:before {
    content: "\\ea5f"
}

.dss-icon-func-099:before {
    content: "\\ea60"
}

.dss-icon-func-100:before {
    content: "\\ea61"
}

.dss-icon-func-101:before {
    content: "\\ea62"
}

.dss-icon-func-102:before {
    content: "\\ea63"
}

.dss-icon-func-103:before {
    content: "\\ea64"
}

.dss-icon-func-104:before {
    content: "\\ea65"
}

.dss-icon-func-105:before {
    content: "\\ea66"
}

.dss-icon-func-106:before {
    content: "\\ea67"
}

.dss-icon-func-107:before {
    content: "\\ea68"
}

.dss-icon-func-108:before {
    content: "\\ea69"
}

.dss-icon-func-109:before {
    content: "\\ea6a"
}

.dss-icon-func-110:before {
    content: "\\ea6b"
}

.dss-icon-func-111:before {
    content: "\\ea6c"
}

.dss-icon-func-112:before {
    content: "\\ea6d"
}

.dss-icon-func-113:before {
    content: "\\ea6e"
}

.dss-icon-func-114:before {
    content: "\\ea6f"
}

.dss-icon-func-115:before {
    content: "\\ea70"
}

.dss-icon-func-115-b:before {
    content: "\\ea71"
}

.dss-icon-func-115-c:before {
    content: "\\ea72"
}

.dss-icon-func-116:before {
    content: "\\ea73"
}

.dss-icon-func-118:before {
    content: "\\ea74"
}

.dss-icon-func-119:before {
    content: "\\ea75"
}

.dss-icon-func-120:before {
    content: "\\ea76"
}

.dss-icon-func-121:before {
    content: "\\ea77"
}

.dss-icon-func-122:before {
    content: "\\ea78"
}

.dss-icon-func-122-b:before {
    content: "\\ea79"
}

.dss-icon-func-12-c:before {
    content: "\\ea7a"
}

.dss-icon-func-123:before {
    content: "\\ea7b"
}

.dss-icon-func-124:before {
    content: "\\ea7c"
}

.dss-icon-func-126:before {
    content: "\\ea7d"
}

.dss-icon-func-127:before {
    content: "\\ea7e"
}

.dss-icon-func-128:before {
    content: "\\ea7f"
}

.dss-icon-func-129:before {
    content: "\\ea80"
}

.dss-icon-func-130:before {
    content: "\\ea81"
}

.dss-icon-func-131:before {
    content: "\\ea82"
}

.dss-icon-func-132:before {
    content: "\\ea83"
}

.dss-icon-func-133:before {
    content: "\\ea84"
}

.dss-icon-func-134:before {
    content: "\\ea85"
}

.dss-icon-func-135:before {
    content: "\\ea86"
}

.dss-icon-func-136:before {
    content: "\\ea87"
}

.dss-icon-func-137:before {
    content: "\\ea88"
}

.dss-icon-func-138:before {
    content: "\\ea89"
}

.dss-icon-func-139:before {
    content: "\\ea8a"
}

.dss-icon-func-140:before {
    content: "\\ea8b"
}

.dss-icon-func-141:before {
    content: "\\ea8c"
}

.dss-icon-func-142:before {
    content: "\\ea8d"
}

.dss-icon-func-143:before {
    content: "\\ea8e"
}

.dss-icon-func-144:before {
    content: "\\ea8f"
}

.dss-icon-func-145:before {
    content: "\\ea90"
}

.dss-icon-serv-001:before {
    content: "\\ea91"
}

.dss-icon-serv-002:before {
    content: "\\ea92"
}

.dss-icon-serv-003:before {
    content: "\\ea93"
}

.dss-icon-serv-004:before {
    content: "\\ea94"
}

.dss-icon-serv-005:before {
    content: "\\ea95"
}

.dss-icon-serv-006:before {
    content: "\\ea96"
}

.dss-icon-serv-007:before {
    content: "\\ea97"
}

.dss-icon-serv-008:before {
    content: "\\ea98"
}

.dss-icon-serv-009:before {
    content: "\\ea99"
}

.dss-icon-serv-010:before {
    content: "\\ea9a"
}

.dss-icon-serv-011:before {
    content: "\\ea9b"
}

.dss-icon-serv-012:before {
    content: "\\ea9c"
}

.dss-icon-serv-013:before {
    content: "\\ea9d"
}

.dss-icon-serv-014:before {
    content: "\\ea9e"
}

.dss-icon-serv-015:before {
    content: "\\ea9f"
}

.dss-icon-serv-016:before {
    content: "\\eaa0"
}

.dss-icon-serv-017:before {
    content: "\\eaa1"
}

.dss-icon-serv-018:before {
    content: "\\eaa2"
}

.dss-icon-serv-019:before {
    content: "\\eaa3"
}

.dss-icon-serv-020:before {
    content: "\\eaa4"
}

.dss-icon-serv-021:before {
    content: "\\eaa5"
}

.dss-icon-serv-023:before {
    content: "\\eaa6"
}

.dss-icon-serv-024:before {
    content: "\\eaa7"
}

.dss-icon-serv-025:before {
    content: "\\eaa8"
}

.dss-icon-serv-026:before {
    content: "\\eaa9"
}

.dss-icon-serv-027:before {
    content: "\\eaaa"
}

.dss-icon-serv-028:before {
    content: "\\eaab"
}

.dss-icon-serv-029:before {
    content: "\\eaac"
}

.dss-icon-serv-030:before {
    content: "\\eaad"
}

.dss-icon-serv-031:before {
    content: "\\eaae"
}

.dss-icon-serv-032:before {
    content: "\\eaaf"
}

.dss-icon-serv-033:before {
    content: "\\eab0"
}

.dss-icon-serv-034:before {
    content: "\\eab1"
}

.dss-icon-serv-035:before {
    content: "\\eab2"
}

.dss-icon-serv-036:before {
    content: "\\eab3"
}

.dss-icon-serv-037:before {
    content: "\\eab4"
}

.dss-icon-serv-038:before {
    content: "\\eab5"
}

.dss-icon-serv-039:before {
    content: "\\eab6"
}

.dss-icon-serv-040:before {
    content: "\\eab7"
}

.dss-icon-serv-041:before {
    content: "\\eab8"
}

.dss-icon-serv-042:before {
    content: "\\eab9"
}

.dss-icon-serv-043:before {
    content: "\\eaba"
}

.dss-icon-serv-044:before {
    content: "\\eabb"
}

.dss-icon-serv-045:before {
    content: "\\eabc"
}

.dss-icon-serv-046:before {
    content: "\\eabd"
}

.dss-icon-serv-047:before {
    content: "\\eabe"
}

.dss-icon-serv-048:before {
    content: "\\eabf"
}

.dss-icon-serv-049:before {
    content: "\\eac0"
}

.dss-icon-serv-049-b:before {
    content: "\\eac1"
}

.dss-icon-serv-050:before {
    content: "\\eac2"
}

.dss-icon-serv-051:before {
    content: "\\eac3"
}

.dss-icon-serv-052:before {
    content: "\\eac4"
}

.dss-icon-serv-053:before {
    content: "\\eac5"
}

.dss-icon-serv-054:before {
    content: "\\eac6"
}

.dss-icon-serv-055:before {
    content: "\\eac7"
}

.dss-icon-serv-056:before {
    content: "\\eac8"
}

.dss-icon-serv-057:before {
    content: "\\eac9"
}

.dss-icon-serv-058:before {
    content: "\\eaca"
}

.dss-icon-serv-059:before {
    content: "\\eacb"
}

.dss-icon-serv-060:before {
    content: "\\eacc"
}

.dss-icon-serv-061:before {
    content: "\\eacd"
}

.dss-icon-serv-062:before {
    content: "\\eace"
}

.dss-icon-serv-063:before {
    content: "\\eacf"
}

.dss-icon-serv-064:before {
    content: "\\ead0"
}

.dss-icon-serv-065:before {
    content: "\\ead1"
}

.dss-icon-serv-066:before {
    content: "\\ead2"
}

.dss-icon-serv-067:before {
    content: "\\ead3"
}

.dss-icon-serv-068:before {
    content: "\\ead4"
}

.dss-icon-serv-069:before {
    content: "\\ead5"
}

.dss-icon-serv-070:before {
    content: "\\ead6"
}

.dss-icon-serv-071:before {
    content: "\\ead7"
}

.dss-icon-serv-072:before {
    content: "\\ead8"
}

.dss-icon-serv-073:before {
    content: "\\ead9"
}

.dss-icon-serv-074:before {
    content: "\\eada"
}

.dss-icon-serv-075:before {
    content: "\\eadb"
}

.dss-icon-serv-076:before {
    content: "\\eadc"
}

.dss-icon-serv-077:before {
    content: "\\eadd"
}

.dss-icon-serv-078:before {
    content: "\\eade"
}

.dss-icon-serv-079:before {
    content: "\\eadf"
}

.dss-icon-serv-080:before {
    content: "\\eae0"
}

.dss-icon-serv-081:before {
    content: "\\eae1"
}

.dss-icon-serv-082:before {
    content: "\\eae2"
}

.dss-icon-serv-083:before {
    content: "\\eae3"
}

.dss-icon-serv-084:before {
    content: "\\eae4"
}

.dss-icon-serv-085:before {
    content: "\\eae5"
}

.dss-icon-serv-086:before {
    content: "\\eae6"
}

.dss-icon-serv-087:before {
    content: "\\eae7"
}

.dss-icon-serv-088:before {
    content: "\\eae8"
}

.dss-icon-serv-089:before {
    content: "\\eae9"
}

.dss-icon-serv-090:before {
    content: "\\eaea"
}

.dss-icon-serv-091:before {
    content: "\\eaeb"
}

.dss-icon-serv-092:before {
    content: "\\eaec"
}

.dss-icon-serv-093:before {
    content: "\\eaed"
}

.dss-icon-serv-094:before {
    content: "\\eaee"
}

.dss-icon-serv-095:before {
    content: "\\eaef"
}

.dss-icon-serv-096:before {
    content: "\\eaf0"
}

.dss-icon-serv-097:before {
    content: "\\eaf1"
}

.dss-icon-serv-098:before {
    content: "\\eaf2"
}

.dss-icon-serv-099:before {
    content: "\\eaf3"
}

.dss-icon-serv-100:before {
    content: "\\eaf4"
}

.dss-icon-serv-100-b:before {
    content: "\\eaf5"
}

.dss-icon-serv-101:before {
    content: "\\eaf6"
}

.dss-icon-serv-101-b:before {
    content: "\\eaf7"
}

.dss-icon-serv-102-c:before {
    content: "\\eaf8"
}

.dss-icon-serv-103:before {
    content: "\\eaf9"
}

.dss-icon-serv-104:before {
    content: "\\eafa"
}

.dss-icon-serv-105:before {
    content: "\\eafb"
}

.dss-icon-serv-106:before {
    content: "\\eafc"
}

.dss-icon-serv-107:before {
    content: "\\eafd"
}

.dss-icon-serv-108:before {
    content: "\\eafe"
}

.dss-icon-serv-109:before {
    content: "\\eaff"
}

.dss-icon-serv-110:before {
    content: "\\eb00"
}

.dss-icon-serv-111:before {
    content: "\\eb01"
}

.dss-icon-serv-112:before {
    content: "\\eb02"
}

.dss-icon-serv-113:before {
    content: "\\eb03"
}

.dss-icon-serv-114:before {
    content: "\\eb04"
}

.dss-icon-serv-115:before {
    content: "\\eb05"
}

.dss-icon-serv-116:before {
    content: "\\eb06"
}

.dss-icon-serv-117:before {
    content: "\\eb07"
}

.dss-icon-serv-118:before {
    content: "\\eb08"
}

.dss-icon-serv-119:before {
    content: "\\eb09"
}

.dss-icon-serv-120:before {
    content: "\\eb0a"
}

.dss-icon-serv-121:before {
    content: "\\eb0b"
}

.dss-icon-serv-122:before {
    content: "\\eb0c"
}

.dss-icon-serv-123:before {
    content: "\\eb0d"
}

.dss-icon-serv-124:before {
    content: "\\eb0e"
}

.dss-icon-serv-125:before {
    content: "\\eb0f"
}

.dss-icon-serv-126:before {
    content: "\\eb10"
}

.dss-icon-serv-127:before {
    content: "\\eb11"
}

.dss-icon-serv-128:before {
    content: "\\eb12"
}

.dss-icon-serv-130:before {
    content: "\\eb14"
}

.dss-icon-serv-131:before {
    content: "\\eb15"
}

.dss-icon-serv-132:before {
    content: "\\eb16"
}

.dss-icon-serv-133:before {
    content: "\\eb17"
}

.dss-icon-serv-134:before {
    content: "\\eb18"
}

.dss-icon-serv-135:before {
    content: "\\eb19"
}

.dss-icon-serv-136:before {
    content: "\\eb1a"
}

.dss-icon-serv-137:before {
    content: "\\eb1b"
}

.dss-icon-serv-138:before {
    content: "\\eb1c"
}

.dss-icon-serv-139:before {
    content: "\\eb40"
}

.dss-icon-serv-140:before {
    content: "\\eb41"
}

.dss-icon-serv-141:before {
    content: "\\eb42"
}

.dss-icon-serv-142:before {
    content: "\\eb43"
}

.dss-icon-serv-143:before {
    content: "\\eb44"
}

.dss-icon-serv-144:before {
    content: "\\eb45"
}

.dss-icon-serv-145:before {
    content: "\\eb46"
}

.dss-icon-serv-146:before {
    content: "\\eb47"
}

.dss-icon-serv-147:before {
    content: "\\eb48"
}

.dss-icon-serv-148:before {
    content: "\\eb49"
}

.dss-icon-serv-149:before {
    content: "\\eb4a"
}

.dss-icon-serv-150:before {
    content: "\\eb4b"
}

.dss-icon-serv-151:before {
    content: "\\eb4c"
}

.dss-icon-sys-001:before {
    content: "\\eb1d"
}

.dss-icon-sys-002:before {
    content: "\\eb1e"
}

.dss-icon-sys-003:before {
    content: "\\eb1f"
}

.dss-icon-sys-004:before {
    content: "\\eb20"
}

.dss-icon-sys-005:before {
    content: "\\eb21"
}

.dss-icon-sys-006:before {
    content: "\\eb22"
}

.dss-icon-sys-007:before {
    content: "\\eb23"
}

.dss-icon-sys-008:before {
    content: "\\eb24"
}

.dss-icon-sys-009:before {
    content: "\\eb25"
}

.dss-icon-sys-010:before {
    content: "\\eb26"
}

.dss-icon-sys-011:before {
    content: "\\eb27"
}

.dss-icon-sys-012:before {
    content: "\\eb28"
}

.dss-icon-sys-014:before {
    content: "\\eb29"
}

.dss-icon-sys-015:before {
    content: "\\eb2a"
}

.dss-icon-sys-015-b:before {
    content: "\\eb4d"
}

.dss-icon-sys-016:before {
    content: "\\eb2b"
}

.dss-icon-sys-016-b:before {
    content: "\\eb4e"
}

.dss-icon-sys-017:before {
    content: "\\eb2c"
}

.dss-icon-sys-017-b:before {
    content: "\\eb4f"
}

.dss-icon-sys-018:before {
    content: "\\eb2d"
}

.dss-icon-sys-018-b:before {
    content: "\\eb50"
}

.dss-icon-sys-019:before {
    content: "\\eb2e"
}

.dss-icon-sys-019-b:before {
    content: "\\eb51"
}

.dss-icon-sys-020:before {
    content: "\\eb2f"
}

.dss-icon-sys-021:before {
    content: "\\eb30"
}

.dss-icon-sys-022:before {
    content: "\\eb31"
}

.dss-icon-sys-022-b:before {
    content: "\\eb52"
}

.dss-icon-sys-023:before {
    content: "\\eb32"
}

.dss-icon-sys-024:before {
    content: "\\eb33"
}

.dss-icon-sys-025:before {
    content: "\\eb34"
}

.dss-icon-sys-026:before {
    content: "\\eb35"
}

.dss-icon-sys-027:before {
    content: "\\eb36"
}

.dss-icon-sys-028:before {
    content: "\\eb37"
}

.dss-icon-sys-029:before {
    content: "\\eb38"
}

.dss-icon-sys-030:before {
    content: "\\eb39"
}

.dss-icon-sys-031:before {
    content: "\\eb3a"
}

.dss-icon-sys-032:before {
    content: "\\eb3b"
}

.dss-icon-sys-033:before {
    content: "\\eb3c"
}

.dss-icon-sys-033-b:before {
    content: "\\eb53"
}

.dss-icon-sys-034:before {
    content: "\\eb3d"
}

.dss-icon-sys-035:before {
    content: "\\eb3e"
}

.dss-icon-sys-036:before {
    content: "\\eb3f"
}

.dss-icon-sys-037:before {
    content: "\\eb54"
}

.dss-icon-sys-038:before {
    content: "\\eb55"
}

.dss-icon-sys-038-b:before {
    content: "\\eb56"
}

.dss-icon-sys-039:before {
    content: "\\eb57"
}

.dss-icon-24h:before {
    content: "\\f101"
}

.dss-icon-3-dots-horizontal:before {
    content: "\\f102"
}

.dss-icon-3-dots-vertical:before {
    content: "\\f103"
}

.dss-icon-academy:before {
    content: "\\f104"
}

.dss-icon-accelerator:before {
    content: "\\f105"
}

.dss-icon-accessibility:before {
    content: "\\f106"
}

.dss-icon-account-bonus-dollar:before {
    content: "\\f107"
}

.dss-icon-account-bonus-euro:before {
    content: "\\f108"
}

.dss-icon-account-bonus-pound:before {
    content: "\\f109"
}

.dss-icon-account-dollar:before {
    content: "\\f10a"
}

.dss-icon-account-euro:before {
    content: "\\f10b"
}

.dss-icon-account-group-dollar:before {
    content: "\\f10c"
}

.dss-icon-account-group-euro:before {
    content: "\\f10d"
}

.dss-icon-account-group-pound:before {
    content: "\\f10e"
}

.dss-icon-account-management-dollar:before {
    content: "\\f10f"
}

.dss-icon-account-management-euro:before {
    content: "\\f110"
}

.dss-icon-account-management-pound:before {
    content: "\\f111"
}

.dss-icon-account-people:before {
    content: "\\f112"
}

.dss-icon-account-pound:before {
    content: "\\f113"
}

.dss-icon-account-search-dollar:before {
    content: "\\f114"
}

.dss-icon-account-search-euro:before {
    content: "\\f115"
}

.dss-icon-account-search-pound:before {
    content: "\\f116"
}

.dss-icon-account-user:before {
    content: "\\f117"
}

.dss-icon-add-1px:before {
    content: "\\f118"
}

.dss-icon-add-in-a-circle:before {
    content: "\\f119"
}

.dss-icon-add-photo:before {
    content: "\\f11a"
}

.dss-icon-add-to-calendar:before {
    content: "\\f11b"
}

.dss-icon-add:before {
    content: "\\f11c"
}

.dss-icon-aesthetics:before {
    content: "\\f11d"
}

.dss-icon-agile-coach-2:before {
    content: "\\f11e"
}

.dss-icon-agile-coach:before {
    content: "\\f11f"
}

.dss-icon-agile:before {
    content: "\\f120"
}

.dss-icon-agribusiness:before {
    content: "\\f121"
}

.dss-icon-agriculture-workers:before {
    content: "\\f122"
}

.dss-icon-alert:before {
    content: "\\f123"
}

.dss-icon-alphabetical-order:before {
    content: "\\f124"
}

.dss-icon-ambulance:before {
    content: "\\f125"
}

.dss-icon-american:before {
    content: "\\f126"
}

.dss-icon-analysis:before {
    content: "\\f127"
}

.dss-icon-ant:before {
    content: "\\f128"
}

.dss-icon-antenna:before {
    content: "\\f129"
}

.dss-icon-app-santander:before {
    content: "\\f12a"
}

.dss-icon-apple-outline:before {
    content: "\\f12b"
}

.dss-icon-appliances:before {
    content: "\\f12c"
}

.dss-icon-appointments:before {
    content: "\\f12d"
}

.dss-icon-arrow-down:before {
    content: "\\f12e"
}

.dss-icon-arrow-left:before {
    content: "\\f12f"
}

.dss-icon-arrow-right:before {
    content: "\\f130"
}

.dss-icon-arrow-up:before {
    content: "\\f131"
}

.dss-icon-assisted-navigation:before {
    content: "\\f132"
}

.dss-icon-associations:before {
    content: "\\f133"
}

.dss-icon-at:before {
    content: "\\f134"
}

.dss-icon-atm-dollar:before {
    content: "\\f135"
}

.dss-icon-atm-euro:before {
    content: "\\f136"
}

.dss-icon-atm-pound:before {
    content: "\\f137"
}

.dss-icon-atm:before {
    content: "\\f138"
}

.dss-icon-atom:before {
    content: "\\f139"
}

.dss-icon-attach-document:before {
    content: "\\f13a"
}

.dss-icon-attachment:before {
    content: "\\f13b"
}

.dss-icon-auction:before {
    content: "\\f13c"
}

.dss-icon-audio-off:before {
    content: "\\f13d"
}

.dss-icon-audio-on:before {
    content: "\\f13e"
}

.dss-icon-authentication:before {
    content: "\\f13f"
}

.dss-icon-awards:before {
    content: "\\f140"
}

.dss-icon-backlog:before {
    content: "\\f141"
}

.dss-icon-bag-of-money-dollar:before {
    content: "\\f142"
}

.dss-icon-bag-of-money-euro:before {
    content: "\\f143"
}

.dss-icon-bag-of-money-pound:before {
    content: "\\f144"
}

.dss-icon-bank-fees:before {
    content: "\\f145"
}

.dss-icon-barcode:before {
    content: "\\f146"
}

.dss-icon-basket:before {
    content: "\\f147"
}

.dss-icon-bath:before {
    content: "\\f148"
}

.dss-icon-bathroom-alt:before {
    content: "\\f149"
}

.dss-icon-bathroom:before {
    content: "\\f14a"
}

.dss-icon-bbq:before {
    content: "\\f14b"
}

.dss-icon-beach:before {
    content: "\\f14c"
}

.dss-icon-become-new-client:before {
    content: "\\f14d"
}

.dss-icon-bed:before {
    content: "\\f14e"
}

.dss-icon-bell:before {
    content: "\\f14f"
}

.dss-icon-benefitiary:before {
    content: "\\f150"
}

.dss-icon-bike:before {
    content: "\\f151"
}

.dss-icon-blink:before {
    content: "\\f152"
}

.dss-icon-block-in-a-circle:before {
    content: "\\f153"
}

.dss-icon-boat-trip:before {
    content: "\\f154"
}

.dss-icon-bodybuilding:before {
    content: "\\f155"
}

.dss-icon-book:before {
    content: "\\f156"
}

.dss-icon-booklet-atm-enter:before {
    content: "\\f157"
}

.dss-icon-booklet-atm-withdraw:before {
    content: "\\f158"
}

.dss-icon-bookmark:before {
    content: "\\f159"
}

.dss-icon-broker-plataform:before {
    content: "\\f15a"
}

.dss-icon-brush:before {
    content: "\\f15b"
}

.dss-icon-bug:before {
    content: "\\f15c"
}

.dss-icon-building:before {
    content: "\\f15d"
}

.dss-icon-burger-menu-1px:before {
    content: "\\f15e"
}

.dss-icon-burger-menu:before {
    content: "\\f15f"
}

.dss-icon-burndowncharct:before {
    content: "\\f160"
}

.dss-icon-burndownchart2:before {
    content: "\\f161"
}

.dss-icon-business-alert:before {
    content: "\\f162"
}

.dss-icon-business-store:before {
    content: "\\f163"
}

.dss-icon-business-support:before {
    content: "\\f164"
}

.dss-icon-calculator:before {
    content: "\\f165"
}

.dss-icon-calendar:before {
    content: "\\f166"
}

.dss-icon-call-center-db:before {
    content: "\\f167"
}

.dss-icon-call-support:before {
    content: "\\f168"
}

.dss-icon-camera:before {
    content: "\\f169"
}

.dss-icon-camping-gas:before {
    content: "\\f16a"
}

.dss-icon-cancel-appointments:before {
    content: "\\f16b"
}

.dss-icon-cancel-check:before {
    content: "\\f16c"
}

.dss-icon-cancel-checkbook:before {
    content: "\\f16d"
}

.dss-icon-cancel-next-receipt:before {
    content: "\\f16e"
}

.dss-icon-capitalization:before {
    content: "\\f16f"
}

.dss-icon-card-block:before {
    content: "\\f170"
}

.dss-icon-card-enter-e-cash:before {
    content: "\\f171"
}

.dss-icon-card-extract:before {
    content: "\\f172"
}

.dss-icon-card-insert:before {
    content: "\\f173"
}

.dss-icon-card-invoice:before {
    content: "\\f174"
}

.dss-icon-card-machine:before {
    content: "\\f175"
}

.dss-icon-card-postpone-liquidation:before {
    content: "\\f176"
}

.dss-icon-card:before {
    content: "\\f177"
}

.dss-icon-cardboard-box:before {
    content: "\\f178"
}

.dss-icon-cards:before {
    content: "\\f179"
}

.dss-icon-carnivorous-food:before {
    content: "\\f17a"
}

.dss-icon-center-position:before {
    content: "\\f17b"
}

.dss-icon-champions-league:before {
    content: "\\f17c"
}

.dss-icon-change-account-associate-dollar:before {
    content: "\\f17d"
}

.dss-icon-change-account-associate-euro:before {
    content: "\\f17e"
}

.dss-icon-change-account-associate-pound:before {
    content: "\\f17f"
}

.dss-icon-change-beneficiary:before {
    content: "\\f180"
}

.dss-icon-change-contributions:before {
    content: "\\f181"
}

.dss-icon-chat-bot:before {
    content: "\\f182"
}

.dss-icon-chat:before {
    content: "\\f183"
}

.dss-icon-check-asigment:before {
    content: "\\f184"
}

.dss-icon-check:before {
    content: "\\f185"
}

.dss-icon-checkbook:before {
    content: "\\f186"
}

.dss-icon-checking-account-change:before {
    content: "\\f187"
}

.dss-icon-checking-account-closing:before {
    content: "\\f188"
}

.dss-icon-checking-account-open:before {
    content: "\\f189"
}

.dss-icon-checking-account:before {
    content: "\\f18a"
}

.dss-icon-checklist:before {
    content: "\\f18b"
}

.dss-icon-checkmark-in-a-circle:before {
    content: "\\f18c"
}

.dss-icon-checkmark:before {
    content: "\\f18d"
}

.dss-icon-chemistry:before {
    content: "\\f18e"
}

.dss-icon-chevron-down-1px:before {
    content: "\\f18f"
}

.dss-icon-chevron-down-small-1px:before {
    content: "\\f190"
}

.dss-icon-chevron-down-small:before {
    content: "\\f191"
}

.dss-icon-chevron-down:before {
    content: "\\f192"
}

.dss-icon-chevron-left-1px:before {
    content: "\\f193"
}

.dss-icon-chevron-left-small-1px:before {
    content: "\\f194"
}

.dss-icon-chevron-left-small:before {
    content: "\\f195"
}

.dss-icon-chevron-left:before {
    content: "\\f196"
}

.dss-icon-chevron-right-1px:before {
    content: "\\f197"
}

.dss-icon-chevron-right-small-1px:before {
    content: "\\f198"
}

.dss-icon-chevron-right-small:before {
    content: "\\f199"
}

.dss-icon-chevron-right:before {
    content: "\\f19a"
}

.dss-icon-chevron-up-1px:before {
    content: "\\f19b"
}

.dss-icon-chevron-up-small-1px:before {
    content: "\\f19c"
}

.dss-icon-chevron-up-small:before {
    content: "\\f19d"
}

.dss-icon-chevron-up:before {
    content: "\\f19e"
}

.dss-icon-children:before {
    content: "\\f19f"
}

.dss-icon-cinema:before {
    content: "\\f1a0"
}

.dss-icon-circle-account-add-user:before {
    content: "\\f1a1"
}

.dss-icon-circle-account-user:before {
    content: "\\f1a2"
}

.dss-icon-circuit:before {
    content: "\\f1a3"
}

.dss-icon-city:before {
    content: "\\f1a4"
}

.dss-icon-civil-liability:before {
    content: "\\f1a5"
}

.dss-icon-clean:before {
    content: "\\f1a6"
}

.dss-icon-clients:before {
    content: "\\f1a7"
}

.dss-icon-clip:before {
    content: "\\f1a8"
}

.dss-icon-clipboard:before {
    content: "\\f1a9"
}

.dss-icon-clock-out:before {
    content: "\\f1aa"
}

.dss-icon-clock-restart:before {
    content: "\\f1ab"
}

.dss-icon-close-1px:before {
    content: "\\f1ac"
}

.dss-icon-close:before {
    content: "\\f1ad"
}

.dss-icon-cloud:before {
    content: "\\f1ae"
}

.dss-icon-cloudy:before {
    content: "\\f1af"
}

.dss-icon-code-window:before {
    content: "\\f1b0"
}

.dss-icon-collapse-keyboard:before {
    content: "\\f1b1"
}

.dss-icon-commerce:before {
    content: "\\f1b2"
}

.dss-icon-commodities:before {
    content: "\\f1b3"
}

.dss-icon-communication-announcement:before {
    content: "\\f1b4"
}

.dss-icon-communication-message:before {
    content: "\\f1b5"
}

.dss-icon-company-radar:before {
    content: "\\f1b6"
}

.dss-icon-confirming-advances-dollar:before {
    content: "\\f1b7"
}

.dss-icon-confirming-advances-euro:before {
    content: "\\f1b8"
}

.dss-icon-confirming-advances-pound:before {
    content: "\\f1b9"
}

.dss-icon-contacless:before {
    content: "\\f1ba"
}

.dss-icon-contacts:before {
    content: "\\f1bb"
}

.dss-icon-control:before {
    content: "\\f1bc"
}

.dss-icon-coordinates-card:before {
    content: "\\f1bd"
}

.dss-icon-copy:before {
    content: "\\f1be"
}

.dss-icon-correct:before {
    content: "\\f1bf"
}

.dss-icon-countryside:before {
    content: "\\f1c0"
}

.dss-icon-credit:before {
    content: "\\f1c1"
}

.dss-icon-cvv-number:before {
    content: "\\f1c2"
}

.dss-icon-daily:before {
    content: "\\f1c3"
}

.dss-icon-day-time-change:before {
    content: "\\f1c4"
}

.dss-icon-deal-handshake:before {
    content: "\\f1c5"
}

.dss-icon-dealership:before {
    content: "\\f1c6"
}

.dss-icon-death:before {
    content: "\\f1c7"
}

.dss-icon-debt:before {
    content: "\\f1c8"
}

.dss-icon-deferred-transfer:before {
    content: "\\f1c9"
}

.dss-icon-definition-of-done:before {
    content: "\\f1ca"
}

.dss-icon-definition-of-ready:before {
    content: "\\f1cb"
}

.dss-icon-delete-account:before {
    content: "\\f1cc"
}

.dss-icon-delivery:before {
    content: "\\f1cd"
}

.dss-icon-deposit-check:before {
    content: "\\f1ce"
}

.dss-icon-deposits:before {
    content: "\\f1cf"
}

.dss-icon-desktop:before {
    content: "\\f1d0"
}

.dss-icon-diamond:before {
    content: "\\f1d1"
}

.dss-icon-dice:before {
    content: "\\f1d2"
}

.dss-icon-digital-channels:before {
    content: "\\f1d3"
}

.dss-icon-digital-subscriptions-cards:before {
    content: "\\f1d4"
}

.dss-icon-digital-subscriptions-contactless:before {
    content: "\\f1d5"
}

.dss-icon-digital-subscriptions:before {
    content: "\\f1d6"
}

.dss-icon-direct-money:before {
    content: "\\f1d7"
}

.dss-icon-dirty:before {
    content: "\\f1d8"
}

.dss-icon-discount-card:before {
    content: "\\f1d9"
}

.dss-icon-discount:before {
    content: "\\f1da"
}

.dss-icon-dna:before {
    content: "\\f1db"
}

.dss-icon-doctor:before {
    content: "\\f1dc"
}

.dss-icon-document-bdr:before {
    content: "\\f1dd"
}

.dss-icon-document-cv:before {
    content: "\\f1de"
}

.dss-icon-document-doc:before {
    content: "\\f1df"
}

.dss-icon-document-etf:before {
    content: "\\f1e0"
}

.dss-icon-document-pdf:before {
    content: "\\f1e1"
}

.dss-icon-document-png:before {
    content: "\\f1e2"
}

.dss-icon-document-ppt:before {
    content: "\\f1e3"
}

.dss-icon-document-sketch:before {
    content: "\\f1e4"
}

.dss-icon-document-svg:before {
    content: "\\f1e5"
}

.dss-icon-document-txt:before {
    content: "\\f1e6"
}

.dss-icon-document-xls:before {
    content: "\\f1e7"
}

.dss-icon-document:before {
    content: "\\f1e8"
}

.dss-icon-dollar-bill:before {
    content: "\\f1e9"
}

.dss-icon-dollar-symbol:before {
    content: "\\f1ea"
}

.dss-icon-domestic-service:before {
    content: "\\f1eb"
}

.dss-icon-double-tap:before {
    content: "\\f1ec"
}

.dss-icon-download-from-cloud:before {
    content: "\\f1ed"
}

.dss-icon-download:before {
    content: "\\f1ee"
}

.dss-icon-dragndrop:before {
    content: "\\f1ef"
}

.dss-icon-duplicated-receipt:before {
    content: "\\f1f0"
}

.dss-icon-dynamics:before {
    content: "\\f1f1"
}

.dss-icon-e_:before {
    content: "\\f1f2"
}

.dss-icon-e-card:before {
    content: "\\f1f3"
}

.dss-icon-e-cash:before {
    content: "\\f1f4"
}

.dss-icon-edit-transfer:before {
    content: "\\f1f5"
}

.dss-icon-edit:before {
    content: "\\f1f6"
}

.dss-icon-electric-bike:before {
    content: "\\f1f7"
}

.dss-icon-electric-car:before {
    content: "\\f1f8"
}

.dss-icon-email-invoice-dollar:before {
    content: "\\f1f9"
}

.dss-icon-email-invoice-euro:before {
    content: "\\f1fa"
}

.dss-icon-email-invoice-pound:before {
    content: "\\f1fb"
}

.dss-icon-email:before {
    content: "\\f1fc"
}

.dss-icon-emoji-angry:before {
    content: "\\f1fd"
}

.dss-icon-emoji-happy:before {
    content: "\\f1fe"
}

.dss-icon-emoji-kiss:before {
    content: "\\f1ff"
}

.dss-icon-emoji-neutral:before {
    content: "\\f200"
}

.dss-icon-emoji-reised-eyebrow:before {
    content: "\\f201"
}

.dss-icon-emoji-sad:before {
    content: "\\f202"
}

.dss-icon-employees:before {
    content: "\\f203"
}

.dss-icon-energy:before {
    content: "\\f204"
}

.dss-icon-enter-fullscreen:before {
    content: "\\f205"
}

.dss-icon-enter-money-atm:before {
    content: "\\f206"
}

.dss-icon-enter-pin:before {
    content: "\\f207"
}

.dss-icon-entertainment-leisure:before {
    content: "\\f208"
}

.dss-icon-entrepreneurship:before {
    content: "\\f209"
}

.dss-icon-eolic-energy:before {
    content: "\\f20a"
}

.dss-icon-epic:before {
    content: "\\f20b"
}

.dss-icon-error-400-500:before {
    content: "\\f20c"
}

.dss-icon-error:before {
    content: "\\f20d"
}

.dss-icon-estimation:before {
    content: "\\f20e"
}

.dss-icon-euro-bill-note:before {
    content: "\\f20f"
}

.dss-icon-euro-symbol:before {
    content: "\\f210"
}

.dss-icon-exhange:before {
    content: "\\f211"
}

.dss-icon-exit-fullscreen:before {
    content: "\\f212"
}

.dss-icon-face-id-apple:before {
    content: "\\f213"
}

.dss-icon-face-id:before {
    content: "\\f214"
}

.dss-icon-facebook-outline:before {
    content: "\\f215"
}

.dss-icon-facebook:before {
    content: "\\f216"
}

.dss-icon-factoring-dollar:before {
    content: "\\f217"
}

.dss-icon-factoring-euro:before {
    content: "\\f218"
}

.dss-icon-factoring-pound:before {
    content: "\\f219"
}

.dss-icon-factoring:before {
    content: "\\f21a"
}

.dss-icon-factory:before {
    content: "\\f21b"
}

.dss-icon-family:before {
    content: "\\f21c"
}

.dss-icon-faq:before {
    content: "\\f21d"
}

.dss-icon-fashion:before {
    content: "\\f21e"
}

.dss-icon-fatca:before {
    content: "\\f21f"
}

.dss-icon-featured:before {
    content: "\\f220"
}

.dss-icon-file-transfer:before {
    content: "\\f221"
}

.dss-icon-file:before {
    content: "\\f222"
}

.dss-icon-filter-deactivate:before {
    content: "\\f223"
}

.dss-icon-filter:before {
    content: "\\f224"
}

.dss-icon-finance-purchase-dollar:before {
    content: "\\f225"
}

.dss-icon-finance-purchase-euro:before {
    content: "\\f226"
}

.dss-icon-finance-purchase-pound:before {
    content: "\\f227"
}

.dss-icon-financial-indicator:before {
    content: "\\f228"
}

.dss-icon-financial-manager:before {
    content: "\\f229"
}

.dss-icon-financing:before {
    content: "\\f22a"
}

.dss-icon-finger:before {
    content: "\\f22b"
}

.dss-icon-fire:before {
    content: "\\f22c"
}

.dss-icon-firewall:before {
    content: "\\f22d"
}

.dss-icon-fishermen:before {
    content: "\\f22e"
}

.dss-icon-fixed-expenses:before {
    content: "\\f22f"
}

.dss-icon-flag:before {
    content: "\\f230"
}

.dss-icon-fog:before {
    content: "\\f231"
}

.dss-icon-folder:before {
    content: "\\f232"
}

.dss-icon-font-adjust:before {
    content: "\\f233"
}

.dss-icon-font-size-decrease:before {
    content: "\\f234"
}

.dss-icon-font-size-increase:before {
    content: "\\f235"
}

.dss-icon-foreign-trade:before {
    content: "\\f236"
}

.dss-icon-fragile:before {
    content: "\\f237"
}

.dss-icon-franchise:before {
    content: "\\f238"
}

.dss-icon-fraud:before {
    content: "\\f239"
}

.dss-icon-free-wi-fi:before {
    content: "\\f23a"
}

.dss-icon-full-screen-2:before {
    content: "\\f23b"
}

.dss-icon-full-screen-exit:before {
    content: "\\f23c"
}

.dss-icon-full-screen:before {
    content: "\\f23d"
}

.dss-icon-furniture:before {
    content: "\\f23e"
}

.dss-icon-gale:before {
    content: "\\f23f"
}

.dss-icon-gas-station:before {
    content: "\\f240"
}

.dss-icon-get-money-atm-code:before {
    content: "\\f241"
}

.dss-icon-get-pin-number:before {
    content: "\\f242"
}

.dss-icon-get-your-key:before {
    content: "\\f243"
}

.dss-icon-ghost:before {
    content: "\\f244"
}

.dss-icon-gift-card:before {
    content: "\\f245"
}

.dss-icon-gift-ticket:before {
    content: "\\f246"
}

.dss-icon-gift:before {
    content: "\\f247"
}

.dss-icon-gold:before {
    content: "\\f248"
}

.dss-icon-golf:before {
    content: "\\f249"
}

.dss-icon-google-play-outline:before {
    content: "\\f24a"
}

.dss-icon-hair-stylist:before {
    content: "\\f24b"
}

.dss-icon-hammer:before {
    content: "\\f24c"
}

.dss-icon-handqr:before {
    content: "\\f24d"
}

.dss-icon-health-check:before {
    content: "\\f24e"
}

.dss-icon-health-insurance:before {
    content: "\\f24f"
}

.dss-icon-heart:before {
    content: "\\f250"
}

.dss-icon-help-in-a-circle:before {
    content: "\\f251"
}

.dss-icon-help-us-to-improve:before {
    content: "\\f252"
}

.dss-icon-help:before {
    content: "\\f253"
}

.dss-icon-hi-contrast:before {
    content: "\\f254"
}

.dss-icon-highlighted-services:before {
    content: "\\f255"
}

.dss-icon-highway:before {
    content: "\\f256"
}

.dss-icon-history:before {
    content: "\\f257"
}

.dss-icon-home:before {
    content: "\\f258"
}

.dss-icon-hospital:before {
    content: "\\f259"
}

.dss-icon-housing:before {
    content: "\\f25a"
}

.dss-icon-id-card:before {
    content: "\\f25b"
}

.dss-icon-idea:before {
    content: "\\f25c"
}

.dss-icon-image-unavailable:before {
    content: "\\f25d"
}

.dss-icon-image:before {
    content: "\\f25e"
}

.dss-icon-inbox:before {
    content: "\\f25f"
}

.dss-icon-income-expenses:before {
    content: "\\f260"
}

.dss-icon-income-tax:before {
    content: "\\f261"
}

.dss-icon-income-taxes:before {
    content: "\\f262"
}

.dss-icon-incomplete:before {
    content: "\\f263"
}

.dss-icon-increase2:before {
    content: "\\f264"
}

.dss-icon-industry-workers:before {
    content: "\\f265"
}

.dss-icon-information-in-a-circle:before {
    content: "\\f266"
}

.dss-icon-input:before {
    content: "\\f267"
}

.dss-icon-inspection:before {
    content: "\\f268"
}

.dss-icon-instagram-outline:before {
    content: "\\f269"
}

.dss-icon-instagram:before {
    content: "\\f26a"
}

.dss-icon-insurance:before {
    content: "\\f26b"
}

.dss-icon-international-financing:before {
    content: "\\f26c"
}

.dss-icon-international:before {
    content: "\\f26d"
}

.dss-icon-investment-small-caps:before {
    content: "\\f26e"
}

.dss-icon-investment-team:before {
    content: "\\f26f"
}

.dss-icon-investment:before {
    content: "\\f270"
}

.dss-icon-keep-your-distance:before {
    content: "\\f271"
}

.dss-icon-key:before {
    content: "\\f272"
}

.dss-icon-king:before {
    content: "\\f273"
}

.dss-icon-lake:before {
    content: "\\f274"
}

.dss-icon-lamp:before {
    content: "\\f275"
}

.dss-icon-language:before {
    content: "\\f276"
}

.dss-icon-laptop:before {
    content: "\\f277"
}

.dss-icon-legal-document:before {
    content: "\\f278"
}

.dss-icon-levy-received-dollar:before {
    content: "\\f279"
}

.dss-icon-levy-received-euro:before {
    content: "\\f27a"
}

.dss-icon-levy-received-pound:before {
    content: "\\f27b"
}

.dss-icon-levy-sent-dollar:before {
    content: "\\f27c"
}

.dss-icon-levy-sent-euro:before {
    content: "\\f27d"
}

.dss-icon-levy-sent-pound:before {
    content: "\\f27e"
}

.dss-icon-life-saver:before {
    content: "\\f27f"
}

.dss-icon-life-show:before {
    content: "\\f280"
}

.dss-icon-lightening:before {
    content: "\\f281"
}

.dss-icon-lighthouse:before {
    content: "\\f282"
}

.dss-icon-link:before {
    content: "\\f283"
}

.dss-icon-linkedin-outline:before {
    content: "\\f284"
}

.dss-icon-linkedin:before {
    content: "\\f285"
}

.dss-icon-liquidation:before {
    content: "\\f286"
}

.dss-icon-list:before {
    content: "\\f287"
}

.dss-icon-local-commerce:before {
    content: "\\f288"
}

.dss-icon-location-active:before {
    content: "\\f289"
}

.dss-icon-location:before {
    content: "\\f28a"
}

.dss-icon-lockout:before {
    content: "\\f28b"
}

.dss-icon-loyalty-card:before {
    content: "\\f28c"
}

.dss-icon-luggage:before {
    content: "\\f28d"
}

.dss-icon-magnet:before {
    content: "\\f28e"
}

.dss-icon-maintenance:before {
    content: "\\f28f"
}

.dss-icon-management-health:before {
    content: "\\f290"
}

.dss-icon-management:before {
    content: "\\f291"
}

.dss-icon-marternity:before {
    content: "\\f292"
}

.dss-icon-maternity:before {
    content: "\\f293"
}

.dss-icon-medal:before {
    content: "\\f294"
}

.dss-icon-medium-long-term-financing:before {
    content: "\\f295"
}

.dss-icon-mic-off:before {
    content: "\\f296"
}

.dss-icon-mic-on:before {
    content: "\\f297"
}

.dss-icon-mic:before {
    content: "\\f298"
}

.dss-icon-minimise-1px:before {
    content: "\\f299"
}

.dss-icon-minimise:before {
    content: "\\f29a"
}

.dss-icon-minus-in-a-circle:before {
    content: "\\f29b"
}

.dss-icon-miscellaneous:before {
    content: "\\f29c"
}

.dss-icon-mobile-chart:before {
    content: "\\f29d"
}

.dss-icon-mobile-landscape:before {
    content: "\\f29e"
}

.dss-icon-mobile-message:before {
    content: "\\f29f"
}

.dss-icon-mobile-payment:before {
    content: "\\f2a0"
}

.dss-icon-mobile-top-up:before {
    content: "\\f2a1"
}

.dss-icon-mobile:before {
    content: "\\f2a2"
}

.dss-icon-modify-liquidation-method:before {
    content: "\\f2a3"
}

.dss-icon-money-cash-dollar:before {
    content: "\\f2a4"
}

.dss-icon-money-cash-euro:before {
    content: "\\f2a5"
}

.dss-icon-money-cash-pound:before {
    content: "\\f2a6"
}

.dss-icon-moon-clouds:before {
    content: "\\f2a7"
}

.dss-icon-moon:before {
    content: "\\f2a8"
}

.dss-icon-more-in-a-circle:before {
    content: "\\f2a9"
}

.dss-icon-mortgage:before {
    content: "\\f2aa"
}

.dss-icon-mortgages-dollar:before {
    content: "\\f2ab"
}

.dss-icon-mortgages-euro:before {
    content: "\\f2ac"
}

.dss-icon-mortgages-pound:before {
    content: "\\f2ad"
}

.dss-icon-motor-sports:before {
    content: "\\f2ae"
}

.dss-icon-motorbike:before {
    content: "\\f2af"
}

.dss-icon-mountains:before {
    content: "\\f2b0"
}

.dss-icon-mouse:before {
    content: "\\f2b1"
}

.dss-icon-museum:before {
    content: "\\f2b2"
}

.dss-icon-music:before {
    content: "\\f2b3"
}

.dss-icon-nail:before {
    content: "\\f2b4"
}

.dss-icon-network-share:before {
    content: "\\f2b5"
}

.dss-icon-new-account:before {
    content: "\\f2b6"
}

.dss-icon-newspaper:before {
    content: "\\f2b7"
}

.dss-icon-nfc-bracelet:before {
    content: "\\f2b8"
}

.dss-icon-nfc-sticker:before {
    content: "\\f2b9"
}

.dss-icon-nfc:before {
    content: "\\f2ba"
}

.dss-icon-no-messages:before {
    content: "\\f2bb"
}

.dss-icon-no-transactions:before {
    content: "\\f2bc"
}

.dss-icon-non-supported-browser:before {
    content: "\\f2bd"
}

.dss-icon-now-logo:before {
    content: "\\f2be"
}

.dss-icon-now:before {
    content: "\\f2bf"
}

.dss-icon-nut:before {
    content: "\\f2c0"
}

.dss-icon-nutritional:before {
    content: "\\f2c1"
}

.dss-icon-offer-discount:before {
    content: "\\f2c2"
}

.dss-icon-office-workers:before {
    content: "\\f2c3"
}

.dss-icon-old-version:before {
    content: "\\f2c4"
}

.dss-icon-one-time-payment-dollar:before {
    content: "\\f2c5"
}

.dss-icon-one-time-payment-euro:before {
    content: "\\f2c6"
}

.dss-icon-one-time-payment-pound:before {
    content: "\\f2c7"
}

.dss-icon-online-banking:before {
    content: "\\f2c8"
}

.dss-icon-online-trading:before {
    content: "\\f2c9"
}

.dss-icon-online-value-dollar:before {
    content: "\\f2ca"
}

.dss-icon-online-value-euro:before {
    content: "\\f2cb"
}

.dss-icon-online-value-pound:before {
    content: "\\f2cc"
}

.dss-icon-operability-level:before {
    content: "\\f2cd"
}

.dss-icon-operate-without-card:before {
    content: "\\f2ce"
}

.dss-icon-orthdontics:before {
    content: "\\f2cf"
}

.dss-icon-other-expenses:before {
    content: "\\f2d0"
}

.dss-icon-others:before {
    content: "\\f2d1"
}

.dss-icon-owl:before {
    content: "\\f2d2"
}

.dss-icon-pacman:before {
    content: "\\f2d3"
}

.dss-icon-party:before {
    content: "\\f2d4"
}

.dss-icon-passport:before {
    content: "\\f2d5"
}

.dss-icon-password-typing:before {
    content: "\\f2d6"
}

.dss-icon-payment-dollar:before {
    content: "\\f2d7"
}

.dss-icon-payment-euro:before {
    content: "\\f2d8"
}

.dss-icon-payment-in-progress-dollar:before {
    content: "\\f2d9"
}

.dss-icon-payment-in-progress-euro:before {
    content: "\\f2da"
}

.dss-icon-payment-in-progress-pound:before {
    content: "\\f2db"
}

.dss-icon-payment-pound:before {
    content: "\\f2dc"
}

.dss-icon-paysheet-dollar:before {
    content: "\\f2dd"
}

.dss-icon-paysheet-euro:before {
    content: "\\f2de"
}

.dss-icon-paysheet-pound:before {
    content: "\\f2df"
}

.dss-icon-percent:before {
    content: "\\f2e0"
}

.dss-icon-periodic-transfer:before {
    content: "\\f2e1"
}

.dss-icon-periodical-input:before {
    content: "\\f2e2"
}

.dss-icon-personal-manager:before {
    content: "\\f2e3"
}

.dss-icon-petrol-tower:before {
    content: "\\f2e4"
}

.dss-icon-petty-cash:before {
    content: "\\f2e5"
}

.dss-icon-phising:before {
    content: "\\f2e6"
}

.dss-icon-phone-24h:before {
    content: "\\f2e7"
}

.dss-icon-phone-call:before {
    content: "\\f2e8"
}

.dss-icon-phone-support:before {
    content: "\\f2e9"
}

.dss-icon-phone:before {
    content: "\\f2ea"
}

.dss-icon-pill:before {
    content: "\\f2eb"
}

.dss-icon-pin:before {
    content: "\\f2ec"
}

.dss-icon-pinch:before {
    content: "\\f2ed"
}

.dss-icon-pix:before {
    content: "\\f2ee"
}

.dss-icon-pizza-chart:before {
    content: "\\f2ef"
}

.dss-icon-place:before {
    content: "\\f2f0"
}

.dss-icon-placeholder:before {
    content: "\\f2f1"
}

.dss-icon-plane:before {
    content: "\\f2f2"
}

.dss-icon-play-button:before {
    content: "\\f2f3"
}

.dss-icon-plug:before {
    content: "\\f2f4"
}

.dss-icon-plusless:before {
    content: "\\f2f5"
}

.dss-icon-podcast-outline:before {
    content: "\\f2f6"
}

.dss-icon-popup:before {
    content: "\\f2f7"
}

.dss-icon-portability:before {
    content: "\\f2f8"
}

.dss-icon-portfolio-of-values:before {
    content: "\\f2f9"
}

.dss-icon-position:before {
    content: "\\f2fa"
}

.dss-icon-pound-note:before {
    content: "\\f2fb"
}

.dss-icon-pound-symbol:before {
    content: "\\f2fc"
}

.dss-icon-power:before {
    content: "\\f2fd"
}

.dss-icon-price:before {
    content: "\\f2fe"
}

.dss-icon-print:before {
    content: "\\f2ff"
}

.dss-icon-product-delivery:before {
    content: "\\f300"
}

.dss-icon-productowner:before {
    content: "\\f301"
}

.dss-icon-public-transportation:before {
    content: "\\f302"
}

.dss-icon-puzzle:before {
    content: "\\f303"
}

.dss-icon-qr-advanced:before {
    content: "\\f304"
}

.dss-icon-qr-code:before {
    content: "\\f305"
}

.dss-icon-queries:before {
    content: "\\f306"
}

.dss-icon-quick-appointment:before {
    content: "\\f307"
}

.dss-icon-quotations:before {
    content: "\\f308"
}

.dss-icon-rackets-sports:before {
    content: "\\f309"
}

.dss-icon-radar:before {
    content: "\\f30a"
}

.dss-icon-radio-button:before {
    content: "\\f30b"
}

.dss-icon-radio:before {
    content: "\\f30c"
}

.dss-icon-rain-shower:before {
    content: "\\f30d"
}

.dss-icon-rain:before {
    content: "\\f30e"
}

.dss-icon-realestatecredit:before {
    content: "\\f30f"
}

.dss-icon-realestatevalue:before {
    content: "\\f310"
}

.dss-icon-receipt-bills:before {
    content: "\\f311"
}

.dss-icon-receipt-management:before {
    content: "\\f312"
}

.dss-icon-receive:before {
    content: "\\f313"
}

.dss-icon-recover-access-keys:before {
    content: "\\f314"
}

.dss-icon-recurrent-payment-dollar:before {
    content: "\\f315"
}

.dss-icon-recurrent-payment-euro:before {
    content: "\\f316"
}

.dss-icon-recurrent-payment-pound:before {
    content: "\\f317"
}

.dss-icon-recycling:before {
    content: "\\f318"
}

.dss-icon-redemption-dollar:before {
    content: "\\f319"
}

.dss-icon-redemption-euro:before {
    content: "\\f31a"
}

.dss-icon-redemption-pound:before {
    content: "\\f31b"
}

.dss-icon-refer-a-friend:before {
    content: "\\f31c"
}

.dss-icon-refinement:before {
    content: "\\f31d"
}

.dss-icon-reform:before {
    content: "\\f31e"
}

.dss-icon-reforms-decorations:before {
    content: "\\f31f"
}

.dss-icon-refresh-reload-screen:before {
    content: "\\f320"
}

.dss-icon-rejected-receipts:before {
    content: "\\f321"
}

.dss-icon-reload:before {
    content: "\\f322"
}

.dss-icon-remittances-dollar:before {
    content: "\\f323"
}

.dss-icon-remittances-euro:before {
    content: "\\f324"
}

.dss-icon-remittances-pound:before {
    content: "\\f325"
}

.dss-icon-renegotiate:before {
    content: "\\f326"
}

.dss-icon-renegotiation:before {
    content: "\\f327"
}

.dss-icon-renovation:before {
    content: "\\f328"
}

.dss-icon-renting-car:before {
    content: "\\f329"
}

.dss-icon-renting-home:before {
    content: "\\f32a"
}

.dss-icon-reports:before {
    content: "\\f32b"
}

.dss-icon-request-appointment:before {
    content: "\\f32c"
}

.dss-icon-restaurant-bar:before {
    content: "\\f32d"
}

.dss-icon-retail:before {
    content: "\\f32e"
}

.dss-icon-retirement-plan-elderly:before {
    content: "\\f32f"
}

.dss-icon-retrospective:before {
    content: "\\f330"
}

.dss-icon-return-receipt:before {
    content: "\\f331"
}

.dss-icon-return:before {
    content: "\\f332"
}

.dss-icon-ribbon:before {
    content: "\\f333"
}

.dss-icon-santander-plus:before {
    content: "\\f334"
}

.dss-icon-santander:before {
    content: "\\f335"
}

.dss-icon-saving-account-dollar:before {
    content: "\\f336"
}

.dss-icon-saving-account-euro:before {
    content: "\\f337"
}

.dss-icon-saving-account-pound:before {
    content: "\\f338"
}

.dss-icon-saving-investment:before {
    content: "\\f339"
}

.dss-icon-savings:before {
    content: "\\f33a"
}

.dss-icon-scales:before {
    content: "\\f33b"
}

.dss-icon-scanner:before {
    content: "\\f33c"
}

.dss-icon-schedule-payment-dollar:before {
    content: "\\f33d"
}

.dss-icon-schedule-payment-euro:before {
    content: "\\f33e"
}

.dss-icon-schedule-payment-pound:before {
    content: "\\f33f"
}

.dss-icon-schedule-spending-dollar:before {
    content: "\\f340"
}

.dss-icon-schedule-spending-euro:before {
    content: "\\f341"
}

.dss-icon-schedule-spending-pound:before {
    content: "\\f342"
}

.dss-icon-screwdriver:before {
    content: "\\f343"
}

.dss-icon-scroll:before {
    content: "\\f344"
}

.dss-icon-scrum-master:before {
    content: "\\f345"
}

.dss-icon-scrum:before {
    content: "\\f346"
}

.dss-icon-seafood:before {
    content: "\\f347"
}

.dss-icon-search:before {
    content: "\\f348"
}

.dss-icon-security-advice:before {
    content: "\\f349"
}

.dss-icon-security-block:before {
    content: "\\f34a"
}

.dss-icon-security-close:before {
    content: "\\f34b"
}

.dss-icon-security-configuration:before {
    content: "\\f34c"
}

.dss-icon-security-error:before {
    content: "\\f34d"
}

.dss-icon-security-open:before {
    content: "\\f34e"
}

.dss-icon-security-verified:before {
    content: "\\f34f"
}

.dss-icon-security:before {
    content: "\\f350"
}

.dss-icon-securize-payment:before {
    content: "\\f351"
}

.dss-icon-selfie:before {
    content: "\\f352"
}

.dss-icon-send:before {
    content: "\\f353"
}

.dss-icon-sepa-transfers:before {
    content: "\\f354"
}

.dss-icon-settings:before {
    content: "\\f355"
}

.dss-icon-share:before {
    content: "\\f356"
}

.dss-icon-shareholders:before {
    content: "\\f357"
}

.dss-icon-short-term-financing:before {
    content: "\\f358"
}

.dss-icon-shower:before {
    content: "\\f359"
}

.dss-icon-shuffle:before {
    content: "\\f35a"
}

.dss-icon-sign-in:before {
    content: "\\f35b"
}

.dss-icon-sign-language:before {
    content: "\\f35c"
}

.dss-icon-sign-off:before {
    content: "\\f35d"
}

.dss-icon-sign-up:before {
    content: "\\f35e"
}

.dss-icon-signature-pending:before {
    content: "\\f35f"
}

.dss-icon-sim-chip-insert:before {
    content: "\\f360"
}

.dss-icon-sim-chip:before {
    content: "\\f361"
}

.dss-icon-sinister-car:before {
    content: "\\f362"
}

.dss-icon-sitemap:before {
    content: "\\f363"
}

.dss-icon-sky:before {
    content: "\\f364"
}

.dss-icon-smartwatch-payment:before {
    content: "\\f365"
}

.dss-icon-smartwatch:before {
    content: "\\f366"
}

.dss-icon-snow:before {
    content: "\\f367"
}

.dss-icon-snowflake:before {
    content: "\\f368"
}

.dss-icon-soccer:before {
    content: "\\f369"
}

.dss-icon-solar-energy:before {
    content: "\\f36a"
}

.dss-icon-solidarity-rounding:before {
    content: "\\f36b"
}

.dss-icon-sound-wave:before {
    content: "\\f36c"
}

.dss-icon-spa:before {
    content: "\\f36d"
}

.dss-icon-speeches:before {
    content: "\\f36e"
}

.dss-icon-sports-risk:before {
    content: "\\f36f"
}

.dss-icon-sports:before {
    content: "\\f370"
}

.dss-icon-sprint-review:before {
    content: "\\f371"
}

.dss-icon-sprint:before {
    content: "\\f372"
}

.dss-icon-sprintplaning:before {
    content: "\\f373"
}

.dss-icon-stack:before {
    content: "\\f374"
}

.dss-icon-star:before {
    content: "\\f375"
}

.dss-icon-statements-dollar:before {
    content: "\\f376"
}

.dss-icon-statements-euro:before {
    content: "\\f377"
}

.dss-icon-statements-pound:before {
    content: "\\f378"
}

.dss-icon-stay-home:before {
    content: "\\f379"
}

.dss-icon-steps:before {
    content: "\\f37a"
}

.dss-icon-stock-exchange:before {
    content: "\\f37b"
}

.dss-icon-strategy:before {
    content: "\\f37c"
}

.dss-icon-student:before {
    content: "\\f37d"
}

.dss-icon-subscription-model:before {
    content: "\\f37e"
}

.dss-icon-subscription:before {
    content: "\\f37f"
}

.dss-icon-subway:before {
    content: "\\f380"
}

.dss-icon-success:before {
    content: "\\f381"
}

.dss-icon-sun-cloud:before {
    content: "\\f382"
}

.dss-icon-sunny:before {
    content: "\\f383"
}

.dss-icon-supermarket-cart:before {
    content: "\\f384"
}

.dss-icon-suppliers:before {
    content: "\\f385"
}

.dss-icon-sustainable-services:before {
    content: "\\f386"
}

.dss-icon-swift-cards:before {
    content: "\\f387"
}

.dss-icon-swipe-down:before {
    content: "\\f388"
}

.dss-icon-swipe-left:before {
    content: "\\f389"
}

.dss-icon-swipe-right:before {
    content: "\\f38a"
}

.dss-icon-swipe-up:before {
    content: "\\f38b"
}

.dss-icon-tailor:before {
    content: "\\f38c"
}

.dss-icon-tampon:before {
    content: "\\f38d"
}

.dss-icon-tap:before {
    content: "\\f38e"
}

.dss-icon-taxes:before {
    content: "\\f38f"
}

.dss-icon-team-interaction:before {
    content: "\\f390"
}

.dss-icon-team-managament:before {
    content: "\\f391"
}

.dss-icon-team-together:before {
    content: "\\f392"
}

.dss-icon-technological-renting:before {
    content: "\\f393"
}

.dss-icon-terminal-code:before {
    content: "\\f394"
}

.dss-icon-terms-conditions:before {
    content: "\\f395"
}

.dss-icon-ticket-movie:before {
    content: "\\f396"
}

.dss-icon-time:before {
    content: "\\f397"
}

.dss-icon-timeout:before {
    content: "\\f398"
}

.dss-icon-token-migration:before {
    content: "\\f399"
}

.dss-icon-token:before {
    content: "\\f39a"
}

.dss-icon-torch:before {
    content: "\\f39b"
}

.dss-icon-tow-truck:before {
    content: "\\f39c"
}

.dss-icon-trade-whatsapp:before {
    content: "\\f39d"
}

.dss-icon-trade:before {
    content: "\\f39e"
}

.dss-icon-train:before {
    content: "\\f39f"
}

.dss-icon-training:before {
    content: "\\f3a0"
}

.dss-icon-transfer:before {
    content: "\\f3a1"
}

.dss-icon-transitions:before {
    content: "\\f3a2"
}

.dss-icon-trash-bin:before {
    content: "\\f3a3"
}

.dss-icon-travel:before {
    content: "\\f3a4"
}

.dss-icon-trophy:before {
    content: "\\f3a5"
}

.dss-icon-truck:before {
    content: "\\f3a6"
}

.dss-icon-tutorial:before {
    content: "\\f3a7"
}

.dss-icon-tv:before {
    content: "\\f3a8"
}

.dss-icon-twitter-outline:before {
    content: "\\f3a9"
}

.dss-icon-twitter:before {
    content: "\\f3aa"
}

.dss-icon-two-double-tap:before {
    content: "\\f3ab"
}

.dss-icon-two-tap:before {
    content: "\\f3ac"
}

.dss-icon-unblock-card:before {
    content: "\\f3ad"
}

.dss-icon-unicorn:before {
    content: "\\f3ae"
}

.dss-icon-university:before {
    content: "\\f3af"
}

.dss-icon-update:before {
    content: "\\f3b0"
}

.dss-icon-upload-to-cloud:before {
    content: "\\f3b1"
}

.dss-icon-upload:before {
    content: "\\f3b2"
}

.dss-icon-urgent:before {
    content: "\\f3b3"
}

.dss-icon-userstory:before {
    content: "\\f3b4"
}

.dss-icon-utilities-services:before {
    content: "\\f3b5"
}

.dss-icon-value-decrease:before {
    content: "\\f3b6"
}

.dss-icon-value-increase:before {
    content: "\\f3b7"
}

.dss-icon-value:before {
    content: "\\f3b8"
}

.dss-icon-vegetarian-food:before {
    content: "\\f3b9"
}

.dss-icon-velocity:before {
    content: "\\f3ba"
}

.dss-icon-veterinary:before {
    content: "\\f3bb"
}

.dss-icon-videochat:before {
    content: "\\f3bc"
}

.dss-icon-videoconference:before {
    content: "\\f3bd"
}

.dss-icon-videogames-switch:before {
    content: "\\f3be"
}

.dss-icon-videogames:before {
    content: "\\f3bf"
}

.dss-icon-visibility-off:before {
    content: "\\f3c0"
}

.dss-icon-visibility-on:before {
    content: "\\f3c1"
}

.dss-icon-wait-outside-the-branch:before {
    content: "\\f3c2"
}

.dss-icon-wallet:before {
    content: "\\f3c3"
}

.dss-icon-warning-in-a-circle:before {
    content: "\\f3c4"
}

.dss-icon-warning:before {
    content: "\\f3c5"
}

.dss-icon-wash-your-hands:before {
    content: "\\f3c6"
}

.dss-icon-water-drop:before {
    content: "\\f3c7"
}

.dss-icon-wear-a-face-mask:before {
    content: "\\f3c8"
}

.dss-icon-webmotors:before {
    content: "\\f3c9"
}

.dss-icon-whatsapp-logo:before {
    content: "\\f3ca"
}

.dss-icon-whatsapp-outline:before {
    content: "\\f3cb"
}

.dss-icon-whatsapp:before {
    content: "\\f3cc"
}

.dss-icon-wheelchair-accessibility:before {
    content: "\\f3cd"
}

.dss-icon-wi-fi:before {
    content: "\\f3ce"
}

.dss-icon-window-success:before {
    content: "\\f3cf"
}

.dss-icon-withdraw-dollar:before {
    content: "\\f3d0"
}

.dss-icon-withdraw-e-cash:before {
    content: "\\f3d1"
}

.dss-icon-withdraw-euro:before {
    content: "\\f3d2"
}

.dss-icon-withdraw-money-atm:before {
    content: "\\f3d3"
}

.dss-icon-withdraw-pound:before {
    content: "\\f3d4"
}

.dss-icon-withdraw-receipt-atm:before {
    content: "\\f3d5"
}

.dss-icon-woman:before {
    content: "\\f3d6"
}

.dss-icon-yoga-relax:before {
    content: "\\f3d7"
}

.dss-icon-youtube-outline:before {
    content: "\\f3d8"
}

.dss-icon-youtube:before {
    content: "\\f3d9"
}

.dss-icon-zoom-in:before {
    content: "\\f3da"
}

.dss-icon-zoom-out:before {
    content: "\\f3db"
}

.dss-icon-star-filled:before {
    content: "\\f3dc"
}

.dss-icon-circle-attention-filled:before {
    content: "\\f3dd"
}

.dss-icon-circle-check-filled:before {
    content: "\\f3de"
}

.dss-icon-circle-close-filled:before {
    content: "\\f3df"
}

.dss-icon-circle-help-filled:before {
    content: "\\f3e0"
}

.dss-icon-circle-information-filled:before {
    content: "\\f3e1"
}

.dss-icon-urgent-filled:before {
    content: "\\f3e2"
}

.dss-icon-banking-checking-account-link:before {
    content: "\\f3e3"
}

.dss-icon-functional-manage-link:before {
    content: "\\f3e4"
}

.dss-icon-income-outcome-dollar:before {
    content: "\\f3e5"
}

.dss-icon-open-finance:before {
    content: "\\f3e6"
}

[class*=" dss-icon-"],[class^=dss-icon-] {
    font-size: 1.5rem
}

.dss-icon--small,.dss-icon--small:before {
    font-size: 1rem
}

.dss-icon--medium,.dss-icon--medium:before {
    font-size: 2rem
}

.dss-icon--large,.dss-icon--large:before {
    font-size: 2.5rem
}

.dss-icon--extra-large,.dss-icon--extra-large:before {
    font-size: 3rem
}

*,:after,:before {
    box-sizing: border-box;
    margin: 0;
    padding: 0
}

body {
    height: 100%;
    width: 100%
}

h1,h2,h3,h4,h5,h6 {
    font-weight: 400
}

a {
    background-color: transparent
}

b,strong {
    font-weight: bolder
}

img {
    border-style: none
}

input[type=text]::-ms-clear,input[type=text]::-ms-reveal {
    display: none;
    height: 0;
    width: 0
}

.dss-elevation-1 {
    border: 1px solid #ccc;
    box-shadow: 0 2px 8px -2px rgba(34,34,34,.4)
}

.dss-elevation-2 {
    border: 1px solid #ccc;
    box-shadow: 0 2px 16px -2px rgba(34,34,34,.4)
}

.dss-align-content-start {
    align-content: flex-start
}

.dss-align-content-end {
    align-content: flex-end
}

.dss-align-content-center {
    align-content: center
}

.dss-align-content-around {
    align-content: space-around
}

.dss-align-content-stretch {
    align-content: stretch
}

.dss-align-content-between {
    align-content: space-between
}

@media (min-width: 320px) {
    .dss-align-content-sm-start {
        align-content:flex-start
    }

    .dss-align-content-sm-end {
        align-content: flex-end
    }

    .dss-align-content-sm-center {
        align-content: center
    }

    .dss-align-content-sm-around {
        align-content: space-around
    }

    .dss-align-content-sm-stretch {
        align-content: stretch
    }

    .dss-align-content-sm-between {
        align-content: space-between
    }
}

@media (min-width: 768px) {
    .dss-align-content-md-start {
        align-content:flex-start
    }

    .dss-align-content-md-end {
        align-content: flex-end
    }

    .dss-align-content-md-center {
        align-content: center
    }

    .dss-align-content-md-around {
        align-content: space-around
    }

    .dss-align-content-md-stretch {
        align-content: stretch
    }

    .dss-align-content-md-between {
        align-content: space-between
    }
}

@media (min-width: 1920px) {
    .dss-align-content-lg-start {
        align-content:flex-start
    }

    .dss-align-content-lg-end {
        align-content: flex-end
    }

    .dss-align-content-lg-center {
        align-content: center
    }

    .dss-align-content-lg-around {
        align-content: space-around
    }

    .dss-align-content-lg-stretch {
        align-content: stretch
    }

    .dss-align-content-lg-between {
        align-content: space-between
    }
}

.dss-align-items-start {
    align-items: flex-start
}

.dss-align-items-end {
    align-items: flex-end
}

.dss-align-items-center {
    align-items: center
}

.dss-align-items-baseline {
    align-items: baseline
}

.dss-align-items-stretch {
    align-items: stretch
}

@media (min-width: 320px) {
    .dss-align-items-sm-start {
        align-items:flex-start
    }

    .dss-align-items-sm-end {
        align-items: flex-end
    }

    .dss-align-items-sm-center {
        align-items: center
    }

    .dss-align-items-sm-baseline {
        align-items: baseline
    }

    .dss-align-items-sm-stretch {
        align-items: stretch
    }
}

@media (min-width: 768px) {
    .dss-align-items-md-start {
        align-items:flex-start
    }

    .dss-align-items-md-end {
        align-items: flex-end
    }

    .dss-align-items-md-center {
        align-items: center
    }

    .dss-align-items-md-baseline {
        align-items: baseline
    }

    .dss-align-items-md-stretch {
        align-items: stretch
    }
}

@media (min-width: 1920px) {
    .dss-align-items-lg-start {
        align-items:flex-start
    }

    .dss-align-items-lg-end {
        align-items: flex-end
    }

    .dss-align-items-lg-center {
        align-items: center
    }

    .dss-align-items-lg-baseline {
        align-items: baseline
    }

    .dss-align-items-lg-stretch {
        align-items: stretch
    }
}

.dss-align-self-start {
    align-self: start
}

.dss-align-self-end {
    align-self: flex-end
}

.dss-align-self-center {
    align-self: center
}

.dss-align-self-baseline {
    align-self: baseline
}

.dss-align-self-stretch {
    align-self: stretch
}

@media (min-width: 320px) {
    .dss-align-self-sm-start {
        align-self:start
    }

    .dss-align-self-sm-end {
        align-self: flex-end
    }

    .dss-align-self-sm-center {
        align-self: center
    }

    .dss-align-self-sm-baseline {
        align-self: baseline
    }

    .dss-align-self-sm-stretch {
        align-self: stretch
    }
}

@media (min-width: 768px) {
    .dss-align-self-md-start {
        align-self:start
    }

    .dss-align-self-md-end {
        align-self: flex-end
    }

    .dss-align-self-md-center {
        align-self: center
    }

    .dss-align-self-md-baseline {
        align-self: baseline
    }

    .dss-align-self-md-stretch {
        align-self: stretch
    }
}

@media (min-width: 1920px) {
    .dss-align-self-lg-start {
        align-self:start
    }

    .dss-align-self-lg-end {
        align-self: flex-end
    }

    .dss-align-self-lg-center {
        align-self: center
    }

    .dss-align-self-lg-baseline {
        align-self: baseline
    }

    .dss-align-self-lg-stretch {
        align-self: stretch
    }
}

.dss-flex-row {
    flex-direction: row!important
}

.dss-flex-row,.dss-flex-row-reverse {
    -webkit-box-orient: horizontal!important
}

.dss-flex-row-reverse {
    flex-direction: row-reverse!important
}

.dss-flex-column {
    flex-direction: column!important
}

.dss-flex-column-reverse {
    flex-direction: column-reverse!important
}

@media (min-width: 320px) {
    .dss-flex-sm-row {
        flex-direction:row!important
    }

    .dss-flex-sm-row-reverse {
        flex-direction: row-reverse!important
    }

    .dss-flex-sm-column {
        flex-direction: column!important
    }

    .dss-flex-sm-column-reverse {
        flex-direction: column-reverse!important
    }
}

@media (min-width: 768px) {
    .dss-flex-md-row {
        flex-direction:row!important
    }

    .dss-flex-md-row-reverse {
        flex-direction: row-reverse!important
    }

    .dss-flex-md-column {
        flex-direction: column!important
    }

    .dss-flex-md-column-reverse {
        flex-direction: column-reverse!important
    }
}

@media (min-width: 1920px) {
    .dss-flex-lg-row {
        flex-direction:row!important
    }

    .dss-flex-lg-row-reverse {
        flex-direction: row-reverse!important
    }

    .dss-flex-lg-column {
        flex-direction: column!important
    }

    .dss-flex-lg-column-reverse {
        flex-direction: column-reverse!important
    }
}

.dss-justify-content-start {
    justify-content: flex-start
}

.dss-justify-content-end {
    justify-content: flex-end
}

.dss-justify-content-center {
    justify-content: center
}

.dss-justify-content-between {
    justify-content: space-between
}

.dss-justify-content-around {
    justify-content: space-around
}

.dss-justify-content-evenly {
    justify-content: space-evenly
}

@media (min-width: 320px) {
    .dss-justify-content-sm-start {
        justify-content:flex-start
    }

    .dss-justify-content-sm-end {
        justify-content: flex-end
    }

    .dss-justify-content-sm-center {
        justify-content: center
    }

    .dss-justify-content-sm-between {
        justify-content: space-between
    }

    .dss-justify-content-sm-around {
        justify-content: space-around
    }

    .dss-justify-content-sm-evenly {
        justify-content: space-evenly
    }
}

@media (min-width: 768px) {
    .dss-justify-content-md-start {
        justify-content:flex-start
    }

    .dss-justify-content-md-end {
        justify-content: flex-end
    }

    .dss-justify-content-md-center {
        justify-content: center
    }

    .dss-justify-content-md-between {
        justify-content: space-between
    }

    .dss-justify-content-md-around {
        justify-content: space-around
    }

    .dss-justify-content-md-evenly {
        justify-content: space-evenly
    }
}

@media (min-width: 1920px) {
    .dss-justify-content-lg-start {
        justify-content:flex-start
    }

    .dss-justify-content-lg-end {
        justify-content: flex-end
    }

    .dss-justify-content-lg-center {
        justify-content: center
    }

    .dss-justify-content-lg-between {
        justify-content: space-between
    }

    .dss-justify-content-lg-around {
        justify-content: space-around
    }

    .dss-justify-content-lg-evenly {
        justify-content: space-evenly
    }
}

.dss-order-0 {
    order: 0
}

.dss-order-1 {
    order: 1
}

.dss-order-2 {
    order: 2
}

.dss-order-3 {
    order: 3
}

.dss-order-4 {
    order: 4
}

.dss-order-5 {
    order: 5
}

.dss-order-6 {
    order: 6
}

.dss-order-7 {
    order: 7
}

.dss-order-8 {
    order: 8
}

.dss-order-9 {
    order: 9
}

.dss-order-10 {
    order: 10
}

.dss-order-11 {
    order: 11
}

.dss-order-12 {
    order: 12
}

@media (min-width: 320px) {
    .dss-order-sm-0 {
        order:0
    }

    .dss-order-sm-1 {
        order: 1
    }

    .dss-order-sm-2 {
        order: 2
    }

    .dss-order-sm-3 {
        order: 3
    }

    .dss-order-sm-4 {
        order: 4
    }

    .dss-order-sm-5 {
        order: 5
    }

    .dss-order-sm-6 {
        order: 6
    }

    .dss-order-sm-7 {
        order: 7
    }

    .dss-order-sm-8 {
        order: 8
    }

    .dss-order-sm-9 {
        order: 9
    }

    .dss-order-sm-10 {
        order: 10
    }

    .dss-order-sm-11 {
        order: 11
    }

    .dss-order-sm-12 {
        order: 12
    }
}

@media (min-width: 768px) {
    .dss-order-md-0 {
        order:0
    }

    .dss-order-md-1 {
        order: 1
    }

    .dss-order-md-2 {
        order: 2
    }

    .dss-order-md-3 {
        order: 3
    }

    .dss-order-md-4 {
        order: 4
    }

    .dss-order-md-5 {
        order: 5
    }

    .dss-order-md-6 {
        order: 6
    }

    .dss-order-md-7 {
        order: 7
    }

    .dss-order-md-8 {
        order: 8
    }

    .dss-order-md-9 {
        order: 9
    }

    .dss-order-md-10 {
        order: 10
    }

    .dss-order-md-11 {
        order: 11
    }

    .dss-order-md-12 {
        order: 12
    }
}

@media (min-width: 1920px) {
    .dss-order-lg-0 {
        order:0
    }

    .dss-order-lg-1 {
        order: 1
    }

    .dss-order-lg-2 {
        order: 2
    }

    .dss-order-lg-3 {
        order: 3
    }

    .dss-order-lg-4 {
        order: 4
    }

    .dss-order-lg-5 {
        order: 5
    }

    .dss-order-lg-6 {
        order: 6
    }

    .dss-order-lg-7 {
        order: 7
    }

    .dss-order-lg-8 {
        order: 8
    }

    .dss-order-lg-9 {
        order: 9
    }

    .dss-order-lg-10 {
        order: 10
    }

    .dss-order-lg-11 {
        order: 11
    }

    .dss-order-lg-12 {
        order: 12
    }
}

.dss-flex-nowrap {
    flex-wrap: nowrap
}

.dss-flex-wrap {
    flex-wrap: wrap
}

.dss-flex-wrap-reverse {
    flex-wrap: wrap-reverse
}

@media (min-width: 320px) {
    .dss-flex-sm-nowrap {
        flex-wrap:nowrap
    }

    .dss-flex-sm-wrap {
        flex-wrap: wrap
    }

    .dss-flex-sm-wrap-reverse {
        flex-wrap: wrap-reverse
    }
}

@media (min-width: 768px) {
    .dss-flex-md-nowrap {
        flex-wrap:nowrap
    }

    .dss-flex-md-wrap {
        flex-wrap: wrap
    }

    .dss-flex-md-wrap-reverse {
        flex-wrap: wrap-reverse
    }
}

@media (min-width: 1920px) {
    .dss-flex-lg-nowrap {
        flex-wrap:nowrap
    }

    .dss-flex-lg-wrap {
        flex-wrap: wrap
    }

    .dss-flex-lg-wrap-reverse {
        flex-wrap: wrap-reverse
    }
}

.dss-display-none {
    display: none!important
}

.dss-display-inline {
    display: inline!important
}

.dss-display-inline-block {
    display: inline-block!important
}

.dss-display-block {
    display: block!important
}

.dss-display-flex {
    display: flex!important
}

.dss-display-inline-flex {
    display: inline-flex!important
}

@media (min-width: 320px) {
    .dss-display-sm-none {
        display:none!important
    }

    .dss-display-sm-inline {
        display: inline!important
    }

    .dss-display-sm-inline-block {
        display: inline-block!important
    }

    .dss-display-sm-block {
        display: block!important
    }

    .dss-display-sm-flex {
        display: flex!important
    }

    .dss-display-sm-inline-flex {
        display: inline-flex!important
    }
}

@media (min-width: 768px) {
    .dss-display-md-none {
        display:none!important
    }

    .dss-display-md-inline {
        display: inline!important
    }

    .dss-display-md-inline-block {
        display: inline-block!important
    }

    .dss-display-md-block {
        display: block!important
    }

    .dss-display-md-flex {
        display: flex!important
    }

    .dss-display-md-inline-flex {
        display: inline-flex!important
    }
}

@media (min-width: 1920px) {
    .dss-display-lg-none {
        display:none!important
    }

    .dss-display-lg-inline {
        display: inline!important
    }

    .dss-display-lg-inline-block {
        display: inline-block!important
    }

    .dss-display-lg-block {
        display: block!important
    }

    .dss-display-lg-flex {
        display: flex!important
    }

    .dss-display-lg-inline-flex {
        display: inline-flex!important
    }
}

.dss-grid-container-fluid {
    display: block;
    width: 100%
}

.dss-grid-container-center {
    display: block;
    margin: 0 auto;
    max-width: 1024px;
    width: 100%
}

.dss-grid-container-left {
    display: block;
    margin: 0 auto 0 0;
    max-width: 1278px;
    width: 100%
}

.dss-grid {
    display: flex;
    flex-wrap: wrap
}

.dss-col,.dss-grid {
    padding-left: 8px;
    padding-right: 8px
}

.dss-col {
    flex-basis: 0;
    flex-grow: 1
}

.dss-col-1,.dss-col-10,.dss-col-11,.dss-col-12,.dss-col-2,.dss-col-3,.dss-col-4,.dss-col-5,.dss-col-6,.dss-col-7,.dss-col-8,.dss-col-9,.dss-col-fixed {
    flex: 0 0 auto;
    padding-left: 8px;
    padding-right: 8px
}

.dss-col-1 {
    width: 8.3333%
}

.dss-col-2 {
    width: 16.6667%
}

.dss-col-3 {
    width: 25%
}

.dss-col-4 {
    width: 33.3333%
}

.dss-col-5 {
    width: 41.6667%
}

.dss-col-6 {
    width: 50%
}

.dss-col-7 {
    width: 58.3333%
}

.dss-col-8 {
    width: 66.6667%
}

.dss-col-9 {
    width: 75%
}

.dss-col-10 {
    width: 83.3333%
}

.dss-col-11 {
    width: 91.6667%
}

.dss-col-12 {
    width: 100%
}

.dss-offset-12 {
    margin-left: 100%
}

.dss-offset-11 {
    margin-left: 91.66666667%
}

.dss-offset-10 {
    margin-left: 83.33333333%
}

.dss-offset-9 {
    margin-left: 75%
}

.dss-offset-8 {
    margin-left: 66.66666667%
}

.dss-offset-7 {
    margin-left: 58.33333333%
}

.dss-offset-6 {
    margin-left: 50%
}

.dss-offset-5 {
    margin-left: 41.66666667%
}

.dss-offset-4 {
    margin-left: 33.33333333%
}

.dss-offset-3 {
    margin-left: 25%
}

.dss-offset-2 {
    margin-left: 16.66666667%
}

.dss-offset-1 {
    margin-left: 8.33333333%
}

.dss-offset-0 {
    margin-left: 0
}

.dss-no-gutter {
    margin: 0!important;
    padding: 0!important
}

.dss-no-gutter-left {
    margin-left: 0!important;
    padding-left: 0!important
}

.dss-no-gutter-top {
    margin-top: 0!important;
    padding-top: 0!important
}

.dss-no-gutter-right {
    margin-right: 0!important;
    padding-right: 0!important
}

.dss-no-gutter-bottom {
    margin-bottom: 0!important;
    padding-bottom: 0!important
}

.dss-col-no-gutter {
    padding: 0!important
}

.dss-col-no-gutter-left {
    padding-left: 0!important
}

.dss-col-no-gutter-top {
    padding-top: 0!important
}

.dss-col-no-gutter-right {
    padding-right: 0!important
}

.dss-col-no-gutter-bottom {
    padding-bottom: 0!important
}

@media (min-width: 320px) {
    .dss-col-sm-1,.dss-col-sm-10,.dss-col-sm-11,.dss-col-sm-12,.dss-col-sm-2,.dss-col-sm-3,.dss-col-sm-4,.dss-col-sm-5,.dss-col-sm-6,.dss-col-sm-7,.dss-col-sm-8,.dss-col-sm-9 {
        flex:0 0 auto;
        padding-left: 8px;
        padding-right: 8px
    }

    .dss-col-sm-1 {
        width: 8.3333%
    }

    .dss-col-sm-2 {
        width: 16.6667%
    }

    .dss-col-sm-3 {
        width: 25%
    }

    .dss-col-sm-4 {
        width: 33.3333%
    }

    .dss-col-sm-5 {
        width: 41.6667%
    }

    .dss-col-sm-6 {
        width: 50%
    }

    .dss-col-sm-7 {
        width: 58.3333%
    }

    .dss-col-sm-8 {
        width: 66.6667%
    }

    .dss-col-sm-9 {
        width: 75%
    }

    .dss-col-sm-10 {
        width: 83.3333%
    }

    .dss-col-sm-11 {
        width: 91.6667%
    }

    .dss-col-sm-12 {
        width: 100%
    }

    .dss-sm-offset-12 {
        margin-left: 100%
    }

    .dss-sm-offset-11 {
        margin-left: 91.66666667%
    }

    .dss-sm-offset-10 {
        margin-left: 83.33333333%
    }

    .dss-sm-offset-9 {
        margin-left: 75%
    }

    .dss-sm-offset-8 {
        margin-left: 66.66666667%
    }

    .dss-sm-offset-7 {
        margin-left: 58.33333333%
    }

    .dss-sm-offset-6 {
        margin-left: 50%
    }

    .dss-sm-offset-5 {
        margin-left: 41.66666667%
    }

    .dss-sm-offset-4 {
        margin-left: 33.33333333%
    }

    .dss-sm-offset-3 {
        margin-left: 25%
    }

    .dss-sm-offset-2 {
        margin-left: 16.66666667%
    }

    .dss-sm-offset-1 {
        margin-left: 8.33333333%
    }

    .dss-sm-offset-0 {
        margin-left: 0
    }
}

@media (min-width: 768px) {
    .dss-col,.dss-col-1,.dss-col-10,.dss-col-11,.dss-col-12,.dss-col-2,.dss-col-3,.dss-col-4,.dss-col-5,.dss-col-6,.dss-col-7,.dss-col-8,.dss-col-9,.dss-col-fixed,.dss-grid {
        padding-left:12px;
        padding-right: 12px
    }

    .dss-col-md-1,.dss-col-md-10,.dss-col-md-11,.dss-col-md-12,.dss-col-md-2,.dss-col-md-3,.dss-col-md-4,.dss-col-md-5,.dss-col-md-6,.dss-col-md-7,.dss-col-md-8,.dss-col-md-9 {
        flex: 0 0 auto;
        padding-left: 12px;
        padding-right: 12px
    }

    .dss-col-md-1 {
        width: 8.3333%
    }

    .dss-col-md-2 {
        width: 16.6667%
    }

    .dss-col-md-3 {
        width: 25%
    }

    .dss-col-md-4 {
        width: 33.3333%
    }

    .dss-col-md-5 {
        width: 41.6667%
    }

    .dss-col-md-6 {
        width: 50%
    }

    .dss-col-md-7 {
        width: 58.3333%
    }

    .dss-col-md-8 {
        width: 66.6667%
    }

    .dss-col-md-9 {
        width: 75%
    }

    .dss-col-md-10 {
        width: 83.3333%
    }

    .dss-col-md-11 {
        width: 91.6667%
    }

    .dss-col-md-12 {
        width: 100%
    }

    .dss-col-md-offset-12 {
        margin-left: 100%
    }

    .dss-md-offset-11 {
        margin-left: 91.66666667%
    }

    .dss-md-offset-10 {
        margin-left: 83.33333333%
    }

    .dss-md-offset-9 {
        margin-left: 75%
    }

    .dss-md-offset-8 {
        margin-left: 66.66666667%
    }

    .dss-md-offset-7 {
        margin-left: 58.33333333%
    }

    .dss-md-offset-6 {
        margin-left: 50%
    }

    .dss-md-offset-5 {
        margin-left: 41.66666667%
    }

    .dss-md-offset-4 {
        margin-left: 33.33333333%
    }

    .dss-md-offset-3 {
        margin-left: 25%
    }

    .dss-md-offset-2 {
        margin-left: 16.66666667%
    }

    .dss-md-offset-1 {
        margin-left: 8.33333333%
    }

    .dss-md-offset-0 {
        margin-left: 0
    }
}

@media (min-width: 1920px) {
    .dss-col,.dss-col-1,.dss-col-10,.dss-col-11,.dss-col-12,.dss-col-2,.dss-col-3,.dss-col-4,.dss-col-5,.dss-col-6,.dss-col-7,.dss-col-8,.dss-col-9,.dss-col-fixed,.dss-grid {
        padding-left:16px;
        padding-right: 16px
    }

    .dss-col-lg-1,.dss-col-lg-10,.dss-col-lg-11,.dss-col-lg-12,.dss-col-lg-2,.dss-col-lg-3,.dss-col-lg-4,.dss-col-lg-5,.dss-col-lg-6,.dss-col-lg-7,.dss-col-lg-8,.dss-col-lg-9 {
        flex: 0 0 auto;
        padding-left: 16px;
        padding-right: 16px
    }

    .dss-col-lg-1 {
        width: 8.3333%
    }

    .dss-col-lg-2 {
        width: 16.6667%
    }

    .dss-col-lg-3 {
        width: 25%
    }

    .dss-col-lg-4 {
        width: 33.3333%
    }

    .dss-col-lg-5 {
        width: 41.6667%
    }

    .dss-col-lg-6 {
        width: 50%
    }

    .dss-col-lg-7 {
        width: 58.3333%
    }

    .dss-col-lg-8 {
        width: 66.6667%
    }

    .dss-col-lg-9 {
        width: 75%
    }

    .dss-col-lg-10 {
        width: 83.3333%
    }

    .dss-col-lg-11 {
        width: 91.6667%
    }

    .dss-col-lg-12 {
        width: 100%
    }

    .dss-lg-offset-12 {
        margin-left: 100%
    }

    .dss-lg-offset-11 {
        margin-left: 91.66666667%
    }

    .dss-lg-offset-10 {
        margin-left: 83.33333333%
    }

    .dss-lg-offset-9 {
        margin-left: 75%
    }

    .dss-lg-offset-8 {
        margin-left: 66.66666667%
    }

    .dss-lg-offset-7 {
        margin-left: 58.33333333%
    }

    .dss-lg-offset-6 {
        margin-left: 50%
    }

    .dss-lg-offset-5 {
        margin-left: 41.66666667%
    }

    .dss-lg-offset-4 {
        margin-left: 33.33333333%
    }

    .dss-lg-offset-3 {
        margin-left: 25%
    }

    .dss-lg-offset-2 {
        margin-left: 16.66666667%
    }

    .dss-lg-offset-1 {
        margin-left: 8.33333333%
    }

    .dss-lg-offset-0 {
        margin-left: 0
    }
}

.dss-mt-0 {
    margin-top: 0!important
}

.dss-mt-0\\.25 {
    margin-top: 4px!important
}

.dss-mt-0\\.5 {
    margin-top: 8px!important
}

.dss-mt-1 {
    margin-top: 16px!important
}

.dss-mt-1\\.5 {
    margin-top: 24px!important
}

.dss-mt-2 {
    margin-top: 32px!important
}

.dss-mt-2\\.5 {
    margin-top: 40px!important
}

.dss-mt-3 {
    margin-top: 48px!important
}

.dss-mt-auto {
    margin-top: auto!important
}

.dss-mr-0 {
    margin-right: 0!important
}

.dss-mr-0\\.25 {
    margin-right: 4px!important
}

.dss-mr-0\\.5 {
    margin-right: 8px!important
}

.dss-mr-1 {
    margin-right: 16px!important
}

.dss-mr-1\\.5 {
    margin-right: 24px!important
}

.dss-mr-2 {
    margin-right: 32px!important
}

.dss-mr-2\\.5 {
    margin-right: 40px!important
}

.dss-mr-3 {
    margin-right: 48px!important
}

.dss-mr-auto {
    margin-right: auto!important
}

.dss-ml-0 {
    margin-left: 0!important
}

.dss-ml-0\\.25 {
    margin-left: 4px!important
}

.dss-ml-0\\.5 {
    margin-left: 8px!important
}

.dss-ml-1 {
    margin-left: 16px!important
}

.dss-ml-1\\.5 {
    margin-left: 24px!important
}

.dss-ml-2 {
    margin-left: 32px!important
}

.dss-ml-2\\.5 {
    margin-left: 40px!important
}

.dss-ml-3 {
    margin-left: 48px!important
}

.dss-ml-auto {
    margin-left: auto!important
}

.dss-mb-0 {
    margin-bottom: 0!important
}

.dss-mb-0\\.25 {
    margin-bottom: 4px!important
}

.dss-mb-0\\.5 {
    margin-bottom: 8px!important
}

.dss-mb-1 {
    margin-bottom: 16px!important
}

.dss-mb-1\\.5 {
    margin-bottom: 24px!important
}

.dss-mb-2 {
    margin-bottom: 32px!important
}

.dss-mb-2\\.5 {
    margin-bottom: 40px!important
}

.dss-mb-3 {
    margin-bottom: 48px!important
}

.dss-mb-auto {
    margin-bottom: auto!important
}

.dss-mx-0 {
    margin-left: 0!important;
    margin-right: 0!important
}

.dss-mx-0\\.25 {
    margin-left: 4px!important;
    margin-right: 4px!important
}

.dss-mx-0\\.5 {
    margin-left: 8px!important;
    margin-right: 8px!important
}

.dss-mx-1 {
    margin-left: 16px!important;
    margin-right: 16px!important
}

.dss-mx-1\\.5 {
    margin-left: 24px!important;
    margin-right: 24px!important
}

.dss-mx-2 {
    margin-left: 32px!important;
    margin-right: 32px!important
}

.dss-mx-2\\.5 {
    margin-left: 40px!important;
    margin-right: 40px!important
}

.dss-mx-3 {
    margin-left: 48px!important;
    margin-right: 48px!important
}

.dss-mx-auto {
    margin-left: auto!important;
    margin-right: auto!important
}

.dss-my-0 {
    margin-bottom: 0!important;
    margin-top: 0!important
}

.dss-my-0\\.25 {
    margin-bottom: 4px!important;
    margin-top: 4px!important
}

.dss-my-0\\.5 {
    margin-bottom: 8px!important;
    margin-top: 8px!important
}

.dss-my-1 {
    margin-bottom: 16px!important;
    margin-top: 16px!important
}

.dss-my-1\\.5 {
    margin-bottom: 24px!important;
    margin-top: 24px!important
}

.dss-my-2 {
    margin-bottom: 32px!important;
    margin-top: 32px!important
}

.dss-my-2\\.5 {
    margin-bottom: 40px!important;
    margin-top: 40px!important
}

.dss-my-3 {
    margin-bottom: 48px!important;
    margin-top: 48px!important
}

.dss-my-auto {
    margin-bottom: auto!important;
    margin-top: auto!important
}

.dss-m-0 {
    margin: 0!important
}

.dss-m-0\\.25 {
    margin: 4px!important
}

.dss-m-0\\.5 {
    margin: 8px!important
}

.dss-m-1 {
    margin: 16px!important
}

.dss-m-1\\.5 {
    margin: 24px!important
}

.dss-m-2 {
    margin: 32px!important
}

.dss-m-2\\.5 {
    margin: 40px!important
}

.dss-m-3 {
    margin: 48px!important
}

.dss-m-auto {
    margin: auto!important
}

@media (min-width: 320px) {
    .dss-mt-sm-0 {
        margin-top:0!important
    }

    .dss-mt-sm-0\\.25 {
        margin-top: 4px!important
    }

    .dss-mt-sm-0\\.5 {
        margin-top: 8px!important
    }

    .dss-mt-sm-1 {
        margin-top: 16px!important
    }

    .dss-mt-sm-1\\.5 {
        margin-top: 24px!important
    }

    .dss-mt-sm-2 {
        margin-top: 32px!important
    }

    .dss-mt-sm-2\\.5 {
        margin-top: 40px!important
    }

    .dss-mt-sm-3 {
        margin-top: 48px!important
    }

    .dss-mt-sm-auto {
        margin-top: auto!important
    }

    .dss-mr-sm-0 {
        margin-right: 0!important
    }

    .dss-mr-sm-0\\.25 {
        margin-right: 4px!important
    }

    .dss-mr-sm-0\\.5 {
        margin-right: 8px!important
    }

    .dss-mr-sm-1 {
        margin-right: 16px!important
    }

    .dss-mr-sm-1\\.5 {
        margin-right: 24px!important
    }

    .dss-mr-sm-2 {
        margin-right: 32px!important
    }

    .dss-mr-sm-2\\.5 {
        margin-right: 40px!important
    }

    .dss-mr-sm-3 {
        margin-right: 48px!important
    }

    .dss-mr-sm-auto {
        margin-right: auto!important
    }

    .dss-ml-sm-0 {
        margin-left: 0!important
    }

    .dss-ml-sm-0\\.25 {
        margin-left: 4px!important
    }

    .dss-ml-sm-0\\.5 {
        margin-left: 8px!important
    }

    .dss-ml-sm-1 {
        margin-left: 16px!important
    }

    .dss-ml-sm-1\\.5 {
        margin-left: 24px!important
    }

    .dss-ml-sm-2 {
        margin-left: 32px!important
    }

    .dss-ml-sm-2\\.5 {
        margin-left: 40px!important
    }

    .dss-ml-sm-3 {
        margin-left: 48px!important
    }

    .dss-ml-sm-auto {
        margin-left: auto!important
    }

    .dss-mb-sm-0 {
        margin-bottom: 0!important
    }

    .dss-mb-sm-0\\.25 {
        margin-bottom: 4px!important
    }

    .dss-mb-sm-0\\.5 {
        margin-bottom: 8px!important
    }

    .dss-mb-sm-1 {
        margin-bottom: 16px!important
    }

    .dss-mb-sm-1\\.5 {
        margin-bottom: 24px!important
    }

    .dss-mb-sm-2 {
        margin-bottom: 32px!important
    }

    .dss-mb-sm-2\\.5 {
        margin-bottom: 40px!important
    }

    .dss-mb-sm-3 {
        margin-bottom: 48px!important
    }

    .dss-mb-sm-auto {
        margin-bottom: auto!important
    }

    .dss-mx-sm-0 {
        margin-left: 0!important;
        margin-right: 0!important
    }

    .dss-mx-sm-0\\.25 {
        margin-left: 4px!important;
        margin-right: 4px!important
    }

    .dss-mx-sm-0\\.5 {
        margin-left: 8px!important;
        margin-right: 8px!important
    }

    .dss-mx-sm-1 {
        margin-left: 16px!important;
        margin-right: 16px!important
    }

    .dss-mx-sm-1\\.5 {
        margin-left: 24px!important;
        margin-right: 24px!important
    }

    .dss-mx-sm-2 {
        margin-left: 32px!important;
        margin-right: 32px!important
    }

    .dss-mx-sm-2\\.5 {
        margin-left: 40px!important;
        margin-right: 40px!important
    }

    .dss-mx-sm-3 {
        margin-left: 48px!important;
        margin-right: 48px!important
    }

    .dss-mx-sm-auto {
        margin-left: auto!important;
        margin-right: auto!important
    }

    .dss-my-sm-0 {
        margin-bottom: 0!important;
        margin-top: 0!important
    }

    .dss-my-sm-0\\.25 {
        margin-bottom: 4px!important;
        margin-top: 4px!important
    }

    .dss-my-sm-0\\.5 {
        margin-bottom: 8px!important;
        margin-top: 8px!important
    }

    .dss-my-sm-1 {
        margin-bottom: 16px!important;
        margin-top: 16px!important
    }

    .dss-my-sm-1\\.5 {
        margin-bottom: 24px!important;
        margin-top: 24px!important
    }

    .dss-my-sm-2 {
        margin-bottom: 32px!important;
        margin-top: 32px!important
    }

    .dss-my-sm-2\\.5 {
        margin-bottom: 40px!important;
        margin-top: 40px!important
    }

    .dss-my-sm-3 {
        margin-bottom: 48px!important;
        margin-top: 48px!important
    }

    .dss-my-sm-auto {
        margin-bottom: auto!important;
        margin-top: auto!important
    }

    .dss-m-sm-0 {
        margin: 0!important
    }

    .dss-m-sm-0\\.25 {
        margin: 4px!important
    }

    .dss-m-sm-0\\.5 {
        margin: 8px!important
    }

    .dss-m-sm-1 {
        margin: 16px!important
    }

    .dss-m-sm-1\\.5 {
        margin: 24px!important
    }

    .dss-m-sm-2 {
        margin: 32px!important
    }

    .dss-m-sm-2\\.5 {
        margin: 40px!important
    }

    .dss-m-sm-3 {
        margin: 48px!important
    }

    .dss-m-sm-auto {
        margin: auto!important
    }
}

@media (min-width: 768px) {
    .dss-mt-md-0 {
        margin-top:0!important
    }

    .dss-mt-md-0\\.25 {
        margin-top: 4px!important
    }

    .dss-mt-md-0\\.5 {
        margin-top: 8px!important
    }

    .dss-mt-md-1 {
        margin-top: 16px!important
    }

    .dss-mt-md-1\\.5 {
        margin-top: 24px!important
    }

    .dss-mt-md-2 {
        margin-top: 32px!important
    }

    .dss-mt-md-2\\.5 {
        margin-top: 40px!important
    }

    .dss-mt-md-3 {
        margin-top: 48px!important
    }

    .dss-mt-md-auto {
        margin-top: auto!important
    }

    .dss-mr-md-0 {
        margin-right: 0!important
    }

    .dss-mr-md-0\\.25 {
        margin-right: 4px!important
    }

    .dss-mr-md-0\\.5 {
        margin-right: 8px!important
    }

    .dss-mr-md-1 {
        margin-right: 16px!important
    }

    .dss-mr-md-1\\.5 {
        margin-right: 24px!important
    }

    .dss-mr-md-2 {
        margin-right: 32px!important
    }

    .dss-mr-md-2\\.5 {
        margin-right: 40px!important
    }

    .dss-mr-md-3 {
        margin-right: 48px!important
    }

    .dss-mr-md-auto {
        margin-right: auto!important
    }

    .dss-ml-md-0 {
        margin-left: 0!important
    }

    .dss-ml-md-0\\.25 {
        margin-left: 4px!important
    }

    .dss-ml-md-0\\.5 {
        margin-left: 8px!important
    }

    .dss-ml-md-1 {
        margin-left: 16px!important
    }

    .dss-ml-md-1\\.5 {
        margin-left: 24px!important
    }

    .dss-ml-md-2 {
        margin-left: 32px!important
    }

    .dss-ml-md-2\\.5 {
        margin-left: 40px!important
    }

    .dss-ml-md-3 {
        margin-left: 48px!important
    }

    .dss-ml-md-auto {
        margin-left: auto!important
    }

    .dss-mb-md-0 {
        margin-bottom: 0!important
    }

    .dss-mb-md-0\\.25 {
        margin-bottom: 4px!important
    }

    .dss-mb-md-0\\.5 {
        margin-bottom: 8px!important
    }

    .dss-mb-md-1 {
        margin-bottom: 16px!important
    }

    .dss-mb-md-1\\.5 {
        margin-bottom: 24px!important
    }

    .dss-mb-md-2 {
        margin-bottom: 32px!important
    }

    .dss-mb-md-2\\.5 {
        margin-bottom: 40px!important
    }

    .dss-mb-md-3 {
        margin-bottom: 48px!important
    }

    .dss-mb-md-auto {
        margin-bottom: auto!important
    }

    .dss-mx-md-0 {
        margin-left: 0!important;
        margin-right: 0!important
    }

    .dss-mx-md-0\\.25 {
        margin-left: 4px!important;
        margin-right: 4px!important
    }

    .dss-mx-md-0\\.5 {
        margin-left: 8px!important;
        margin-right: 8px!important
    }

    .dss-mx-md-1 {
        margin-left: 16px!important;
        margin-right: 16px!important
    }

    .dss-mx-md-1\\.5 {
        margin-left: 24px!important;
        margin-right: 24px!important
    }

    .dss-mx-md-2 {
        margin-left: 32px!important;
        margin-right: 32px!important
    }

    .dss-mx-md-2\\.5 {
        margin-left: 40px!important;
        margin-right: 40px!important
    }

    .dss-mx-md-3 {
        margin-left: 48px!important;
        margin-right: 48px!important
    }

    .dss-mx-md-auto {
        margin-left: auto!important;
        margin-right: auto!important
    }

    .dss-my-md-0 {
        margin-bottom: 0!important;
        margin-top: 0!important
    }

    .dss-my-md-0\\.25 {
        margin-bottom: 4px!important;
        margin-top: 4px!important
    }

    .dss-my-md-0\\.5 {
        margin-bottom: 8px!important;
        margin-top: 8px!important
    }

    .dss-my-md-1 {
        margin-bottom: 16px!important;
        margin-top: 16px!important
    }

    .dss-my-md-1\\.5 {
        margin-bottom: 24px!important;
        margin-top: 24px!important
    }

    .dss-my-md-2 {
        margin-bottom: 32px!important;
        margin-top: 32px!important
    }

    .dss-my-md-2\\.5 {
        margin-bottom: 40px!important;
        margin-top: 40px!important
    }

    .dss-my-md-3 {
        margin-bottom: 48px!important;
        margin-top: 48px!important
    }

    .dss-my-md-auto {
        margin-bottom: auto!important;
        margin-top: auto!important
    }

    .dss-m-md-0 {
        margin: 0!important
    }

    .dss-m-md-0\\.25 {
        margin: 4px!important
    }

    .dss-m-md-0\\.5 {
        margin: 8px!important
    }

    .dss-m-md-1 {
        margin: 16px!important
    }

    .dss-m-md-1\\.5 {
        margin: 24px!important
    }

    .dss-m-md-2 {
        margin: 32px!important
    }

    .dss-m-md-2\\.5 {
        margin: 40px!important
    }

    .dss-m-md-3 {
        margin: 48px!important
    }

    .dss-m-md-auto {
        margin: auto!important
    }
}

@media (min-width: 1920px) {
    .dss-mt-lg-0 {
        margin-top:0!important
    }

    .dss-mt-lg-0\\.25 {
        margin-top: 4px!important
    }

    .dss-mt-lg-0\\.5 {
        margin-top: 8px!important
    }

    .dss-mt-lg-1 {
        margin-top: 16px!important
    }

    .dss-mt-lg-1\\.5 {
        margin-top: 24px!important
    }

    .dss-mt-lg-2 {
        margin-top: 32px!important
    }

    .dss-mt-lg-2\\.5 {
        margin-top: 40px!important
    }

    .dss-mt-lg-3 {
        margin-top: 48px!important
    }

    .dss-mt-lg-auto {
        margin-top: auto!important
    }

    .dss-mr-lg-0 {
        margin-right: 0!important
    }

    .dss-mr-lg-0\\.25 {
        margin-right: 4px!important
    }

    .dss-mr-lg-0\\.5 {
        margin-right: 8px!important
    }

    .dss-mr-lg-1 {
        margin-right: 16px!important
    }

    .dss-mr-lg-1\\.5 {
        margin-right: 24px!important
    }

    .dss-mr-lg-2 {
        margin-right: 32px!important
    }

    .dss-mr-lg-2\\.5 {
        margin-right: 40px!important
    }

    .dss-mr-lg-3 {
        margin-right: 48px!important
    }

    .dss-mr-lg-auto {
        margin-right: auto!important
    }

    .dss-ml-lg-0 {
        margin-left: 0!important
    }

    .dss-ml-lg-0\\.25 {
        margin-left: 4px!important
    }

    .dss-ml-lg-0\\.5 {
        margin-left: 8px!important
    }

    .dss-ml-lg-1 {
        margin-left: 16px!important
    }

    .dss-ml-lg-1\\.5 {
        margin-left: 24px!important
    }

    .dss-ml-lg-2 {
        margin-left: 32px!important
    }

    .dss-ml-lg-2\\.5 {
        margin-left: 40px!important
    }

    .dss-ml-lg-3 {
        margin-left: 48px!important
    }

    .dss-ml-lg-auto {
        margin-left: auto!important
    }

    .dss-mb-lg-0 {
        margin-bottom: 0!important
    }

    .dss-mb-lg-0\\.25 {
        margin-bottom: 4px!important
    }

    .dss-mb-lg-0\\.5 {
        margin-bottom: 8px!important
    }

    .dss-mb-lg-1 {
        margin-bottom: 16px!important
    }

    .dss-mb-lg-1\\.5 {
        margin-bottom: 24px!important
    }

    .dss-mb-lg-2 {
        margin-bottom: 32px!important
    }

    .dss-mb-lg-2\\.5 {
        margin-bottom: 40px!important
    }

    .dss-mb-lg-3 {
        margin-bottom: 48px!important
    }

    .dss-mb-lg-auto {
        margin-bottom: auto!important
    }

    .dss-mx-lg-0 {
        margin-left: 0!important;
        margin-right: 0!important
    }

    .dss-mx-lg-0\\.25 {
        margin-left: 4px!important;
        margin-right: 4px!important
    }

    .dss-mx-lg-0\\.5 {
        margin-left: 8px!important;
        margin-right: 8px!important
    }

    .dss-mx-lg-1 {
        margin-left: 16px!important;
        margin-right: 16px!important
    }

    .dss-mx-lg-1\\.5 {
        margin-left: 24px!important;
        margin-right: 24px!important
    }

    .dss-mx-lg-2 {
        margin-left: 32px!important;
        margin-right: 32px!important
    }

    .dss-mx-lg-2\\.5 {
        margin-left: 40px!important;
        margin-right: 40px!important
    }

    .dss-mx-lg-3 {
        margin-left: 48px!important;
        margin-right: 48px!important
    }

    .dss-mx-lg-auto {
        margin-left: auto!important;
        margin-right: auto!important
    }

    .dss-my-lg-0 {
        margin-bottom: 0!important;
        margin-top: 0!important
    }

    .dss-my-lg-0\\.25 {
        margin-bottom: 4px!important;
        margin-top: 4px!important
    }

    .dss-my-lg-0\\.5 {
        margin-bottom: 8px!important;
        margin-top: 8px!important
    }

    .dss-my-lg-1 {
        margin-bottom: 16px!important;
        margin-top: 16px!important
    }

    .dss-my-lg-1\\.5 {
        margin-bottom: 24px!important;
        margin-top: 24px!important
    }

    .dss-my-lg-2 {
        margin-bottom: 32px!important;
        margin-top: 32px!important
    }

    .dss-my-lg-2\\.5 {
        margin-bottom: 40px!important;
        margin-top: 40px!important
    }

    .dss-my-lg-3 {
        margin-bottom: 48px!important;
        margin-top: 48px!important
    }

    .dss-my-lg-auto {
        margin-bottom: auto!important;
        margin-top: auto!important
    }

    .dss-m-lg-0 {
        margin: 0!important
    }

    .dss-m-lg-0\\.25 {
        margin: 4px!important
    }

    .dss-m-lg-0\\.5 {
        margin: 8px!important
    }

    .dss-m-lg-1 {
        margin: 16px!important
    }

    .dss-m-lg-1\\.5 {
        margin: 24px!important
    }

    .dss-m-lg-2 {
        margin: 32px!important
    }

    .dss-m-lg-2\\.5 {
        margin: 40px!important
    }

    .dss-m-lg-3 {
        margin: 48px!important
    }

    .dss-m-lg-auto {
        margin: auto!important
    }
}

.dss-pt-0 {
    padding-top: 0!important
}

.dss-pt-0\\.25 {
    padding-top: 4px!important
}

.dss-pt-0\\.5 {
    padding-top: 8px!important
}

.dss-pt-1 {
    padding-top: 16px!important
}

.dss-pt-1\\.5 {
    padding-top: 24px!important
}

.dss-pt-2 {
    padding-top: 32px!important
}

.dss-pt-2\\.5 {
    padding-top: 40px!important
}

.dss-pt-3 {
    padding-top: 48px!important
}

.dss-pr-0 {
    padding-right: 0!important
}

.dss-pr-0\\.25 {
    padding-right: 4px!important
}

.dss-pr-0\\.5 {
    padding-right: 8px!important
}

.dss-pr-1 {
    padding-right: 16px!important
}

.dss-pr-1\\.5 {
    padding-right: 24px!important
}

.dss-pr-2 {
    padding-right: 32px!important
}

.dss-pr-2\\.5 {
    padding-right: 40px!important
}

.dss-pr-3 {
    padding-right: 48px!important
}

.dss-pl-0 {
    padding-left: 0!important
}

.dss-pl-0\\.25 {
    padding-left: 4px!important
}

.dss-pl-0\\.5 {
    padding-left: 8px!important
}

.dss-pl-1 {
    padding-left: 16px!important
}

.dss-pl-1\\.5 {
    padding-left: 24px!important
}

.dss-pl-2 {
    padding-left: 32px!important
}

.dss-pl-2\\.5 {
    padding-left: 40px!important
}

.dss-pl-3 {
    padding-left: 48px!important
}

.dss-pb-0 {
    padding-bottom: 0!important
}

.dss-pb-0\\.25 {
    padding-bottom: 4px!important
}

.dss-pb-0\\.5 {
    padding-bottom: 8px!important
}

.dss-pb-1 {
    padding-bottom: 16px!important
}

.dss-pb-1\\.5 {
    padding-bottom: 24px!important
}

.dss-pb-2 {
    padding-bottom: 32px!important
}

.dss-pb-2\\.5 {
    padding-bottom: 40px!important
}

.dss-pb-3 {
    padding-bottom: 48px!important
}

.dss-px-0 {
    padding-left: 0!important;
    padding-right: 0!important
}

.dss-px-0\\.25 {
    padding-left: 4px!important;
    padding-right: 4px!important
}

.dss-px-0\\.5 {
    padding-left: 8px!important;
    padding-right: 8px!important
}

.dss-px-1 {
    padding-left: 16px!important;
    padding-right: 16px!important
}

.dss-px-1\\.5 {
    padding-left: 24px!important;
    padding-right: 24px!important
}

.dss-px-2 {
    padding-left: 32px!important;
    padding-right: 32px!important
}

.dss-px-2\\.5 {
    padding-left: 40px!important;
    padding-right: 40px!important
}

.dss-px-3 {
    padding-left: 48px!important;
    padding-right: 48px!important
}

.dss-py-0 {
    padding-bottom: 0!important;
    padding-top: 0!important
}

.dss-py-0\\.25 {
    padding-bottom: 4px!important;
    padding-top: 4px!important
}

.dss-py-0\\.5 {
    padding-bottom: 8px!important;
    padding-top: 8px!important
}

.dss-py-1 {
    padding-bottom: 16px!important;
    padding-top: 16px!important
}

.dss-py-1\\.5 {
    padding-bottom: 24px!important;
    padding-top: 24px!important
}

.dss-py-2 {
    padding-bottom: 32px!important;
    padding-top: 32px!important
}

.dss-py-2\\.5 {
    padding-bottom: 40px!important;
    padding-top: 40px!important
}

.dss-py-3 {
    padding-bottom: 48px!important;
    padding-top: 48px!important
}

.dss-p-0 {
    padding: 0!important
}

.dss-p-0\\.25 {
    padding: 4px!important
}

.dss-p-0\\.5 {
    padding: 8px!important
}

.dss-p-1 {
    padding: 16px!important
}

.dss-p-1\\.5 {
    padding: 24px!important
}

.dss-p-2 {
    padding: 32px!important
}

.dss-p-2\\.5 {
    padding: 40px!important
}

.dss-p-3 {
    padding: 48px!important
}

@media (min-width: 320px) {
    .dss-pt-sm-0 {
        padding-top:0!important
    }

    .dss-pt-sm-0\\.25 {
        padding-top: 4px!important
    }

    .dss-pt-sm-0\\.5 {
        padding-top: 8px!important
    }

    .dss-pt-sm-1 {
        padding-top: 16px!important
    }

    .dss-pt-sm-1\\.5 {
        padding-top: 24px!important
    }

    .dss-pt-sm-2 {
        padding-top: 32px!important
    }

    .dss-pt-sm-2\\.5 {
        padding-top: 40px!important
    }

    .dss-pt-sm-3 {
        padding-top: 48px!important
    }

    .dss-pr-sm-0 {
        padding-right: 0!important
    }

    .dss-pr-sm-0\\.25 {
        padding-right: 4px!important
    }

    .dss-pr-sm-0\\.5 {
        padding-right: 8px!important
    }

    .dss-pr-sm-1 {
        padding-right: 16px!important
    }

    .dss-pr-sm-1\\.5 {
        padding-right: 24px!important
    }

    .dss-pr-sm-2 {
        padding-right: 32px!important
    }

    .dss-pr-sm-2\\.5 {
        padding-right: 40px!important
    }

    .dss-pr-sm-3 {
        padding-right: 48px!important
    }

    .dss-pl-sm-0 {
        padding-left: 0!important
    }

    .dss-pl-sm-0\\.25 {
        padding-left: 4px!important
    }

    .dss-pl-sm-0\\.5 {
        padding-left: 8px!important
    }

    .dss-pl-sm-1 {
        padding-left: 16px!important
    }

    .dss-pl-sm-1\\.5 {
        padding-left: 24px!important
    }

    .dss-pl-sm-2 {
        padding-left: 32px!important
    }

    .dss-pl-sm-2\\.5 {
        padding-left: 40px!important
    }

    .dss-pl-sm-3 {
        padding-left: 48px!important
    }

    .dss-pb-sm-0 {
        padding-bottom: 0!important
    }

    .dss-pb-sm-0\\.25 {
        padding-bottom: 4px!important
    }

    .dss-pb-sm-0\\.5 {
        padding-bottom: 8px!important
    }

    .dss-pb-sm-1 {
        padding-bottom: 16px!important
    }

    .dss-pb-sm-1\\.5 {
        padding-bottom: 24px!important
    }

    .dss-pb-sm-2 {
        padding-bottom: 32px!important
    }

    .dss-pb-sm-2\\.5 {
        padding-bottom: 40px!important
    }

    .dss-pb-sm-3 {
        padding-bottom: 48px!important
    }

    .dss-px-sm-0 {
        padding-left: 0!important;
        padding-right: 0!important
    }

    .dss-px-sm-0\\.25 {
        padding-left: 4px!important;
        padding-right: 4px!important
    }

    .dss-px-sm-0\\.5 {
        padding-left: 8px!important;
        padding-right: 8px!important
    }

    .dss-px-sm-1 {
        padding-left: 16px!important;
        padding-right: 16px!important
    }

    .dss-px-sm-1\\.5 {
        padding-left: 24px!important;
        padding-right: 24px!important
    }

    .dss-px-sm-2 {
        padding-left: 32px!important;
        padding-right: 32px!important
    }

    .dss-px-sm-2\\.5 {
        padding-left: 40px!important;
        padding-right: 40px!important
    }

    .dss-px-sm-3 {
        padding-left: 48px!important;
        padding-right: 48px!important
    }

    .dss-py-sm-0 {
        padding-bottom: 0!important;
        padding-top: 0!important
    }

    .dss-py-sm-0\\.25 {
        padding-bottom: 4px!important;
        padding-top: 4px!important
    }

    .dss-py-sm-0\\.5 {
        padding-bottom: 8px!important;
        padding-top: 8px!important
    }

    .dss-py-sm-1 {
        padding-bottom: 16px!important;
        padding-top: 16px!important
    }

    .dss-py-sm-1\\.5 {
        padding-bottom: 24px!important;
        padding-top: 24px!important
    }

    .dss-py-sm-2 {
        padding-bottom: 32px!important;
        padding-top: 32px!important
    }

    .dss-py-sm-2\\.5 {
        padding-bottom: 40px!important;
        padding-top: 40px!important
    }

    .dss-py-sm-3 {
        padding-bottom: 48px!important;
        padding-top: 48px!important
    }

    .dss-p-sm-0 {
        padding: 0!important
    }

    .dss-p-sm-0\\.25 {
        padding: 4px!important
    }

    .dss-p-sm-0\\.5 {
        padding: 8px!important
    }

    .dss-p-sm-1 {
        padding: 16px!important
    }

    .dss-p-sm-1\\.5 {
        padding: 24px!important
    }

    .dss-p-sm-2 {
        padding: 32px!important
    }

    .dss-p-sm-2\\.5 {
        padding: 40px!important
    }

    .dss-p-sm-3 {
        padding: 48px!important
    }
}

@media (min-width: 768px) {
    .dss-pt-md-0 {
        padding-top:0!important
    }

    .dss-pt-md-0\\.25 {
        padding-top: 4px!important
    }

    .dss-pt-md-0\\.5 {
        padding-top: 8px!important
    }

    .dss-pt-md-1 {
        padding-top: 16px!important
    }

    .dss-pt-md-1\\.5 {
        padding-top: 24px!important
    }

    .dss-pt-md-2 {
        padding-top: 32px!important
    }

    .dss-pt-md-2\\.5 {
        padding-top: 40px!important
    }

    .dss-pt-md-3 {
        padding-top: 48px!important
    }

    .dss-pr-md-0 {
        padding-right: 0!important
    }

    .dss-pr-md-0\\.25 {
        padding-right: 4px!important
    }

    .dss-pr-md-0\\.5 {
        padding-right: 8px!important
    }

    .dss-pr-md-1 {
        padding-right: 16px!important
    }

    .dss-pr-md-1\\.5 {
        padding-right: 24px!important
    }

    .dss-pr-md-2 {
        padding-right: 32px!important
    }

    .dss-pr-md-2\\.5 {
        padding-right: 40px!important
    }

    .dss-pr-md-3 {
        padding-right: 48px!important
    }

    .dss-pl-md-0 {
        padding-left: 0!important
    }

    .dss-pl-md-0\\.25 {
        padding-left: 4px!important
    }

    .dss-pl-md-0\\.5 {
        padding-left: 8px!important
    }

    .dss-pl-md-1 {
        padding-left: 16px!important
    }

    .dss-pl-md-1\\.5 {
        padding-left: 24px!important
    }

    .dss-pl-md-2 {
        padding-left: 32px!important
    }

    .dss-pl-md-2\\.5 {
        padding-left: 40px!important
    }

    .dss-pl-md-3 {
        padding-left: 48px!important
    }

    .dss-pb-md-0 {
        padding-bottom: 0!important
    }

    .dss-pb-md-0\\.25 {
        padding-bottom: 4px!important
    }

    .dss-pb-md-0\\.5 {
        padding-bottom: 8px!important
    }

    .dss-pb-md-1 {
        padding-bottom: 16px!important
    }

    .dss-pb-md-1\\.5 {
        padding-bottom: 24px!important
    }

    .dss-pb-md-2 {
        padding-bottom: 32px!important
    }

    .dss-pb-md-2\\.5 {
        padding-bottom: 40px!important
    }

    .dss-pb-md-3 {
        padding-bottom: 48px!important
    }

    .dss-px-md-0 {
        padding-left: 0!important;
        padding-right: 0!important
    }

    .dss-px-md-0\\.25 {
        padding-left: 4px!important;
        padding-right: 4px!important
    }

    .dss-px-md-0\\.5 {
        padding-left: 8px!important;
        padding-right: 8px!important
    }

    .dss-px-md-1 {
        padding-left: 16px!important;
        padding-right: 16px!important
    }

    .dss-px-md-1\\.5 {
        padding-left: 24px!important;
        padding-right: 24px!important
    }

    .dss-px-md-2 {
        padding-left: 32px!important;
        padding-right: 32px!important
    }

    .dss-px-md-2\\.5 {
        padding-left: 40px!important;
        padding-right: 40px!important
    }

    .dss-px-md-3 {
        padding-left: 48px!important;
        padding-right: 48px!important
    }

    .dss-py-md-0 {
        padding-bottom: 0!important;
        padding-top: 0!important
    }

    .dss-py-md-0\\.25 {
        padding-bottom: 4px!important;
        padding-top: 4px!important
    }

    .dss-py-md-0\\.5 {
        padding-bottom: 8px!important;
        padding-top: 8px!important
    }

    .dss-py-md-1 {
        padding-bottom: 16px!important;
        padding-top: 16px!important
    }

    .dss-py-md-1\\.5 {
        padding-bottom: 24px!important;
        padding-top: 24px!important
    }

    .dss-py-md-2 {
        padding-bottom: 32px!important;
        padding-top: 32px!important
    }

    .dss-py-md-2\\.5 {
        padding-bottom: 40px!important;
        padding-top: 40px!important
    }

    .dss-py-md-3 {
        padding-bottom: 48px!important;
        padding-top: 48px!important
    }

    .dss-p-md-0 {
        padding: 0!important
    }

    .dss-p-md-0\\.25 {
        padding: 4px!important
    }

    .dss-p-md-0\\.5 {
        padding: 8px!important
    }

    .dss-p-md-1 {
        padding: 16px!important
    }

    .dss-p-md-1\\.5 {
        padding: 24px!important
    }

    .dss-p-md-2 {
        padding: 32px!important
    }

    .dss-p-md-2\\.5 {
        padding: 40px!important
    }

    .dss-p-md-3 {
        padding: 48px!important
    }
}

@media (min-width: 1920px) {
    .dss-pt-lg-0 {
        padding-top:0!important
    }

    .dss-pt-lg-0\\.25 {
        padding-top: 4px!important
    }

    .dss-pt-lg-0\\.5 {
        padding-top: 8px!important
    }

    .dss-pt-lg-1 {
        padding-top: 16px!important
    }

    .dss-pt-lg-1\\.5 {
        padding-top: 24px!important
    }

    .dss-pt-lg-2 {
        padding-top: 32px!important
    }

    .dss-pt-lg-2\\.5 {
        padding-top: 40px!important
    }

    .dss-pt-lg-3 {
        padding-top: 48px!important
    }

    .dss-pr-lg-0 {
        padding-right: 0!important
    }

    .dss-pr-lg-0\\.25 {
        padding-right: 4px!important
    }

    .dss-pr-lg-0\\.5 {
        padding-right: 8px!important
    }

    .dss-pr-lg-1 {
        padding-right: 16px!important
    }

    .dss-pr-lg-1\\.5 {
        padding-right: 24px!important
    }

    .dss-pr-lg-2 {
        padding-right: 32px!important
    }

    .dss-pr-lg-2\\.5 {
        padding-right: 40px!important
    }

    .dss-pr-lg-3 {
        padding-right: 48px!important
    }

    .dss-pl-lg-0 {
        padding-left: 0!important
    }

    .dss-pl-lg-0\\.25 {
        padding-left: 4px!important
    }

    .dss-pl-lg-0\\.5 {
        padding-left: 8px!important
    }

    .dss-pl-lg-1 {
        padding-left: 16px!important
    }

    .dss-pl-lg-1\\.5 {
        padding-left: 24px!important
    }

    .dss-pl-lg-2 {
        padding-left: 32px!important
    }

    .dss-pl-lg-2\\.5 {
        padding-left: 40px!important
    }

    .dss-pl-lg-3 {
        padding-left: 48px!important
    }

    .dss-pb-lg-0 {
        padding-bottom: 0!important
    }

    .dss-pb-lg-0\\.25 {
        padding-bottom: 4px!important
    }

    .dss-pb-lg-0\\.5 {
        padding-bottom: 8px!important
    }

    .dss-pb-lg-1 {
        padding-bottom: 16px!important
    }

    .dss-pb-lg-1\\.5 {
        padding-bottom: 24px!important
    }

    .dss-pb-lg-2 {
        padding-bottom: 32px!important
    }

    .dss-pb-lg-2\\.5 {
        padding-bottom: 40px!important
    }

    .dss-pb-lg-3 {
        padding-bottom: 48px!important
    }

    .dss-px-lg-0 {
        padding-left: 0!important;
        padding-right: 0!important
    }

    .dss-px-lg-0\\.25 {
        padding-left: 4px!important;
        padding-right: 4px!important
    }

    .dss-px-lg-0\\.5 {
        padding-left: 8px!important;
        padding-right: 8px!important
    }

    .dss-px-lg-1 {
        padding-left: 16px!important;
        padding-right: 16px!important
    }

    .dss-px-lg-1\\.5 {
        padding-left: 24px!important;
        padding-right: 24px!important
    }

    .dss-px-lg-2 {
        padding-left: 32px!important;
        padding-right: 32px!important
    }

    .dss-px-lg-2\\.5 {
        padding-left: 40px!important;
        padding-right: 40px!important
    }

    .dss-px-lg-3 {
        padding-left: 48px!important;
        padding-right: 48px!important
    }

    .dss-py-lg-0 {
        padding-bottom: 0!important;
        padding-top: 0!important
    }

    .dss-py-lg-0\\.25 {
        padding-bottom: 4px!important;
        padding-top: 4px!important
    }

    .dss-py-lg-0\\.5 {
        padding-bottom: 8px!important;
        padding-top: 8px!important
    }

    .dss-py-lg-1 {
        padding-bottom: 16px!important;
        padding-top: 16px!important
    }

    .dss-py-lg-1\\.5 {
        padding-bottom: 24px!important;
        padding-top: 24px!important
    }

    .dss-py-lg-2 {
        padding-bottom: 32px!important;
        padding-top: 32px!important
    }

    .dss-py-lg-2\\.5 {
        padding-bottom: 40px!important;
        padding-top: 40px!important
    }

    .dss-py-lg-3 {
        padding-bottom: 48px!important;
        padding-top: 48px!important
    }

    .dss-p-lg-0 {
        padding: 0!important
    }

    .dss-p-lg-0\\.25 {
        padding: 4px!important
    }

    .dss-p-lg-0\\.5 {
        padding: 8px!important
    }

    .dss-p-lg-1 {
        padding: 16px!important
    }

    .dss-p-lg-1\\.5 {
        padding: 24px!important
    }

    .dss-p-lg-2 {
        padding: 32px!important
    }

    .dss-p-lg-2\\.5 {
        padding: 40px!important
    }

    .dss-p-lg-3 {
        padding: 48px!important
    }
}

.dss-text-justify {
    text-align: justify!important
}

.dss-text-left {
    text-align: left!important
}

.dss-text-right {
    text-align: right!important
}

.dss-text-center {
    text-align: center!important
}

.dss-text-nowrap {
    white-space: nowrap!important
}

.dss-text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.dss-text-lowercase {
    text-transform: lowercase!important
}

.dss-text-uppercase {
    text-transform: uppercase!important
}

.dss-text-capitalize {
    text-transform: capitalize!important
}

.dss-text-bold {
    font-weight: 700!important
}

.dss-text-normal {
    font-weight: 400!important
}

.dss-text-light {
    font-weight: 300!important
}

.dss-text-italic {
    font-style: italic!important
}

@media (min-width: 320px) {
    .dss-text-sm-justify {
        text-align:justify!important
    }

    .dss-text-sm-left {
        text-align: left!important
    }

    .dss-text-sm-right {
        text-align: right!important
    }

    .dss-text-sm-center {
        text-align: center!important
    }
}

@media (min-width: 768px) {
    .dss-text-md-justify {
        text-align:justify!important
    }

    .dss-text-md-left {
        text-align: left!important
    }

    .dss-text-md-right {
        text-align: right!important
    }

    .dss-text-md-center {
        text-align: center!important
    }
}

@media (min-width: 1920px) {
    .dss-text-lg-justify {
        text-align:justify!important
    }

    .dss-text-lg-left {
        text-align: left!important
    }

    .dss-text-lg-right {
        text-align: right!important
    }

    .dss-text-lg-center {
        text-align: center!important
    }
}

[class*=" dss-icon-"],[class^=dss-icon-] {
    color: #222;
    direction: ltr;
    font-family: SantanderIcons!important;
    font-size: 24px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-style: normal;
    font-weight: 400!important;
    height: 24px;
    letter-spacing: normal;
    line-height: 24px;
    text-align: center;
    text-transform: none;
    white-space: nowrap;
    width: 24px
}

.dss-icon-old {
    font-family: SantanderWebFont!important
}

.dss-icon--small:before {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    width: 16px
}

.dss-icon--medium,.dss-icon--medium:before {
    font-size: 32px;
    height: 32px;
    line-height: 32px;
    width: 32px
}

.dss-icon--large,.dss-icon--large:before {
    font-size: 40px;
    height: 40px;
    line-height: 40px;
    width: 40px
}

.dss-icon--extra-large,.dss-icon--extra-large:before {
    font-size: 48px;
    height: 48px;
    line-height: 48px;
    width: 48px
}

.dss-icon--hover {
    border-radius: 4px;
    transition-duration: .1s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-icon--hover:hover {
    background-color: #eef6f8
}

.dss-position-static {
    position: static!important
}

.dss-position-relative {
    position: relative!important
}

.dss-position-absolute {
    position: absolute!important
}

.dss-position-fixed {
    position: fixed!important
}

.dss-position-sticky {
    position: sticky!important
}

.dss-top-0 {
    top: 0!important
}

.dss-top-50 {
    top: 50%!important
}

.dss-top-100 {
    top: 100%!important
}

.dss-right-0 {
    right: 0!important
}

.dss-right-50 {
    right: 50%!important
}

.dss-right-100 {
    right: 100%!important
}

.dss-bottom-0 {
    bottom: 0!important
}

.dss-bottom-50 {
    bottom: 50%!important
}

.dss-bottom-100 {
    bottom: 100%!important
}

.dss-left-0 {
    left: 0!important
}

.dss-left-50 {
    left: 50%!important
}

.dss-left-100 {
    left: 100%!important
}

.dss-translate-middle {
    transform: translate(-50%,-50%)!important
}

.dss-translate-middle-x {
    transform: translateX(-50%)!important
}

.dss-translate-middle-y {
    transform: translateY(-50%)!important
}

.dss-scrollbar {
    scrollbar-color: #ccc transparent;
    scrollbar-width: thin
}

.dss-scrollbar::-webkit-scrollbar {
    height: 8px;
    width: 8px
}

.dss-scrollbar::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 8px
}

.dss-scrollbar::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: #ccc;
    border-radius: 8px;
    border: 2px solid transparent
}

@media (-ms-high-contrast:none) {
    .dss-scrollbar {
        scrollbar-3dlight-color: #ccc;
        scrollbar-arrow-color:transparent;scrollbar-base-color:transparent;scrollbar-darkshadow-color: #ccc;
        scrollbar-face-color:#ccc;scrollbar-highlight-color:#ccc;scrollbar-shadow-color:#ccc;scrollbar-track-color:transparent}
}

.dss-scrollbar-measure {
    height: 50px;
    overflow: scroll;
    position: absolute;
    top: -9999px;
    width: 50px
}

.dss-body,.dss-display1,.dss-display2,.dss-display3,.dss-figure1,.dss-figure2,.dss-figure3,.dss-figure4,.dss-h1,.dss-h2,.dss-h3 {
    color: #222;
    font-weight: 400;
    text-align: left
}

.dss-display1 {
    font-size: 42px;
    line-height: 1.23809524
}

.dss-display1,.dss-display2 {
    font-family: SantanderHeadline,sans-serif
}

.dss-display2 {
    font-size: 36px;
    line-height: 1.22222222
}

.dss-display3 {
    font-family: SantanderHeadline,sans-serif;
    font-size: 48px;
    line-height: 1.25
}

.dss-figure1 {
    font-size: 40px
}

.dss-figure1,.dss-figure2 {
    font-family: SantanderMicroText,sans-serif;
    font-weight: 700;
    line-height: 1.5
}

.dss-figure2 {
    font-size: 32px
}

.dss-figure3 {
    font-size: 24px;
    line-height: 1.5
}

.dss-figure3,.dss-figure4 {
    font-family: SantanderMicroText,sans-serif;
    font-weight: 700
}

.dss-figure4 {
    font-size: 18px;
    line-height: 1.55555556
}

.dss-h1 {
    font-size: 28px;
    line-height: 1.14285714
}

.dss-h1,.dss-h2 {
    font-family: SantanderHeadline,sans-serif
}

.dss-h2 {
    font-size: 24px;
    line-height: 1.33333333
}

.dss-h3 {
    font-family: SantanderHeadline,sans-serif;
    font-size: 20px;
    line-height: 1.2
}

.dss-body {
    font-size: 16px;
    line-height: 1.5
}

.dss-body,.dss-caption {
    font-family: SantanderMicroText,sans-serif
}

.dss-caption {
    color: #444;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429;
    text-align: left
}

.dss-bold {
    font-weight: 700
}

.dss-color-red-light4 {
    color: #fde5e5
}

.dss-color-red-light3 {
    color: #e5abab
}

.dss-color-red-light2 {
    color: #f57f7f
}

.dss-color-red-light1 {
    color: #f14c4c
}

.dss-color-red {
    color: #ec0000
}

.dss-color-red-dark1 {
    color: #c00
}

.dss-color-red-dark2 {
    color: #900
}

.dss-color-gray-light3 {
    color: #fbfbfb
}

.dss-color-gray-light2 {
    color: #f0f0f0
}

.dss-color-gray-light1 {
    color: #ccc
}

.dss-color-gray {
    color: #999
}

.dss-color-gray-dark1 {
    color: #767676
}

.dss-color-gray-dark2 {
    color: #444
}

.dss-color-gray-dark3 {
    color: #222
}

.dss-color-black {
    color: #000
}

.dss-color-white {
    color: #fff
}

.dss-color-cyan {
    color: #5ab8ca
}

.dss-color-yellow {
    color: #f2a51a
}

.dss-color-orange {
    color: #f88200
}

.dss-color-green-light1 {
    color: #d1e5b9
}

.dss-color-green {
    color: #739e41
}

.dss-color-blue-gray {
    color: #6f7779
}

.dss-color-blue-light5 {
    color: #bde3ea
}

.dss-color-blue-light4 {
    color: #cedee7
}

.dss-color-blue-light3 {
    color: #deedf2
}

.dss-color-blue-light2 {
    color: #eef6f8
}

.dss-color-blue-light1 {
    color: #f5f9fb
}

.dss-color-blue {
    color: #9bc3d3
}

.dss-color-brown {
    color: #ae9576
}

.dss-color-pink {
    color: #9e3667
}

@media (min-width: 768px) {
    .dss-display1 {
        font-size:60px;
        line-height: 1.2
    }

    .dss-display2 {
        font-size: 42px;
        line-height: 1.23809524
    }
}

.dss-accordion {
    background-color: #fff;
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    list-style: none;
    padding: 16px;
    width: 100%
}

.dss-accordion__item-header {
    align-items: center;
    cursor: pointer;
    display: flex;
    padding-bottom: 16px;
    padding-top: 16px;
    position: relative
}

.dss-accordion__item-header:hover {
    background-color: #eef6f8
}

.dss-accordion__item-title {
    font-size: 16px;
    line-height: 1.5
}

.dss-accordion__item-subtitle {
    color: #444;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    line-height: 1.28571429
}

.dss-accordion__item-icon {
    margin-right: 8px
}

.dss-accordion__item-number {
    font-weight: 700;
    margin-right: 16px
}

.dss-accordion__item-icon-arrow {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    transition-duration: .2s;
    transition-property: transform;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-accordion__item-body {
    animation-delay: 0ms,.4s;
    animation-duration: .4s,.1s;
    animation-fill-mode: both;
    animation-name: dss-accordion-slide-in-down,dss-accordion-fade-in;
    animation-timing-function: cubic-bezier(0,0,.2,1);
    position: relative;
    z-index: 1
}

.dss-accordion__item {
    border-bottom: 1px solid #ccc;
    overflow: hidden
}

.dss-accordion__item.dss-accordion__item--filter {
    overflow: initial
}

.dss-accordion__item.dss-accordion__item--active .dss-accordion__item-icon-arrow {
    transform: translateY(-50%) rotate(180deg)
}

.dss-accordion__item.dss-accordion__item--close .dss-accordion__item-body {
    animation-delay: 0ms,.1s;
    animation-duration: .1s,.4s;
    animation-name: dss-accordion-fade-out,dss-accordion-slide-out-up;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    opacity: 0
}

.dss-accordion.dss-accordion--py-1 .dss-accordion__item-body,.dss-accordion.dss-accordion--py-1 .dss-accordion__item-header {
    padding-bottom: 8px;
    padding-top: 8px
}

.dss-accordion.dss-accordion--py-3 .dss-accordion__item-body,.dss-accordion.dss-accordion--py-3 .dss-accordion__item-header {
    padding-bottom: 24px;
    padding-top: 24px
}

@media (min-width: 1920px) {
    .dss-accordion {
        font-size:16px;
        padding: 24px
    }

    .dss-accordion__item-header {
        line-height: 24px;
        padding-bottom: 24px;
        padding-top: 24px
    }

    .dss-accordion__item-title {
        font-size: 16px;
        line-height: 24px
    }

    .dss-accordion__item-subtitle {
        font-size: 14px;
        line-height: 18px
    }

    .dss-accordion__item-number {
        margin-right: 24px
    }

    .dss-accordion__item-body {
        padding-bottom: 24px;
        padding-top: 24px
    }

    .dss-accordion.dss-accordion--py-1 .dss-accordion__item-body,.dss-accordion.dss-accordion--py-1 .dss-accordion__item-header {
        padding-bottom: 16px;
        padding-top: 16px
    }

    .dss-accordion.dss-accordion--py-3 .dss-accordion__item-body,.dss-accordion.dss-accordion--py-3 .dss-accordion__item-header {
        padding-bottom: 32px;
        padding-top: 32px
    }
}

@keyframes dss-accordion-slide-in-down {
    0% {
        max-height: 0;
        padding-bottom: 0;
        padding-top: 0;
        transform: scaleY(0);
        transform-origin: top
    }

    to {
        max-height: none;
        padding-bottom: 16px;
        padding-top: 16px;
        transform: scaleY(1);
        transform-origin: top
    }
}

@keyframes dss-accordion-slide-out-up {
    0% {
        max-height: none;
        padding-bottom: 16px;
        padding-top: 16px;
        transform: scaleY(1);
        transform-origin: top
    }

    to {
        max-height: 0;
        padding-bottom: 0;
        padding-top: 0;
        transform: scaleY(0);
        transform-origin: top
    }
}

@keyframes dss-accordion-fade-in {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes dss-accordion-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.dss-avatar {
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    padding: 4px
}

.dss-avatar:not([class*=dss-icon]) {
    cursor: default;
    font-family: SantanderHeadline,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5
}

.dss-avatar--type-default {
    background-color: #c00;
    color: #fff
}

.dss-avatar--type-sky {
    background-color: #9bc3d3;
    color: #fff
}

.dss-avatar--type-neutral {
    background-color: #f0f0f0;
    color: #222
}

.dss-avatar.dss-avatar--size-default {
    height: 32px;
    width: 32px
}

.dss-avatar.dss-avatar--size-extra-large {
    height: 48px;
    width: 48px
}

.dss-avatar.dss-avatar--size-extra-large:not([class*=dss-icon]) {
    font-size: 24px;
    line-height: 24px
}

.dss-alert-banner-wrapper {
    display: block
}

.dss-alert-banner {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-alert-banner-fade-in;
    animation-timing-function: cubic-bezier(0,0,.2,1);
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    display: block;
    padding: 16px;
    width: 100%
}

.dss-alert-banner--close {
    animation-duration: .1s;
    animation-fill-mode: both;
    animation-name: dss-alert-banner-fade-out;
    animation-timing-function: cubic-bezier(.6,0,1,1)
}

.dss-alert-banner__body {
    align-items: center;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    width: 100%
}

.dss-alert-banner__icon-info {
    margin-right: 8px
}

.dss-alert-banner__icon-info--large-text {
    align-self: flex-start;
    margin-top: -4px
}

.dss-alert-banner__actions {
    display: block;
    margin-left: 32px;
    margin-top: 8px
}

.dss-alert-banner__actions .dss-button:not(:last-of-type) {
    margin-right: 16px
}

@media (min-width: 768px) {
    .dss-alert-banner--only-one-button,.dss-alert-banner__actions {
        align-items:center;
        display: flex
    }

    .dss-alert-banner__actions {
        justify-content: flex-end;
        margin-left: 0;
        margin-top: 0
    }
}

@media (min-width: 1920px) {
    .dss-alert-banner {
        padding-left:24px;
        padding-right: 24px
    }

    .dss-alert-banner__icon-info {
        margin-right: 16px
    }
}

@keyframes dss-alert-banner-fade-in {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes dss-alert-banner-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.dss-alert-toast {
    animation-duration: .4s;
    animation-name: dss-alert-toast-slide-in-down;
    animation-timing-function: cubic-bezier(0,0,.2,1);
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 8px -2px rgba(34,34,34,.4);
    display: block;
    left: 0;
    margin: 0 auto;
    padding: 16px;
    position: fixed;
    right: 0;
    top: 48px;
    transition-delay: .25s;
    transition-duration: 165ms;
    transition-property: top;
    transition-timing-function: cubic-bezier(0,0,.2,1);
    width: calc(100% - 32px);
    z-index: 10000
}

.dss-alert-toast--close {
    animation-duration: .1s;
    animation-name: dss-alert-toast-fade-out;
    animation-timing-function: cubic-bezier(.6,0,1,1)
}

.dss-alert-toast__body {
    align-items: flex-start;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    width: calc(100% - 32px)
}

.dss-alert-toast__icon-info {
    margin-right: 8px
}

.dss-alert-toast__actions {
    display: block;
    margin-left: 32px;
    margin-top: 8px
}

.dss-alert-toast__icon-close {
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 16px
}

@keyframes dss-alert-toast-slide-in-down {
    0% {
        top: -100%
    }

    to {
        top: 48px
    }
}

@media (min-width: 768px) {
    .dss-alert-toast {
        display:flex;
        padding-bottom: 8px;
        padding-top: 8px;
        top: 120px;
        width: 70%
    }

    .dss-alert-toast,.dss-alert-toast__body {
        align-items: center
    }

    .dss-alert-toast__body {
        flex: 1;
        width: auto
    }

    .dss-alert-toast__actions {
        margin-left: 16px;
        margin-right: 48px;
        margin-top: 0
    }

    @keyframes dss-alert-toast-slide-in-down {
        0% {
            top: -100%
        }

        to {
            top: 120px
        }
    }
}

@media (min-width: 1920px) {
    .dss-alert-toast {
        padding:16px 24px;
        top: 200px;
        width: 50%
    }

    .dss-alert-toast__icon-info {
        margin-right: 16px
    }

    .dss-alert-toast__actions {
        margin-left: 24px
    }

    .dss-alert-toast__icon-close {
        right: 24px;
        top: 26px
    }

    @keyframes dss-alert-toast-slide-in-down {
        0% {
            top: -100%
        }

        to {
            top: 200px
        }
    }
}

@keyframes dss-alert-toast-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.dss-background-status {
    background-color: #fff
}

.dss-background-status--1 {
    background-color: #f5f9fb
}

.dss-background-status--2 {
    background-color: #deedf2
}

.dss-background-status--3 {
    background-color: #f5f9fb;
    border-radius: 4px;
    border: 4px solid #deedf2
}

.dss-badge__content {
    border-radius: 4px;
    border: 1px solid #fff;
    color: #fff;
    display: inline;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 700;
    height: 24px;
    line-height: 18px;
    overflow: hidden;
    padding: 2px 8px;
    pointer-events: none;
    text-align: center;
    white-space: nowrap;
    z-index: 1000
}

.dss-badge__content--one-caracter {
    display: inline-block;
    position: absolute;
    top: -9px;
    width: 32px
}

.dss-badge__content--two-caracter {
    display: inline-block;
    position: absolute;
    top: -9px;
    width: 34px
}

.dss-badge__content--three-caracter {
    display: inline-block;
    position: absolute;
    top: -9px;
    width: 42px
}

.dss-badge {
    overflow: visible!important;
    position: relative
}

.dss-badge--default .dss-badge__content {
    background-color: #c00
}

.dss-badge--dark .dss-badge__content {
    background-color: #222
}

.dss-badge--success .dss-badge__content {
    background-color: #739e41
}

.dss-badge.dss-button .dss-badge__content {
    top: -12px
}

.dss-badge.dss-button .dss-badge__content--one-caracter {
    right: -16px
}

.dss-badge.dss-button .dss-badge__content--two-caracter {
    right: -18px
}

.dss-badge.dss-button .dss-badge__content--three-caracter {
    right: -26px
}

.dss-badge[class*=dss-icon] .dss-badge__content {
    top: -11px
}

.dss-badge[class*=dss-icon] .dss-badge__content--one-caracter {
    right: -19px
}

.dss-badge[class*=dss-icon] .dss-badge__content--two-caracter {
    right: -21px
}

.dss-badge[class*=dss-icon] .dss-badge__content--three-caracter {
    right: -29px
}

.dss-badge.dss-icon--small .dss-badge__content {
    top: -15px
}

.dss-badge.dss-icon--small .dss-badge__content--one-caracter {
    right: -23px
}

.dss-badge.dss-icon--small .dss-badge__content--two-caracter {
    right: -25px
}

.dss-badge.dss-icon--small .dss-badge__content--three-caracter {
    right: -33px
}

.dss-badge.dss-icon--medium .dss-badge__content {
    top: -8px
}

.dss-badge.dss-icon--medium .dss-badge__content--one-caracter {
    right: -15px
}

.dss-badge.dss-icon--medium .dss-badge__content--two-caracter {
    right: -17px
}

.dss-badge.dss-icon--medium .dss-badge__content--three-caracter {
    right: -25px
}

.dss-badge.dss-icon--large .dss-badge__content {
    top: -4px
}

.dss-badge.dss-icon--large .dss-badge__content--one-caracter {
    right: -11px
}

.dss-badge.dss-icon--large .dss-badge__content--two-caracter {
    right: -13px
}

.dss-badge.dss-icon--large .dss-badge__content--three-caracter {
    right: -21px
}

.dss-badge.dss-icon--extra-large .dss-badge__content {
    top: 0
}

.dss-badge.dss-icon--extra-large .dss-badge__content--one-caracter {
    right: -7px
}

.dss-badge.dss-icon--extra-large .dss-badge__content--two-caracter {
    right: -11px
}

.dss-badge.dss-icon--extra-large .dss-badge__content--three-caracter {
    right: -17px
}

.dss-breadcrumb {
    background-color: #fff;
    list-style: none
}

.dss-breadcrumb__link>a {
    color: #c00;
    cursor: pointer;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    text-decoration: underline;
    transition-duration: .1s;
    transition-property: color;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-breadcrumb__link>a:hover {
    color: #900
}

.dss-breadcrumb__item {
    align-items: center;
    display: inline-flex
}

.dss-breadcrumb__item:last-of-type .dss-breadcrumb__link>* {
    pointer-events: none
}

.dss-breadcrumb__icon {
    margin-left: 8px;
    margin-right: 8px
}

.dss-breadcrumb__title>h1,.dss-breadcrumb__title>h2,.dss-breadcrumb__title>h3,.dss-breadcrumb__title>h4,.dss-breadcrumb__title>h5,.dss-breadcrumb__title>h6 {
    color: #222;
    font-family: SantanderHeadline,sans-serif;
    font-size: 32px;
    font-weight: 400;
    line-height: 1.5;
    margin-top: 4px
}

@media (max-width: 1920px) {
    .dss-breadcrumb__link>a {
        font-size:16px;
        line-height: 24px
    }

    .dss-breadcrumb__title>h1,.dss-breadcrumb__title>h2,.dss-breadcrumb__title>h3,.dss-breadcrumb__title>h4,.dss-breadcrumb__title>h5,.dss-breadcrumb__title>h6 {
        font-size: 32px;
        line-height: 48px
    }
}

.dss-button {
    appearance: none;
    border-radius: 4px;
    color: #c00;
    cursor: pointer;
    display: inline-block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    height: 40px;
    line-height: 24px;
    max-width: 288px;
    min-width: 58px;
    overflow: hidden;
    padding: 8px;
    text-align: center;
    text-decoration: underline;
    text-overflow: ellipsis;
    transition-duration: .1s;
    transition-property: color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    vertical-align: middle;
    white-space: nowrap
}

.dss-button:disabled,.dss-button[disabled] {
    cursor: not-allowed
}

.dss-button:focus {
    outline: 0
}

.dss-button:focus:not(:disabled):not([disabled]) {
    box-shadow: 0 0 0 4px #bde3ea
}

.dss-button--text {
    background-color: transparent;
    border: none
}

.dss-button--text:hover {
    color: #900
}

.dss-button--text:disabled,.dss-button--text[disabled] {
    color: #ccc
}

.dss-button--primary {
    background-color: #c00;
    border: none;
    color: #fff;
    height: 48px;
    line-height: 32px;
    max-width: 320px;
    min-width: 88px;
    padding: 8px 16px;
    text-decoration: none;
    transform: scale(1);
    transition-duration: .1s;
    transition-property: background-color,transform;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-button--primary:hover {
    background-color: #900
}

.dss-button--primary:disabled,.dss-button--primary[disabled] {
    background-color: #ccc;
    color: #fff
}

.dss-button--secondary {
    background-color: #fff;
    border: 1px solid #c00;
    color: #c00;
    height: 48px;
    line-height: 30px;
    max-width: 320px;
    min-width: 88px;
    padding: 8px 16px;
    text-decoration: none;
    transform: scale(1);
    transition-duration: .1s;
    transition-property: background-color,transform;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-button--secondary:hover {
    background-color: #fde5e5;
    border-color: #900;
    color: #900
}

.dss-button--secondary:disabled,.dss-button--secondary[disabled] {
    background-color: #fff;
    border-color: #ccc;
    color: #ccc
}

.dss-button--icon-button {
    background-color: transparent;
    border: none;
    height: 48px;
    line-height: 32px;
    padding: 8px 16px;
    text-decoration: none
}

.dss-button--icon-button [class*=dss-icon] {
    color: #c00;
    margin-right: 8px;
    vertical-align: text-top
}

.dss-button--icon-button:hover {
    background-color: #fde5e5;
    color: #900
}

.dss-button--icon-button:hover [class*=dss-icon] {
    color: #900
}

.dss-button--icon-button:disabled,.dss-button--icon-button[disabled] {
    background-color: transparent;
    color: #ccc
}

.dss-button--icon-button:disabled [class*=dss-icon],.dss-button--icon-button[disabled] [class*=dss-icon] {
    color: #ccc
}

.dss-button--clicked.dss-button--primary,.dss-button--clicked.dss-button--secondary {
    transform: scale(.95)
}

.dss-webview.dss-button {
    max-width: none;
    width: 100%
}

@media (min-width: 1920px) {
    .dss-button {
        font-size:16px
    }

    .dss-button--primary {
        height: 56px;
        line-height: 40px;
        max-width: 360px;
        min-width: 104px
    }

    .dss-button--secondary {
        height: 56px;
        line-height: 38px;
        max-width: 360px;
        min-width: 104px
    }
}

.dss-calendar {
    background-color: #fff;
    border-radius: 4px;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    height: 391px;
    padding: 24px 12px 16px 16px;
    text-align: center;
    width: 284px
}

.dss-calendar__nav {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 252px
}

.dss-calendar__title.dss-button {
    text-overflow: clip
}

.dss-calendar__title--month {
    min-width: 33px
}

.dss-calendar__title--year {
    min-width: 42px
}

.dss-calendar__nav-item {
    align-items: center;
    display: flex
}

.dss-calendar__nav-item--year,.dss-calendar__nav-item--years {
    justify-content: space-between;
    width: 100%
}

.dss-calendar__nav-item--years .dss-calendar__title {
    color: inherit;
    text-decoration: none
}

.dss-calendar__previous {
    cursor: pointer;
    margin-right: 4px
}

.dss-calendar__next {
    cursor: pointer;
    margin-left: 4px
}

.dss-calendar__content {
    margin: 16px auto 0;
    width: 252px
}

.dss-calendar__labels {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
    width: 100%
}

.dss-calendar__label {
    height: 28px;
    line-height: 28px;
    width: 36px
}

.dss-calendar__list {
    border-top: 1px solid #ccc;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    padding-top: 16px;
    width: 100%
}

.dss-calendar__day,.dss-calendar__month,.dss-calendar__year {
    border-radius: 4px;
    color: #444;
    display: block;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    text-align: center
}

.dss-calendar__day {
    width: 32px
}

.dss-calendar__month {
    margin-bottom: 8px;
    width: 80px
}

.dss-calendar__year {
    margin-bottom: 8px;
    width: 59px
}

.dss-calendar__item {
    margin: 4px 0;
    padding-right: 4px
}

.dss-calendar__item--today .dss-calendar__day {
    border-radius: 50%;
    border: 1px solid #ccc
}

.dss-calendar__item--active .dss-calendar__day {
    background-color: #ec0000;
    border-radius: 50%;
    color: #fff;
    cursor: pointer
}

.dss-calendar__item--active .dss-calendar__month,.dss-calendar__item--active .dss-calendar__year {
    background-color: #deedf2
}

.dss-calendar__item--disabled .dss-calendar__day,.dss-calendar__item--disabled .dss-calendar__month,.dss-calendar__item--disabled .dss-calendar__year {
    color: #ccc;
    cursor: not-allowed;
    pointer-events: none
}

.dss-calendar__item:not(.dss-calendar__item--disabled).dss-calendar__item--range-end .dss-calendar__day,.dss-calendar__item:not(.dss-calendar__item--disabled).dss-calendar__item--range-start .dss-calendar__day {
    background-color: #ec0000;
    border-radius: 50%;
    color: #fff;
    cursor: pointer
}

.dss-calendar__item:not(.dss-calendar__item--disabled):not(.dss-calendar__item--empty):not(.dss-calendar__item--range-start):not(.dss-calendar__item--range-end):not(.dss-calendar__item--active):hover .dss-calendar__day,.dss-calendar__item:not(.dss-calendar__item--disabled):not(.dss-calendar__item--empty):not(.dss-calendar__item--range-start):not(.dss-calendar__item--range-end):not(.dss-calendar__item--active):hover .dss-calendar__month,.dss-calendar__item:not(.dss-calendar__item--disabled):not(.dss-calendar__item--empty):not(.dss-calendar__item--range-start):not(.dss-calendar__item--range-end):not(.dss-calendar__item--active):hover .dss-calendar__year {
    background-color: #eef6f8;
    border-color: transparent;
    cursor: pointer
}

.dss-calendar__item:not(.dss-calendar__item--disabled).dss-calendar__item--range-start {
    background-color: #eef6f8;
    background-image: linear-gradient(90deg,#fff 0 50%,#eef6f8 0 50%)
}

.dss-calendar__item:not(.dss-calendar__item--disabled).dss-calendar__item--range-start.dss-calendar__item--range-start-selected {
    background-color: #deedf2;
    background-image: linear-gradient(90deg,#fff 0 50%,#deedf2 0 50%)
}

.dss-calendar__item:not(.dss-calendar__item--disabled).dss-calendar__item--range-end {
    background-color: #deedf2;
    background-image: linear-gradient(270deg,#fff 0 50%,#deedf2 0 50%)
}

.dss-calendar__item:not(.dss-calendar__item--disabled).dss-calendar__item--range {
    background-color: #eef6f8
}

.dss-calendar__item:not(.dss-calendar__item--disabled).dss-calendar__item--range.dss-calendar__item--range-selected {
    background-color: #deedf2
}

.dss-calendar__item--event {
    position: relative
}

.dss-calendar__item--event:after {
    background-color: #5ab8ca;
    border-radius: 50%;
    bottom: 2px;
    content: "";
    height: 4px;
    left: calc(50% - 2px);
    position: absolute;
    transform: translateX(-50%);
    width: 4px
}

.dss-calendar__item--event.dss-calendar__item--active:after {
    bottom: 4px
}

.dss-calendar__item--event.dss-calendar__item--active:after,.dss-calendar__item--event.dss-calendar__item--range-end:after,.dss-calendar__item--event.dss-calendar__item--range-start:after,.dss-card-list {
    background-color: #fff
}

.dss-card-list {
    align-items: center;
    display: flex;
    overflow-x: auto;
    width: 100%
}

.dss-card-list dss-card-option:not(:last-of-type) .dss-card-option-feature,.dss-card-list dss-card-option:not(:last-of-type) .dss-card-option-icon,.dss-card-list dss-card-option:not(:last-of-type) .dss-card-option-number {
    margin-right: 12px
}

.dss-card-list dss-card-option:not(:first-of-type) .dss-card-option-feature,.dss-card-list dss-card-option:not(:first-of-type) .dss-card-option-icon,.dss-card-list dss-card-option:not(:first-of-type) .dss-card-option-number {
    margin-left: 12px
}

.dss-card-list--column {
    flex-direction: column;
    justify-content: center
}

.dss-card-list--column dss-card-option:not(:last-of-type) .dss-card-option-text {
    margin-bottom: 12px
}

.dss-card-list--column dss-card-option:not(:first-of-type) .dss-card-option-text {
    margin-top: 12px
}

.dss-card {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    box-shadow: 0 2px 8px 0 rgba(34,34,34,.4);
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    transition-duration: .1s;
    transition-property: border-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 100%
}

.dss-card:hover:not(.dss-card--selected) {
    border-color: #444
}

.dss-card--selected {
    border-color: #c00
}

@media (min-width: 768px) {
    .dss-card-list {
        align-items:normal;
        display: block
    }
}

.dss-card-option-feature {
    background-color: #fff;
    cursor: pointer;
    display: inline-block;
    margin: 16px;
    padding: 16px;
    position: relative;
    width: 230px
}

.dss-card-option-feature__option {
    position: absolute;
    right: 16px;
    top: 16px
}

.dss-card-option-feature__option .dss-checkbox,.dss-card-option-feature__option .dss-radio-group__item {
    min-height: 24px;
    padding: 0;
    pointer-events: none
}

.dss-card-option-feature__option .dss-checkbox__label:before,.dss-card-option-feature__option .dss-radio-group__label:before {
    margin-right: 0
}

.dss-card-option-feature__feature,.dss-card-option-feature__label {
    color: #444;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429;
    text-align: left;
    word-wrap: break-word
}

.dss-card-option-feature__number {
    color: #222;
    font-family: SantanderHeadline,sans-serif;
    font-size: 28px;
    font-weight: 400;
    line-height: 1.14285714;
    text-align: left;
    word-wrap: break-word
}

.dss-card-option-feature__list {
    list-style: none
}

.dss-card-option-feature__item {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    pointer-events: none
}

.dss-card-option-feature__status--no-check {
    color: #f14c4c
}

.dss-card-option-feature__status--check {
    color: #739e41
}

@media (min-width: 1920px) {
    .dss-card-option-feature {
        margin:24px;
        padding: 24px;
        width: 310px
    }

    .dss-card-option-feature__option {
        right: 24px;
        top: 24px
    }

    .dss-card-option-feature__item {
        margin-bottom: 16px
    }
}

.dss-card-option-icon {
    background-color: #fff;
    cursor: pointer;
    display: inline-block;
    margin: 16px;
    padding: 16px;
    position: relative;
    width: 212px
}

.dss-card-option-icon__option {
    position: absolute;
    right: 16px;
    top: 16px
}

.dss-card-option-icon__option .dss-checkbox,.dss-card-option-icon__option .dss-radio-group__item {
    min-height: 24px;
    padding: 0;
    pointer-events: none
}

.dss-card-option-icon__option .dss-checkbox__label:before,.dss-card-option-icon__option .dss-radio-group__label:before {
    margin-right: 0
}

.dss-card-option-icon__wrapper-icon {
    margin-bottom: 4px
}

.dss-card-option-icon__label {
    color: #222;
    font-family: SantanderHeadline,sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 1.33333333;
    text-align: left;
    word-wrap: break-word
}

@media (min-width: 768px) {
    .dss-card-option-icon {
        width:312px
    }
}

@media (min-width: 1920px) {
    .dss-card-option-icon {
        margin:24px;
        padding: 24px;
        width: 366px
    }

    .dss-card-option-icon__option {
        right: 24px;
        top: 24px
    }

    .dss-card-option-icon__wrapper-icon {
        margin-bottom: 16px
    }

    .dss-card-option-icon__wrapper-icon [class*=dss-icon-],.dss-card-option-icon__wrapper-icon [class*=dss-icon-]:before,.dss-card-option-icon__wrapper-icon [class^=dss-icon-],.dss-card-option-icon__wrapper-icon [class^=dss-icon-]:before {
        font-size: 56px;
        height: 56px;
        line-height: 56px;
        width: 56px
    }
}

.dss-card-option-number {
    background-color: #fff;
    cursor: pointer;
    display: inline-block;
    margin: 16px;
    padding: 16px;
    position: relative;
    width: 160px
}

.dss-card-option-number__option {
    position: absolute;
    right: 16px;
    top: 16px
}

.dss-card-option-number__option .dss-checkbox,.dss-card-option-number__option .dss-radio-group__item {
    min-height: 24px;
    padding: 0;
    pointer-events: none
}

.dss-card-option-number__option .dss-checkbox__label:before,.dss-card-option-number__option .dss-radio-group__label:before {
    margin-right: 0
}

.dss-card-option-number__wrapper-icon {
    margin-bottom: 4px
}

.dss-card-option-number__label {
    color: #444;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429;
    text-align: left;
    word-wrap: break-word
}

.dss-card-option-number__number {
    color: #222;
    font-family: SantanderHeadline,sans-serif;
    font-size: 28px;
    font-weight: 400;
    line-height: 1.14285714;
    text-align: left;
    word-wrap: break-word
}

@media (min-width: 1920px) {
    .dss-card-option-number {
        margin:24px;
        padding: 24px;
        width: 238px
    }

    .dss-card-option-number__option {
        right: 24px;
        top: 24px
    }

    .dss-card-option-number__wrapper-icon {
        margin-bottom: 8px
    }
}

.dss-card-option-text {
    background-color: #fff;
    cursor: pointer;
    display: flex;
    margin: 16px;
    padding: 16px;
    position: relative;
    width: 260px
}

.dss-card-option-text__option {
    position: absolute;
    right: 16px;
    top: 16px
}

.dss-card-option-text__option .dss-checkbox,.dss-card-option-text__option .dss-radio-group__item {
    min-height: 24px;
    padding: 0;
    pointer-events: none
}

.dss-card-option-text__option .dss-checkbox__label:before,.dss-card-option-text__option .dss-radio-group__label:before {
    margin-right: 0
}

.dss-card-option-text__wrapper-icon {
    align-items: center;
    border-radius: 4px;
    border: 1px solid #f0f0f0;
    display: flex;
    height: 32px;
    justify-content: center;
    margin-right: 16px;
    width: 40px
}

.dss-card-option-text__wrapper-text {
    padding-right: 8px;
    width: calc(100% - 80px)
}

.dss-card-option-text__label {
    color: #222;
    font-size: 16px;
    line-height: 1.5
}

.dss-card-option-text__description,.dss-card-option-text__label {
    font-family: SantanderMicroText,sans-serif;
    font-weight: 400;
    text-align: left;
    word-wrap: break-word
}

.dss-card-option-text__description {
    color: #444;
    font-size: 14px;
    line-height: 1.28571429
}

@media (min-width: 768px) {
    .dss-card-option-text {
        width:312px
    }

    .dss-card-option-text__wrapper-icon {
        height: 48px;
        width: 64px
    }

    .dss-card-option-text__wrapper-text {
        padding-right: 16px;
        width: calc(100% - 104px)
    }
}

@media (min-width: 1920px) {
    .dss-card-option-text {
        margin:24px;
        padding: 24px;
        width: 366px
    }

    .dss-card-option-text__option {
        right: 24px;
        top: 24px
    }

    .dss-card-option-text__wrapper-text {
        padding-right: 16px;
        width: calc(100% - 112px)
    }
}

.dss-carousel {
    background-color: #fff;
    display: block;
    overflow: hidden;
    width: 100%
}

.dss-carousel__items {
    border-radius: 4px;
    display: block;
    position: relative;
    width: 100%;
    z-index: 1
}

.dss-carousel__items--fade .dss-carousel__item {
    border-radius: 4px;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition-duration: .4s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 100%;
    z-index: 1
}

.dss-carousel__items--fade .dss-carousel__item--active {
    opacity: 1;
    z-index: 10
}

.dss-carousel__items--slide {
    align-items: center;
    display: flex;
    overflow-y: hidden;
    transition-duration: .4s;
    transition-property: transform;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-carousel__items--slide,.dss-carousel__items--slide dss-carousel-item {
    position: relative;
    width: 100%
}

dss-carousel:not(.dss-carousel--no-height-limit) .dss-carousel__item-img {
    border-radius: 4px;
    height: auto;
    max-height: 337px;
    width: 100%
}

.dss-carousel__item-img {
    max-width: 100%;
    border-radius: 4px;
    height: auto
}

.dss-carousel__item-title {
    color: #fff;
    display: block;
    font-family: SantanderHeadline,sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 1.33333333;
    width: 100%
}

.dss-carousel__item-description {
    color: #fff;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    width: 100%
}

.dss-carousel__caption {
    background-image: linear-gradient(transparent,#222);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    bottom: 0;
    display: block;
    left: 0;
    padding: 16px;
    position: absolute;
    width: 100%
}

.dss-carousel__nav {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    padding: 4px;
    position: relative;
    z-index: 10
}

.dss-carousel__nav-next,.dss-carousel__nav-prev {
    border-radius: 4px;
    cursor: pointer;
    font-family: SantanderMicroText,sans-serif;
    outline: 0
}

.dss-carousel__nav-next:focus:not(.dss-carousel__nav-prev--disabled):not(.dss-carousel__nav-next--disabled),.dss-carousel__nav-prev:focus:not(.dss-carousel__nav-prev--disabled):not(.dss-carousel__nav-next--disabled) {
    box-shadow: 0 0 0 4px #bde3ea
}

.dss-carousel__nav-next--disabled,.dss-carousel__nav-prev--disabled {
    color: #ccc;
    cursor: not-allowed
}

.dss-carousel__nav-next [class*=dss-icon-],.dss-carousel__nav-prev [class*=dss-icon-] {
    color: inherit
}

.dss-carousel__nav-items {
    list-style: none
}

.dss-carousel__nav-item {
    cursor: pointer;
    display: inline-block
}

.dss-carousel__nav-item:not(:last-of-type) {
    margin-right: 8px
}

@media (min-width: 768px) {
    .dss-carousel--side-nav .dss-carousel {
        position:relative
    }

    .dss-carousel--side-nav .dss-carousel__items {
        margin: 0 auto;
        width: 90%
    }

    .dss-carousel--side-nav .dss-carousel__nav {
        margin-top: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%
    }

    .dss-carousel--side-nav .dss-carousel__nav-item {
        display: none
    }
}

@media (min-width: 1920px) {
    .dss-carousel__items {
        height:438px
    }

    .dss-carousel__item img {
        max-height: 438px
    }

    .dss-carousel__item-title {
        font-size: 24px;
        line-height: 32px
    }

    .dss-carousel__item-description {
        font-size: 16px;
        line-height: 24px
    }
}

.dss-container {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    width: 100%
}

.dss-container--elevation-1 {
    box-shadow: 0 2px 8px -2px rgba(34,34,34,.4)
}

.dss-container--elevation-2 {
    box-shadow: 0 2px 16px -2px rgba(34,34,34,.4)
}

.dss-countdown,.dss-countdown__time {
    align-items: center;
    display: inline-flex
}

.dss-countdown {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 16px
}

.dss-countdown--description {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 288px;
    padding-bottom: 16px;
    padding-top: 16px;
    width: 100%
}

.dss-countdown--description .dss-countdown__time {
    margin-bottom: 16px
}

.dss-countdown--action {
    align-items: normal;
    display: flex;
    flex-direction: column;
    max-width: 288px;
    width: 100%
}

.dss-countdown__icon {
    margin-right: 8px
}

.dss-countdown__value {
    font-weight: 700;
    margin-right: 4px
}

.dss-countdown__label:not(:last-of-type) {
    margin-right: 16px
}

.dss-countdown__description {
    color: #444;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    line-height: 1.28571429;
    margin-top: 16px
}

.dss-countdown__action,.dss-countdown__text {
    display: block
}

.dss-countdown__action .dss-button {
    margin-left: -8px
}

@media (min-width: 768px) {
    .dss-countdown--action {
        align-items:center;
        display: inline-flex;
        flex-direction: row;
        max-width: none;
        min-height: 58px;
        min-width: 400px;
        width: auto
    }

    .dss-countdown__text {
        display: inline-block
    }

    .dss-countdown__text:after {
        content: "\\00A0"
    }

    .dss-countdown__action {
        align-items: center;
        display: flex;
        justify-content: space-between;
        width: 100%
    }
}

.dss-data-table {
    background-color: #f0f0f0;
    position: relative
}

.dss-data-table .dss-option-button {
    padding-left: 0;
    padding-right: 0
}

.dss-data-table__header {
    padding: 16px 24px
}

.dss-data-table__header .dss-form-field {
    max-width: 300px
}

.dss-data-table__title {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 16px
}

.dss-data-table__label {
    align-items: center;
    cursor: pointer;
    display: flex
}

.dss-data-table__sorting {
    cursor: pointer;
    height: 16px;
    margin-left: 16px;
    margin-right: 16px;
    position: relative;
    width: 16px
}

.dss-data-table__sorting:after,.dss-data-table__sorting:before {
    border-style: solid;
    content: "";
    cursor: pointer;
    display: inline-block;
    height: 0;
    left: 0;
    position: absolute;
    width: 0
}

.dss-data-table__sorting:before {
    border-color: transparent transparent #ccc;
    border-width: 0 8px 8px;
    top: 0
}

.dss-data-table__sorting:after {
    border-color: #ccc transparent transparent;
    border-width: 8px 8px 0;
    top: 16px
}

.dss-data-table__sorting--asc:before {
    border-bottom-color: #c00
}

.dss-data-table__sorting--asc:after {
    border-top-color: #ccc
}

.dss-data-table__sorting--desc:before {
    border-bottom-color: #ccc
}

.dss-data-table__sorting--desc:after {
    border-top-color: #c00
}

.dss-data-table__not-found-message {
    background-color: #fff;
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 16px;
    padding: 24px;
    text-align: center
}

.dss-data-table__not-found-wrapper:not(:empty)+.dss-data-table__not-found-message {
    display: none
}

@media (min-width: 768px) {
    .dss-data-table__header {
        padding-bottom:16px;
        padding-top: 24px
    }

    .dss-data-table__header .dss-form-field {
        max-width: 524px;
        min-width: 300px
    }

    .dss-data-table thead th[dssSort] {
        cursor: pointer
    }

    .dss-data-table thead th[dssSort]:hover .dss-data-table__sorting:before {
        border-bottom-color: #222
    }

    .dss-data-table thead th[dssSort]:hover .dss-data-table__sorting--asc:before {
        border-bottom-color: #ccc
    }

    .dss-data-table thead th[dssSort]:hover .dss-data-table__sorting--asc:after {
        border-top-color: #222
    }

    .dss-data-table thead th[dssSort]:hover .dss-data-table__sorting--desc:before {
        border-bottom-color: #222
    }

    .dss-data-table thead th[dssSort]:hover .dss-data-table__sorting--desc:after {
        border-top-color: #ccc
    }
}

.dss-dialog {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-dialog-fade-in;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    bottom: 0;
    height: 100%;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 10000
}

.dss-dialog--close {
    animation-delay: .1s;
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-dialog-fade-out;
    animation-timing-function: cubic-bezier(.8,0,.4,1)
}

.dss-dialog__content {
    animation-delay: .2s;
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-dialog-zoom-in;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 16px -2px rgba(34,34,34,.4);
    padding: 16px;
    position: absolute;
    top: 50%;
    width: 100%
}

.dss-dialog__content--close {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-dialog-zoom-out;
    animation-timing-function: cubic-bezier(.8,0,.4,1)
}

.dss-dialog__header {
    font-family: SantanderHeadline,sans-serif;
    font-size: 24px;
    line-height: 1.33333333;
    margin-bottom: 8px
}

.dss-dialog__body,.dss-dialog__header {
    color: #222;
    display: block;
    font-weight: 400;
    width: 100%
}

.dss-dialog__body {
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 16px
}

.dss-dialog__footer {
    display: flex;
    flex-direction: column-reverse
}

.dss-dialog__footer .dss-button {
    max-width: none
}

.dss-dialog__footer .dss-button:not(:first-of-type) {
    margin-bottom: 16px
}

@keyframes dss-dialog-fade-in {
    0% {
        background-color: transparent
    }

    to {
        background-color: rgba(0,0,0,.6)
    }
}

@keyframes dss-dialog-fade-out {
    0% {
        background-color: rgba(0,0,0,.6)
    }

    to {
        background-color: transparent
    }
}

@keyframes dss-dialog-zoom-in {
    0% {
        opacity: 0;
        transform: translateY(-50%) scale(.6)
    }

    to {
        opacity: 1;
        transform: translateY(-50%) scale(1)
    }
}

@keyframes dss-dialog-zoom-out {
    0% {
        opacity: 1;
        transform: translateY(-50%)
    }

    to {
        opacity: 0;
        transform: translateY(-50%)
    }
}

@media (min-width: 768px) {
    .dss-dialog__content {
        left:50%;
        max-width: 560px;
        padding: 32px 24px
    }

    .dss-dialog__body {
        margin-bottom: 32px
    }

    .dss-dialog__footer {
        flex-direction: row;
        justify-content: flex-end
    }

    .dss-dialog__footer .dss-button {
        max-width: 320px
    }

    .dss-dialog__footer .dss-button:not(:first-of-type) {
        margin-bottom: 0;
        margin-left: 24px
    }

    @keyframes dss-dialog-zoom-in {
        0% {
            opacity: 0;
            transform: translate(-50%,-50%) scale(.6)
        }

        to {
            opacity: 1;
            transform: translate(-50%,-50%) scale(1)
        }
    }

    @keyframes dss-dialog-zoom-out {
        0% {
            opacity: 1;
            transform: translate(-50%,-50%)
        }

        to {
            opacity: 0;
            transform: translate(-50%,-50%)
        }
    }
}

@media (min-width: 768px) and (-ms-high-contrast:none) {
    .dss-dialog__content {
        left:calc(50% - 280px)
    }
}

@media (min-width: 1920px) {
    .dss-dialog__content {
        max-width:576px;
        padding: 32px
    }

    .dss-dialog__header {
        font-size: 24px;
        line-height: 32px
    }

    .dss-dialog__body {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 40px
    }

    .dss-dialog__footer .dss-button:not(:first-of-type) {
        margin-left: 32px
    }
}

.dss-divider {
    background-color: #ccc;
    border: none;
    height: 1px;
    width: 100%
}

.dss-divider--1 {
    background-color: #999
}

.dss-divider--2 {
    background-color: #767676
}

.dss-divider--3 {
    background-color: #444
}

.dss-download {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    padding: 16px
}

.dss-download--default .dss-download__button.dss-button {
    align-self: flex-end;
    margin-top: 24px;
    width: 100%
}

.dss-download--list .dss-download__button.dss-button {
    align-self: flex-end;
    margin-top: 40px;
    width: 100%
}

.dss-download__wrapper {
    align-items: center;
    display: flex;
    flex-wrap: wrap
}

.dss-download__icon {
    margin-right: 8px
}

.dss-download__title {
    color: #222;
    font-size: 16px;
    line-height: 1.5;
    width: calc(100% - 40px)
}

.dss-download__description,.dss-download__title {
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-weight: 400
}

.dss-download__description {
    color: #444;
    font-size: 14px;
    line-height: 1.28571429;
    margin-top: 16px;
    width: 100%
}

.dss-download__list {
    list-style: none
}

.dss-download__item {
    border-bottom: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    padding-top: 16px;
    width: 100%
}

.dss-download__item .dss-download__title {
    width: 100%
}

.dss-download__item .dss-download__description {
    margin-top: 0
}

.dss-download__item .dss-download__item-button.dss-button {
    align-self: flex-end;
    margin-top: 24px;
    max-width: 320px;
    text-decoration: none;
    width: 100%
}

@media (min-width: 768px) {
    .dss-download {
        display:block;
        flex-direction: row;
        padding: 24px;
        position: relative
    }

    .dss-download--default {
        align-items: center;
        display: flex;
        max-width: 696px
    }

    .dss-download--default .dss-download__description {
        margin-left: 40px;
        margin-top: 0
    }

    .dss-download--default .dss-download__button.dss-button {
        align-self: auto;
        margin-top: 0;
        width: auto
    }

    .dss-download--list {
        max-width: 568px;
        padding-bottom: 96px
    }

    .dss-download--list .dss-download__description {
        margin-left: 0;
        margin-top: 0
    }

    .dss-download--list .dss-download__button.dss-button {
        align-self: auto;
        bottom: 24px;
        margin-top: 0;
        position: absolute;
        right: 24px;
        width: auto
    }

    .dss-download__wrapper {
        align-items: flex-start;
        flex: 1
    }

    .dss-download__item {
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 24px;
        padding-top: 24px
    }

    .dss-download__item .dss-download__item-button.dss-button {
        align-self: auto;
        margin-right: 16px;
        margin-top: 0;
        width: auto
    }
}

@media (min-width: 1920px) {
    .dss-download--default .dss-download__description {
        font-size:14px;
        line-height: 18px;
        margin-left: 48px
    }

    .dss-download__icon {
        margin-right: 16px
    }

    .dss-download__title {
        font-size: 16px;
        line-height: 24px;
        width: calc(100% - 48px)
    }
}

.dss-drawer__content {
    background-color: #fff;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    min-width: 100vw
}

.dss-drawer__header {
    align-items: center;
    background-color: inherit;
    display: flex;
    font-family: SantanderHeadline,sans-serif;
    font-size: 24px;
    font-weight: 400;
    justify-content: space-between;
    line-height: 1.33333333;
    padding: 16px;
    position: relative;
    z-index: 10
}

.dss-drawer__icon {
    cursor: pointer;
    margin-left: 16px
}

.dss-drawer__body {
    background-color: inherit;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 16px;
    position: relative;
    z-index: 1
}

.dss-drawer__footer {
    align-items: center;
    background-color: inherit;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    left: 0;
    padding: 16px;
    position: absolute;
    right: 0;
    z-index: 10
}

.dss-drawer {
    animation-duration: .5s;
    animation-fill-mode: both;
    animation-name: dss-drawer-fade-in;
    animation-timing-function: cubic-bezier(0,0,.2,1);
    bottom: 0;
    height: 100%;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 10000
}

.dss-drawer .dss-drawer__header {
    height: 84px
}

.dss-drawer .dss-drawer__body {
    height: calc(100vh - 166px)
}

.dss-drawer .dss-drawer__footer {
    height: 80px
}

.dss-drawer.dss-drawer--header .dss-drawer__header {
    height: 84px
}

.dss-drawer.dss-drawer--header .dss-drawer__body {
    height: calc(100vh - 86px)
}

.dss-drawer.dss-drawer--footer .dss-drawer__header,.dss-drawer.dss-drawer--header .dss-drawer__footer {
    display: none
}

.dss-drawer.dss-drawer--footer .dss-drawer__body {
    height: calc(100vh - 82px)
}

.dss-drawer.dss-drawer--footer .dss-drawer__footer {
    height: 80px
}

.dss-drawer.dss-drawer--scroll .dss-drawer__footer,.dss-drawer.dss-drawer--scroll .dss-drawer__header {
    box-shadow: 0 2px 8px -2px rgba(34,34,34,.4)
}

.dss-drawer:not(.dss-drawer--aside) .dss-drawer__content {
    animation-duration: .5s;
    animation-fill-mode: both;
    animation-name: dss-drawer-slide-in-up;
    animation-timing-function: cubic-bezier(0,0,.2,1)
}

.dss-drawer.dss-drawer--aside .dss-drawer__content {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-drawer-slide-in-right;
    animation-timing-function: cubic-bezier(0,0,.2,1)
}

.dss-drawer.dss-drawer--close {
    animation-name: dss-drawer-fade-out;
    animation-timing-function: cubic-bezier(.6,0,1,1)
}

.dss-drawer.dss-drawer--close:not(.dss-drawer--aside) .dss-drawer__content {
    animation-name: dss-drawer-slide-out-down;
    animation-timing-function: cubic-bezier(.6,0,1,1)
}

.dss-drawer.dss-drawer--close.dss-drawer--aside .dss-drawer__content {
    animation-name: dss-drawer-slide-out-left;
    animation-timing-function: cubic-bezier(.6,0,1,1)
}

@media (min-width: 768px) {
    .dss-drawer:not(.dss-drawer--aside) .dss-drawer__content {
        border-top-left-radius:8px;
        border-top-right-radius: 8px;
        border: 1px solid #ccc;
        bottom: 0;
        box-shadow: 0 2px 8px -2px rgba(34,34,34,.4);
        height: 85vh;
        left: 10.5vw;
        min-height: 0;
        min-width: 0;
        position: absolute;
        width: 79vw
    }

    .dss-drawer:not(.dss-drawer--aside) .dss-drawer__header {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 24px
    }

    .dss-drawer:not(.dss-drawer--aside) .dss-drawer__icon {
        margin-left: 24px
    }

    .dss-drawer:not(.dss-drawer--aside) .dss-drawer__body {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        height: calc(85vh - 166px);
        padding: 24px
    }

    .dss-drawer:not(.dss-drawer--aside) .dss-drawer__footer {
        justify-content: center;
        padding: 24px
    }

    .dss-drawer:not(.dss-drawer--aside).dss-drawer--header .dss-drawer__body {
        height: calc(85vh - 86px)
    }

    .dss-drawer:not(.dss-drawer--aside).dss-drawer--footer .dss-drawer__body {
        height: calc(85vh - 82px)
    }

    .dss-drawer.dss-drawer--aside .dss-drawer__content {
        border-bottom-left-radius: 8px;
        border-top-left-radius: 8px;
        box-shadow: 0 2px 8px -2px rgba(34,34,34,.4);
        height: 100vh;
        min-width: 0;
        position: absolute;
        right: 0;
        width: 40vw
    }

    .dss-drawer.dss-drawer--aside .dss-drawer__header {
        border-top-left-radius: 8px
    }

    .dss-drawer.dss-drawer--aside .dss-drawer__body {
        border-bottom-left-radius: 8px;
        border-top-left-radius: 8px
    }

    .dss-drawer.dss-drawer--aside .dss-drawer__footer {
        border-bottom-left-radius: 8px
    }
}

@keyframes dss-drawer-fade-in {
    0% {
        background-color: transparent
    }

    to {
        background-color: rgba(0,0,0,.6)
    }
}

@keyframes dss-drawer-fade-out {
    0% {
        background-color: rgba(0,0,0,.6)
    }

    to {
        background-color: transparent
    }
}

@keyframes dss-drawer-slide-in-up {
    0% {
        transform: translateY(100%)
    }

    to {
        transform: translateY(0)
    }
}

@keyframes dss-drawer-slide-out-down {
    0% {
        transform: translateY(0)
    }

    to {
        transform: translateY(100%)
    }
}

@keyframes dss-drawer-slide-in-right {
    0% {
        transform: translateX(100%)
    }

    to {
        transform: translateX(0)
    }
}

@keyframes dss-drawer-slide-out-left {
    0% {
        transform: translateX(0)
    }

    to {
        transform: translateX(100%)
    }
}

.dss-cascader__select {
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    color: #444;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    justify-content: space-between;
    line-height: 1.5;
    min-height: 48px;
    outline: 0;
    padding: 8px 56px 8px 16px;
    transition-duration: .6s;
    transition-property: border-color;
    transition-timing-function: cubic-bezier(.25,.8,.25,1);
    width: 100%
}

.dss-cascader__select:hover {
    border-color: #444
}

.dss-cascader__select:focus {
    border-color: #5ab8ca
}

.dss-cascader__select:disabled {
    border-color: #ccc;
    color: #ccc;
    cursor: inherit
}

.dss-cascader .dss-form-field__label {
    pointer-events: none
}

.dss-cascader--active .dss-form-field__label {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-cascader--open .dss-cascader__select {
    border-color: #5ab8ca
}

.dss-cascader--open .dss-cascader__options {
    display: flex
}

.dss-cascader--open .dss-form-field__label {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-cascader--open .dss-form-field__right-icon {
    transform: rotate(180deg)
}

.dss-cascader.dss-form-field--error .dss-cascader__select {
    border-color: #f14c4c
}

.dss-cascader.dss-form-field--success .dss-cascader__select {
    border-color: #739e41
}

.dss-cascader .dss-form-field__right-icon {
    transition-duration: .2s;
    transition-property: transform;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-cascader__go-back {
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: none;
    position: absolute;
    width: 100%;
    z-index: 101
}

.dss-cascader__go-back:hover {
    background-color: #eef6f8
}

.dss-cascader__go-back-link {
    align-items: center;
    color: #444;
    cursor: pointer;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 16px;
    text-decoration: none;
    width: 100%
}

.dss-cascader__go-back-label {
    margin-left: 8px
}

.dss-cascader__options {
    animation-duration: .2s;
    animation-fill-mode: backwards;
    animation-name: dss-cascader-options-slide-in-down;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 8px 0 rgba(34,34,34,.4);
    display: none;
    max-width: 292px;
    position: absolute;
    top: 52px;
    width: 100%;
    z-index: 1000
}

.dss-cascader__options .dss-flyout-menu {
    position: absolute;
    top: 0;
    z-index: 100
}

.dss-cascader__options .dss-flyout-menu__item {
    min-height: 40px
}

.dss-cascader__options .dss-flyout-menu__label {
    margin-left: 0
}

.dss-cascader__options--close {
    opacity: 0;
    transition-duration: .2s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-cascader__options--go-back .dss-cascader__go-back {
    display: block
}

.dss-cascader__options--go-back .dss-flyout-menu {
    padding-top: 42px
}

.dss-cascader__wrapper--bottom-page .dss-cascader__options {
    bottom: calc(100% + 16px);
    top: auto
}

@media (min-width: 768px) {
    .dss-cascader__options .dss-flyout-menu {
        position:static;
        top: auto
    }

    .dss-cascader__options--level .dss-flyout-menu:first-of-type {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0
    }

    .dss-cascader__options--level .dss-flyout-menu:last-of-type {
        border-bottom-left-radius: 0;
        border-left: 1px solid #ccc;
        border-top-left-radius: 0
    }

    .dss-cascader__options--level .dss-flyout-menu:nth-of-type(1n+2):not(:last-of-type) {
        border-left: 1px solid #ccc;
        border-radius: initial
    }
}

@media (min-width: 1920px) {
    .dss-cascader__go-back-link,.dss-cascader__select {
        font-size:16px;
        line-height: 24px
    }
}

@keyframes dss-cascader-options-slide-in-down {
    0% {
        opacity: 0;
        transform: scaleY(.6);
        transform-origin: center top
    }

    to {
        opacity: 1;
        transform: scaleY(1);
        transform-origin: center top
    }
}

.dss-checkbox__label {
    align-items: flex-start;
    color: #222;
    cursor: pointer;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    position: relative
}

.dss-checkbox__label:before {
    background-color: transparent;
    border-radius: 4px;
    border: 2px solid #c00;
    content: "";
    display: inline-block;
    flex: 0 1 24px;
    height: 24px;
    margin-right: 8px;
    transition-duration: .2s;
    transition-property: border-color,box-shadow;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 24px
}

.dss-checkbox__label-content {
    flex: 1
}

.dss-checkbox__icon-checked,.dss-checkbox__icon-indeterminate {
    background-color: #c00;
    border-radius: 4px;
    height: 24px;
    left: 0;
    position: absolute;
    top: 0;
    transition-duration: .2s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 24px
}

.dss-checkbox__icon-checked svg {
    fill: #fff
}

.dss-checkbox__icon-checked.dss-checkbox__icon-checked--enter,.dss-checkbox__icon-checked.dss-checkbox__icon-checked--leave {
    animation-duration: .1s;
    animation-name: dss-fade-checkbox;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-checkbox__icon-checked.dss-checkbox__icon-checked--enter svg,.dss-checkbox__icon-checked.dss-checkbox__icon-checked--leave svg {
    animation-duration: .2s;
    animation-name: dss-checked;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-checkbox__icon-checked.dss-checkbox__icon-checked--leave {
    animation-direction: reverse;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-checkbox__icon-checked.dss-checkbox__icon-checked--leave svg {
    animation-direction: reverse;
    animation-duration: .2s;
    animation-fill-mode: both;
    fill: #fff
}

.dss-checkbox__icon-indeterminate line {
    stroke: #fff;
    stroke-width: 2px
}

.dss-checkbox__icon-indeterminate line:last-of-type {
    stroke: transparent;
    transition-delay: .2s;
    transition-duration: .2s;
    transition-property: stroke,stroke-width;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-checkbox__icon-indeterminate.dss-checkbox__icon-indeterminate--enter line,.dss-checkbox__icon-indeterminate.dss-checkbox__icon-indeterminate--leave line {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-checked-indeterminate;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-checkbox__icon-indeterminate.dss-checkbox__icon-indeterminate--leave line {
    animation-direction: reverse
}

.dss-checkbox__icon-indeterminate.dss-checkbox__icon-indeterminate--enter line:last-of-type {
    stroke: #fff;
    stroke-width: 8px
}

.dss-checkbox {
    align-items: center;
    display: flex;
    min-height: 40px;
    padding: 8px;
    width: 100%
}

.dss-checkbox--checked .dss-checkbox__label:before,.dss-checkbox--indeterminate .dss-checkbox__label:before {
    border-color: #c00
}

.dss-checkbox--disabled .dss-checkbox__label {
    color: #ccc;
    cursor: not-allowed
}

.dss-checkbox--disabled .dss-checkbox__label:before {
    border-color: #ccc;
    box-shadow: none
}

.dss-checkbox--checked.dss-checkbox--disabled .dss-checkbox__icon-checked,.dss-checkbox--checked.dss-checkbox--disabled .dss-checkbox__icon-indeterminate,.dss-checkbox--indeterminate.dss-checkbox--disabled .dss-checkbox__icon-checked,.dss-checkbox--indeterminate.dss-checkbox--disabled .dss-checkbox__icon-indeterminate {
    background-color: #ccc
}

.dss-checkbox--checked:not(.dss-checkbox--disabled) .dss-checkbox__label:hover:before,.dss-checkbox--indeterminate:not(.dss-checkbox--disabled) .dss-checkbox__label:hover:before,.dss-checkbox:not(.dss-checkbox--disabled) .dss-checkbox__label:hover:before {
    border-color: #900
}

.dss-checkbox--checked:not(.dss-checkbox--disabled) .dss-checkbox__label:hover .dss-checkbox__icon-checked,.dss-checkbox--checked:not(.dss-checkbox--disabled) .dss-checkbox__label:hover .dss-checkbox__icon-indeterminate,.dss-checkbox--indeterminate:not(.dss-checkbox--disabled) .dss-checkbox__label:hover .dss-checkbox__icon-checked,.dss-checkbox--indeterminate:not(.dss-checkbox--disabled) .dss-checkbox__label:hover .dss-checkbox__icon-indeterminate {
    background-color: #900
}

.dss-checkbox__input {
    height: 0;
    opacity: 0;
    width: 0
}

.dss-checkbox__input:focus+.dss-checkbox__label:before {
    box-shadow: 0 0 0 4px #bde3ea
}

@keyframes dss-fade-checkbox {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes dss-checked {
    0% {
        transform: scale(0) rotate(45deg)
    }

    to {
        transform: scale(1) rotate(0)
    }
}

@keyframes dss-checked-indeterminate {
    0% {
        transform: rotate(0) translate(0)
    }

    to {
        transform: rotate(-45deg) translate(-10px,7px)
    }
}

.dss-datepicker-range-wrapper,.dss-datepicker-wrapper {
    position: relative
}

.dss-datepicker-range-wrapper .dss-datepicker.dss-form-field {
    min-width: 320px
}

.dss-datepicker__placeholder {
    background-color: #fff;
    color: #767676;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    left: 18px;
    line-height: 1.5;
    pointer-events: none;
    position: absolute;
    top: 10px
}

.dss-datepicker__range {
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
    width: 100%
}

.dss-datepicker__range .dss-datepicker__input {
    border: none!important;
    box-shadow: none!important
}

.dss-datepicker__range .dss-datepicker__input--active:not(:disabled),.dss-datepicker__range .dss-datepicker__input:focus {
    box-shadow: none;
    outline: 0
}

.dss-datepicker__range .dss-datepicker__placeholder:last-of-type {
    left: 147px;
    width: 152px
}

.dss-datepicker--error .dss-datepicker__range {
    border-color: #f14c4c
}

.dss-datepicker:not(.dss-datepicker--disabled):not(.dss-datepicker--error) .dss-datepicker__range--active {
    border-color: #5ab8ca
}

.dss-datepicker--disabled .dss-datepicker__range {
    border-color: #ccc;
    color: #ccc
}

.dss-datepicker__input.dss-datepicker__input--start {
    margin-right: 8px;
    padding-right: 0!important;
    width: 120px
}

.dss-datepicker__input.dss-datepicker__input--start:not([value*="/"]),.dss-datepicker__input.dss-datepicker__input--start:not([value]) {
    width: 128px
}

.dss-datepicker__input.dss-datepicker__input--start:not([value*="/"])~.dss-datepicker__placeholder:last-of-type,.dss-datepicker__input.dss-datepicker__input--start:not([value])~.dss-datepicker__placeholder:last-of-type {
    left: 152px
}

@media (-ms-high-contrast:none) {
    .dss-datepicker__input.dss-datepicker__input--start {
        margin-right: 16px
    }
}

.dss-datepicker__input.dss-datepicker__input--end {
    padding-right: 40px!important;
    width: calc(100% - 120px)
}

.dss-datepicker__range-filter {
    position: relative;
    width: 285px
}

.dss-datepicker__range-filter:after {
    border-bottom: 1px solid #ccc;
    bottom: 0;
    content: "";
    left: 16px;
    position: absolute;
    width: 253px
}

.dss-datepicker__range-filter .dss-tag__list>dss-tag:last-child .dss-tag__item {
    margin-right: 16px
}

.dss-datepicker__range-filter-title {
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.28571429;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px
}

.dss-datepicker-calendars {
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    left: 0;
    position: absolute;
    top: 100%;
    z-index: 1000
}

.dss-datepicker-calendars .dss-datepicker-calendars__range:first-of-type {
    display: block
}

.dss-datepicker-calendars .dss-datepicker-calendars__range:last-of-type {
    display: none
}

.dss-datepicker-calendars--bottom-page {
    bottom: calc(100% + 16px);
    top: auto
}

.dss-datepicker-calendars--last-active .dss-datepicker-calendars__range:first-of-type {
    display: none
}

.dss-datepicker-calendars--last-active .dss-datepicker-calendars__range:last-of-type {
    display: block
}

@media (min-width: 768px) {
    .dss-datepicker__range-filter {
        padding-bottom:16px;
        padding-left: 8px;
        width: auto
    }

    .dss-datepicker__range-filter:after {
        display: none
    }

    .dss-datepicker__range-filter .dss-datepicker__range-filter-title {
        padding-bottom: 8px;
        padding-top: 24px
    }

    .dss-datepicker__range-filter .dss-tag__item {
        margin-left: 16px;
        margin-top: 16px;
        min-width: 130px
    }

    .dss-datepicker__range-filter .dss-separator .dss-tag__item {
        margin-top: 32px
    }

    .dss-datepicker-calendars {
        flex-direction: row;
        max-width: 740px
    }

    .dss-datepicker-calendars .dss-datepicker-calendars__range:first-of-type,.dss-datepicker-calendars .dss-datepicker-calendars__range:last-of-type,.dss-datepicker-calendars--last-active .dss-datepicker-calendars__range:first-of-type,.dss-datepicker-calendars--last-active .dss-datepicker-calendars__range:last-of-type {
        display: block
    }
}

@media (min-width: 1920px) {
    .dss-datepicker__placeholder {
        font-size:16px;
        line-height: 24px
    }

    .dss-datepicker__range .dss-datepicker__placeholder:last-of-type {
        left: 147px
    }

    .dss-datepicker__input.dss-datepicker__input--start {
        width: 120px
    }

    .dss-datepicker__input.dss-datepicker__input--start:not([value*="/"]),.dss-datepicker__input.dss-datepicker__input--start:not([value]) {
        width: 128px
    }

    .dss-datepicker__input.dss-datepicker__input--start:not([value*="/"])~.dss-datepicker__placeholder:last-of-type,.dss-datepicker__input.dss-datepicker__input--start:not([value])~.dss-datepicker__placeholder:last-of-type {
        left: 152px
    }

    .dss-datepicker__input.dss-datepicker__input--end {
        width: calc(100% - 120px)
    }
}

.dss-dropdown__select {
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    color: 1px;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    justify-content: space-between;
    line-height: 1.5;
    min-height: 48px;
    outline: 0;
    padding: 8px 56px 8px 16px;
    transition-duration: .6s;
    transition-property: border-color;
    transition-timing-function: cubic-bezier(.25,.8,.25,1);
    width: 100%
}

.dss-dropdown__select:hover {
    border-color: #444
}

.dss-dropdown__select:focus {
    border-color: #5ab8ca
}

.dss-dropdown__select:disabled {
    border-color: #ccc;
    color: #ccc;
    cursor: inherit
}

.dss-dropdown__select>option,.dss-dropdown__select>span:not(.dss-dropdown__value) {
    align-items: center;
    display: flex
}

.dss-dropdown--active .dss-form-field__label {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-dropdown--open .dss-dropdown__select {
    border-color: #5ab8ca
}

.dss-dropdown--open .dss-form-field__label {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-dropdown--open .dss-form-field__right-icon {
    transform: rotate(180deg)
}

.dss-dropdown.dss-form-field--error .dss-dropdown__select {
    border-color: #f14c4c
}

.dss-dropdown.dss-form-field--success .dss-dropdown__select {
    border-color: #739e41
}

.dss-dropdown .dss-flyout-menu {
    max-width: none
}

.dss-dropdown .dss-flyout-menu__label {
    margin-left: 0
}

.dss-dropdown .dss-checkbox {
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none
}

.dss-dropdown .dss-form-field__right-icon {
    transition-duration: .2s;
    transition-property: transform;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-dropdown__options {
    position: absolute;
    top: 52px
}

.dss-dropdown__option,.dss-dropdown__option>option,.dss-dropdown__option>span {
    align-items: center;
    display: flex
}

.dss-dropdown__value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.dss-dropdown__option-group,.dss-dropdown__quantity {
    color: #444;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429
}

.dss-dropdown__option-group {
    display: block;
    padding: 8px
}

.dss-dropdown__option-group~.dss-divider {
    margin: 0 auto;
    width: calc(100% - 16px)
}

.dss-dropdown__wrapper--bottom-page .dss-dropdown__options {
    bottom: calc(100% + 16px);
    top: auto
}

@media (min-width: 1920px) {
    .dss-dropdown__select {
        font-size:16px;
        line-height: 24px
    }

    .dss-dropdown__select:focus~.dss-form-field__label {
        font-size: 14px;
        line-height: 18px;
        top: -10px
    }

    .dss-dropdown__option-group,.dss-dropdown__quantity {
        font-size: 14px;
        line-height: 18px
    }
}

.dss-form-field__left-icon,.dss-form-field__right-icon {
    background-color: #fff;
    pointer-events: none;
    position: absolute;
    top: 12px
}

.dss-form-field__left-icon--action,.dss-form-field__right-icon--action {
    cursor: pointer;
    pointer-events: auto
}

.dss-form-field__hint-wrapper {
    align-items: center;
    display: flex
}

.dss-form-field__hint-wrapper--start {
    justify-content: flex-start
}

.dss-form-field__hint-wrapper--end {
    justify-content: flex-end
}

.dss-form-field__hint-wrapper--space-between {
    justify-content: space-between
}

.dss-form-field__error-message,.dss-form-field__hint {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    line-height: 1.28571429
}

.dss-form-field__hint {
    display: inline-block
}

.dss-form-field__error-message {
    display: block
}

.dss-form-field__label {
    background-color: #fff;
    color: #444;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    left: 16px;
    line-height: 1.5;
    padding-left: 2px;
    padding-right: 2px;
    position: absolute;
    top: 12px;
    transition-duration: .2s;
    transition-property: top,font-size;
    transition-timing-function: cubic-bezier(.25,.8,.25,1)
}

.dss-form-field__label--active {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-form-field__input {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    color: #444;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    min-height: 48px;
    padding: 8px 16px;
    transition-duration: .2s;
    transition-property: border-color,box-shadow;
    transition-timing-function: cubic-bezier(.25,.8,.25,1);
    width: 100%
}

.dss-form-field__input:hover {
    border-color: #444
}

.dss-form-field__input--active:not(:disabled),.dss-form-field__input:focus {
    border-color: #5ab8ca;
    outline: 0
}

.dss-form-field__input:focus~.dss-form-field__label {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-form-field__input:disabled {
    border-color: #ccc;
    color: #ccc;
    cursor: inherit
}

.dss-form-field {
    border-radius: 4px;
    position: relative;
    width: 100%
}

.dss-form-field.dss-form-field--disabled .dss-form-field__label {
    color: #ccc;
    cursor: inherit
}

.dss-form-field.dss-form-field--error .dss-form-field__label {
    color: #f14c4c
}

.dss-form-field.dss-form-field--success .dss-form-field__label {
    color: #739e41
}

.dss-form-field--right-icon .dss-form-field__input {
    padding-right: 56px
}

.dss-form-field--right-icon .dss-form-field__right-icon {
    right: 16px
}

.dss-form-field--left-icon .dss-form-field__input {
    padding-left: 56px
}

.dss-form-field--left-icon .dss-form-field__label:not(.dss-form-field__label--active) {
    left: 56px
}

.dss-form-field--left-icon .dss-form-field__input:focus~.dss-form-field__label,.dss-form-field--left-icon .dss-form-field__left-icon {
    left: 16px
}

.dss-form-field--disabled {
    cursor: not-allowed
}

.dss-form-field--disabled .dss-form-field__hint,.dss-form-field--disabled .dss-form-field__left-icon,.dss-form-field--disabled .dss-form-field__left-icon:before,.dss-form-field--disabled .dss-form-field__right-icon,.dss-form-field--disabled .dss-form-field__right-icon:before {
    color: #ccc;
    cursor: inherit
}

.dss-form-field--disabled .dss-form-field__left-icon,.dss-form-field--disabled .dss-form-field__right-icon {
    pointer-events: none
}

.dss-form-field--error .dss-form-field__error-message,.dss-form-field--error .dss-form-field__hint,.dss-form-field--error .dss-form-field__left-icon:before,.dss-form-field--error .dss-form-field__right-icon:not(.dss-form-field__icon-clear):before {
    color: #f14c4c
}

.dss-form-field--error .dss-form-field__input {
    border-color: #f14c4c
}

.dss-form-field--success .dss-form-field__hint,.dss-form-field--success .dss-form-field__left-icon:before,.dss-form-field--success .dss-form-field__right-icon:not(.dss-form-field__icon-clear):before {
    color: #739e41
}

.dss-form-field--success .dss-form-field__input {
    border-color: #739e41
}

.dss-form-field__icon-clear {
    visibility: hidden
}

.dss-form-field__icon-clear--visible {
    visibility: visible
}

.dss-form-field__icon-clear--text {
    color: #c00;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    line-height: 1.5;
    text-decoration: underline
}

.dss-form-field__input[rows]~.dss-form-field__icon-clear--text {
    top: 9px
}

@media (min-width: 1920px) {
    .dss-form-field__label {
        font-size:16px;
        line-height: 24px;
        top: 10px
    }

    .dss-form-field__label--active {
        font-size: 14px;
        line-height: 18px;
        top: -10px
    }

    .dss-form-field__input {
        font-size: 16px;
        line-height: 24px
    }

    .dss-form-field__input:focus~.dss-form-field__label {
        font-size: 14px;
        line-height: 18px;
        top: -10px
    }

    .dss-form-field__error-message,.dss-form-field__hint {
        font-size: 14px;
        line-height: 21px
    }

    .dss-form-field__input[rows]~.dss-form-field__icon-clear--text {
        top: 9px
    }
}

.dss-input-number {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.5
}

.dss-input-number--nospotlight {
    font-size: 16px;
    font-weight: 400
}

.dss-input-number__icon-close {
    color: #222!important;
    cursor: pointer;
    pointer-events: auto!important
}

.dss-input-number__icon-close:before {
    color: #222!important
}

.dss-form-field:not(.dss-form-field--error) .dss-input-number__icon-close {
    display: none
}

.dss-radio-group {
    display: block;
    list-style: none;
    width: 100%
}

.dss-radio-group__item {
    align-items: center;
    display: flex;
    min-height: 40px;
    padding: 8px;
    width: 100%
}

.dss-radio-group__item--border {
    border-bottom: 1px solid #ccc
}

.dss-radio-group__label {
    align-items: flex-start;
    color: #222;
    cursor: pointer;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    min-height: 24px;
    position: relative;
    width: 100%
}

.dss-radio-group__label:before {
    background-color: transparent;
    border-radius: 50%;
    border: 2px solid #c00;
    content: "";
    display: inline-block;
    flex: 0 1 24px;
    height: 24px;
    margin-right: 8px;
    transition-duration: .2s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 24px
}

@media (-ms-high-contrast:none) {
    .dss-radio-group__label:before {
        flex-basis: auto;
        flex-grow: 0;
        flex-shrink: 1
    }
}

.dss-radio-group__label-content {
    flex: 1;
    min-height: 24px
}

.dss-radio-group__input {
    height: 0;
    opacity: 0;
    width: 0
}

.dss-radio-group__input:disabled+.dss-radio-group__label {
    color: #ccc;
    cursor: not-allowed
}

.dss-radio-group__input:disabled+.dss-radio-group__label:before {
    background-color: transparent;
    border-color: #ccc;
    box-shadow: none
}

.dss-radio-group__input--checked+.dss-radio-group__label:after {
    animation-duration: .2s;
    animation-name: dss-selected-radio-group;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    background-color: #c00;
    border-radius: 50%;
    content: "";
    height: 14px;
    left: 5px;
    position: absolute;
    top: 5px;
    transform-origin: center center;
    transition-duration: .2s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 14px
}

.dss-radio-group__input--checked:disabled+.dss-radio-group__label:after {
    background-color: #ccc
}

.dss-radio-group__input--checked:not(:disabled)+.dss-radio-group__label:before {
    border-color: #c00
}

.dss-radio-group__input:focus+.dss-radio-group__label:before {
    background-color: #eef6f8;
    box-shadow: 0 0 0 4px #bde3ea
}

.dss-radio-group__input:hover:not(:disabled)+.dss-radio-group__label:before {
    border-color: #900
}

.dss-radio-group__input:hover:not(:disabled)+.dss-radio-group__label:after {
    background-color: #900
}

@keyframes dss-selected-radio-group {
    0% {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

.dss-slider__footer,.dss-slider__header {
    align-items: center;
    color: #444;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    justify-content: space-between;
    line-height: 1.28571429
}

.dss-slider__input-wrapper {
    margin-bottom: 16px;
    margin-top: 16px;
    padding-bottom: 1px;
    padding-top: 1px
}

.dss-slider__track-fill {
    border-radius: 1px;
    height: 100%;
    left: 0;
    top: 0
}

.dss-slider__thumb,.dss-slider__track-fill {
    background-color: #c00;
    display: block;
    position: absolute
}

.dss-slider__thumb {
    border-radius: 50%;
    cursor: grab;
    height: 16px;
    margin-left: -8px;
    margin-top: -8px;
    outline: 0;
    top: 50%;
    touch-action: none;
    width: 16px
}

.dss-slider__thumb:not(.dss-slider__thumb--disabled):focus,.dss-slider__thumb:not(.dss-slider__thumb--disabled):hover {
    background-color: #900;
    box-shadow: 0 0 0 8px rgba(143,0,0,.3)
}

.dss-slider__thumb--dragging {
    cursor: grabbing
}

.dss-slider__thumb--disabled {
    cursor: not-allowed
}

.dss-slider__track {
    background: #767676;
    border-radius: 1px;
    height: 2px;
    position: relative
}

.dss-slider__track--motion .dss-slider__track-fill {
    transition-duration: .2s;
    transition-property: width;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-slider__track--motion .dss-slider__thumb:not(.dss-slider__thumb--dragging) {
    transition-duration: .2s;
    transition-property: background-color,left,box-shadow;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-slider {
    max-width: 288px;
    width: 100%
}

.dss-slider--form-field .dss-form-field {
    display: none
}

.dss-slider--disabled {
    cursor: not-allowed
}

.dss-slider--disabled .dss-slider__footer,.dss-slider--disabled .dss-slider__header {
    color: #ccc
}

.dss-slider--disabled .dss-slider__thumb,.dss-slider--disabled .dss-slider__track,.dss-slider--disabled .dss-slider__track-fill {
    background-color: #ccc
}

@media (min-width: 768px) {
    .dss-slider {
        max-width:344px
    }

    .dss-slider--form-field {
        align-items: center;
        display: flex;
        max-width: 460px
    }

    .dss-slider--form-field>div:first-of-type {
        flex: 1 0 344px
    }

    .dss-slider--form-field .dss-form-field {
        display: block;
        flex: 1 0 100px;
        margin-left: 16px
    }
}

@media (min-width: 1920px) {
    .dss-slider__footer,.dss-slider__header {
        font-size:14px;
        line-height: 18px
    }

    .dss-slider__input-wrapper {
        margin-bottom: 24px;
        margin-top: 24px
    }
}

.dss-toggle {
    align-items: center;
    display: inline-flex;
    justify-content: space-between;
    min-height: 40px;
    padding: 8px;
    position: relative
}

.dss-toggle__label {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    margin-right: 16px
}

.dss-toggle__icon {
    cursor: pointer;
    position: relative
}

.dss-toggle__icon:before {
    background-color: #999;
    border-radius: 14px;
    content: "";
    display: inline-block;
    height: 24px;
    transition-duration: .2s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    vertical-align: middle;
    width: 48px
}

.dss-toggle__icon:after {
    background-color: #fff;
    border-radius: 50%;
    content: "";
    height: 16px;
    left: 4px;
    position: absolute;
    top: 4px;
    transition-duration: .2s;
    transition-property: left;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 16px
}

.dss-toggle.dss-toggle--disabled .dss-toggle__icon {
    color: #ccc;
    cursor: not-allowed
}

.dss-toggle.dss-toggle--disabled .dss-toggle__icon:before {
    background-color: #ccc
}

.dss-toggle.dss-toggle--disabled .dss-toggle__icon:after {
    background-color: #f0f0f0
}

.dss-toggle.dss-toggle--checked:not(.dss-toggle--disabled) .dss-toggle__icon:before {
    background-color: #c00;
    transition-duration: .2s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-toggle.dss-toggle--checked .dss-toggle__icon:after {
    left: 28px;
    transition-duration: .2s;
    transition-property: left;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-toggle__input {
    height: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 0
}

.dss-upload {
    background-color: #fff;
    border-radius: 4px;
    border: 2px dashed #999;
    cursor: pointer;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    min-height: 100px;
    position: relative;
    width: 100%
}

.dss-upload--active,.dss-upload--hover {
    background-color: #5ab8ca;
    border-color: #5ab8ca;
    border-style: solid
}

.dss-upload__input {
    cursor: pointer;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%
}

.dss-upload__text {
    background-color: transparent;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%)
}

.dss-flyout-menu {
    background-color: #fff;
    border-radius: 4px;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    height: auto;
    list-style: none;
    max-height: 260px;
    max-width: 292px;
    overflow-x: auto;
    width: 100%;
    z-index: 1000
}

.dss-flyout-menu--border {
    border: 1px solid #ccc
}

.dss-flyout-menu--close {
    opacity: 0;
    transition-duration: .2s;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(.6,0,1,1)
}

.dss-flyout-menu--animate {
    animation-duration: .2s;
    animation-fill-mode: backwards;
    animation-name: dss-flyout-menu-slide-in-down;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-flyout-menu--animate.dss-flyout-menu--slide-in-vertical-left {
    animation-name: dss-flyout-menu-slide-in-vertical-left
}

.dss-flyout-menu--animate.dss-flyout-menu--slide-in-vertical-right {
    animation-name: dss-flyout-menu-slide-in-vertical-right
}

.dss-flyout-menu__item {
    outline: 0
}

.dss-flyout-menu__item--hover,.dss-flyout-menu__item:hover {
    background-color: #eef6f8
}

.dss-flyout-menu__item--active {
    background-color: #deedf2
}

.dss-flyout-menu__link {
    align-items: center;
    color: #222;
    cursor: pointer;
    display: flex;
    outline: 0;
    padding: 8px 16px;
    text-decoration: none;
    width: 100%
}

.dss-flyout-menu__label {
    margin-left: 8px
}

.dss-flyout-menu.dss-flyout-menu--links .dss-flyout-menu__link {
    justify-content: space-between;
    padding-right: 8px
}

@keyframes dss-flyout-menu-slide-in-down {
    0% {
        opacity: 0;
        transform: scaleY(.6);
        transform-origin: center top
    }

    to {
        opacity: 1;
        transform: scaleY(1);
        transform-origin: center top
    }
}

@keyframes dss-flyout-menu-slide-in-vertical-left {
    0% {
        opacity: 0;
        transform: scale(.6);
        transform-origin: left top
    }

    to {
        opacity: 1;
        transform: scale(1);
        transform-origin: left top
    }
}

@keyframes dss-flyout-menu-slide-in-vertical-right {
    0% {
        opacity: 0;
        transform: scale(.6);
        transform-origin: right top
    }

    to {
        opacity: 1;
        transform: scale(1);
        transform-origin: right top
    }
}

.dss-header {
    background-color: #c00;
    color: #fff;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    height: 56px;
    left: 0;
    line-height: 1.5;
    padding: 16px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000
}

@media (min-width: 768px) {
    .dss-header {
        height:80px
    }
}

.dss-list.dss-list--columned {
    background-color: #fff;
    list-style: none
}

.dss-list.dss-list--columned .dss-list__item {
    border-bottom: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    margin: 0 8px;
    padding: 16px 8px 24px;
    position: relative
}

.dss-list.dss-list--columned .dss-list__item:hover {
    background-color: #eef6f8;
    cursor: pointer
}

.dss-list.dss-list--columned .dss-list__item-title {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: 8px;
    margin-right: 40px;
    text-align: left
}

.dss-list.dss-list--columned .dss-list__item-icon-action {
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: calc(50% - 12px)
}

.dss-list.dss-list--columned .dss-list__item-content {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-right: 40px;
    text-align: left
}

.dss-list.dss-list--columned.dss-list--py-1 .dss-list__item {
    padding-bottom: 8px;
    padding-top: 8px
}

.dss-list.dss-list--columned.dss-list--py-3 .dss-list__item {
    padding-bottom: 24px;
    padding-top: 24px
}

@media (min-width: 768px) {
    .dss-list.dss-list--columned .dss-list__item {
        flex-direction:row
    }

    .dss-list.dss-list--columned .dss-list__item-title {
        flex: 0 0 210px;
        margin-bottom: 0;
        margin-right: 24px
    }
}

@media (min-width: 1920px) {
    .dss-list.dss-list--columned .dss-list__item {
        margin:0 16px;
        padding: 24px 16px 32px
    }

    .dss-list.dss-list--columned .dss-list__item-title {
        flex: 0 0 242px;
        margin-right: 32px
    }

    .dss-list.dss-list--columned .dss-list__item-icon-action {
        right: 16px
    }

    .dss-list.dss-list--columned .dss-list__item-content {
        margin-right: 56px
    }

    .dss-list.dss-list--columned.dss-list--py-1 .dss-list__item {
        padding-bottom: 16px;
        padding-top: 16px
    }

    .dss-list.dss-list--columned.dss-list--py-3 .dss-list__item {
        padding-bottom: 32px;
        padding-top: 32px
    }
}

.dss-list.dss-list--description {
    background-color: #fff;
    list-style: none
}

.dss-list.dss-list--description .dss-list__item {
    border-bottom: 1px solid #ccc;
    display: flex;
    margin: 0 8px;
    padding: 16px 8px 24px;
    position: relative
}

.dss-list.dss-list--description .dss-list__item:hover {
    background-color: #eef6f8;
    cursor: pointer
}

.dss-list.dss-list--description .dss-list__item-icon-info {
    margin-right: 8px
}

.dss-list.dss-list--description .dss-list__item-title {
    color: #222;
    display: block;
    font-family: SantanderHeadline,sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 16px;
    margin-right: 40px;
    text-align: left
}

.dss-list.dss-list--description .dss-list__item-content {
    font-size: 16px;
    line-height: 1.5
}

.dss-list.dss-list--description .dss-list__item-caption,.dss-list.dss-list--description .dss-list__item-content {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-weight: 400;
    margin-right: 40px;
    text-align: left
}

.dss-list.dss-list--description .dss-list__item-caption {
    font-size: 14px;
    line-height: 1.28571429;
    margin-top: 16px
}

.dss-list.dss-list--description .dss-list__item-icon-action {
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: calc(50% - 12px)
}

.dss-list.dss-list--description.dss-list--py-1 .dss-list__item {
    padding-bottom: 8px;
    padding-top: 8px
}

.dss-list.dss-list--description.dss-list--py-3 .dss-list__item {
    padding-bottom: 24px;
    padding-top: 24px
}

@media (min-width: 768px) {
    .dss-list.dss-list--description .dss-list__item-icon-info {
        margin-right:16px
    }

    .dss-list.dss-list--description .dss-list__item-title {
        margin-bottom: 8px
    }

    .dss-list.dss-list--description .dss-list__item-caption {
        margin-top: 8px
    }
}

@media (min-width: 1920px) {
    .dss-list.dss-list--description .dss-list__item {
        margin:0 16px;
        padding: 24px 16px 32px
    }

    .dss-list.dss-list--description .dss-list__item-icon-info {
        margin-right: 24px
    }

    .dss-list.dss-list--description .dss-list__item-caption,.dss-list.dss-list--description .dss-list__item-content,.dss-list.dss-list--description .dss-list__item-title {
        margin-right: 48px
    }

    .dss-list.dss-list--description .dss-list__item-icon-action {
        right: 16px
    }

    .dss-list.dss-list--description.dss-list--py-1 .dss-list__item {
        padding-bottom: 16px;
        padding-top: 16px
    }

    .dss-list.dss-list--description.dss-list--py-3 .dss-list__item {
        padding-bottom: 32px;
        padding-top: 32px
    }
}

.dss-list.dss-list--text {
    background-color: #fff;
    list-style: none
}

.dss-list.dss-list--text .dss-list__item {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    margin: 0 8px;
    padding: 16px 8px
}

.dss-list.dss-list--text .dss-list__item-title {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    text-align: left
}

.dss-list.dss-list--text .dss-list__item-actions>span {
    cursor: pointer;
    margin-left: 16px
}

.dss-list.dss-list--text.dss-list--py-1 .dss-list__item {
    padding-bottom: 8px;
    padding-top: 8px
}

.dss-list.dss-list--text.dss-list--py-3 .dss-list__item {
    padding-bottom: 24px;
    padding-top: 24px
}

@media (min-width: 1920px) {
    .dss-list.dss-list--item .dss-list__item {
        margin:0 16px;
        padding: 24px 16px
    }

    .dss-list.dss-list--item .dss-list__item-actions>span {
        margin-left: 24px
    }

    .dss-list.dss-list--text.dss-list--py-1 .dss-list__item {
        padding-bottom: 16px;
        padding-top: 16px
    }

    .dss-list.dss-list--text.dss-list--py-3 .dss-list__item {
        padding-bottom: 32px;
        padding-top: 32px
    }
}

.dss-list.dss-list--value {
    background-color: #fff;
    list-style: none
}

.dss-list.dss-list--value .dss-list__item {
    border-bottom: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    margin: 0 8px;
    padding: 16px 8px
}

.dss-list.dss-list--value .dss-list__item-title {
    font-weight: 400;
    margin-bottom: 8px
}

.dss-list.dss-list--value .dss-list__item-content,.dss-list.dss-list--value .dss-list__item-title {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    line-height: 1.5;
    text-align: left
}

.dss-list.dss-list--value .dss-list__item-content {
    font-weight: 700
}

.dss-list.dss-list--value.dss-list--py-1 .dss-list__item {
    padding-bottom: 8px;
    padding-top: 8px
}

.dss-list.dss-list--value.dss-list--py-3 .dss-list__item {
    padding-bottom: 24px;
    padding-top: 24px
}

@media (min-width: 768px) {
    .dss-list.dss-list--value .dss-list__item {
        flex-direction:row;
        justify-content: space-between
    }

    .dss-list.dss-list--value .dss-list__item-title {
        margin-bottom: 0
    }

    .dss-list.dss-list--value .dss-list__item-content {
        margin-left: 16px
    }
}

@media (min-width: 1920px) {
    .dss-list.dss-list--value .dss-list__item {
        margin:0 16px;
        padding: 24px 16px
    }

    .dss-list.dss-list--value .dss-list__item-content {
        margin-left: 24px
    }

    .dss-list.dss-list--value.dss-list--py-1 .dss-list__item {
        padding-bottom: 16px;
        padding-top: 16px
    }

    .dss-list.dss-list--value.dss-list--py-3 .dss-list__item {
        padding-bottom: 32px;
        padding-top: 32px
    }
}

.dss-notify {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-notify-slide-in-right;
    animation-timing-function: cubic-bezier(0,0,.2,1);
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 16px -2px rgba(34,34,34,.4);
    max-width: 288px;
    padding: 16px;
    position: fixed;
    right: 16px;
    top: 96px;
    transition-duration: .2s;
    transition-property: top;
    transition-timing-function: cubic-bezier(0,0,.2,1);
    width: 100%;
    z-index: 10000
}

.dss-notify--close {
    animation-name: dss-notify-fade-out;
    animation-timing-function: cubic-bezier(.6,0,1,1)
}

.dss-notify__header {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    position: relative
}

.dss-notify__header>[class*=dss-icon]:not(.dss-notify__icon-close) {
    margin-right: 16px
}

.dss-notify__title {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    width: calc(100% - 64px)
}

.dss-notify__icon-close {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0
}

.dss-notify__body {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429;
    text-align: left
}

.dss-notify__footer {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 16px
}

.dss-notify__footer .dss-button:not(:last-of-type) {
    margin-right: 16px
}

.dss-notify__footer .dss-button:last-of-type {
    margin-right: 24px
}

@media (min-width: 768px) {
    .dss-notify {
        max-width:424px
    }

    .dss-notify__footer {
        justify-content: flex-end
    }
}

@media (min-width: 1920px) {
    .dss-notify {
        padding:24px
    }

    .dss-notify__title {
        width: calc(100% - 72px)
    }
}

@keyframes dss-notify-slide-in-right {
    0% {
        transform: translateX(calc(100% + 24px))
    }

    to {
        transform: translateX(0)
    }
}

@keyframes dss-notify-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.dss-logo {
    display: inline-block
}

.dss-menu__item-icon,.dss-menu__submenu-icon {
    align-self: flex-start;
    margin-right: 8px
}

.dss-menu__item-icon-arrow {
    transition-duration: .1s;
    transition-property: color;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-menu__wrapper-details {
    margin-right: 16px;
    width: calc(100% - 48px)
}

.dss-menu__item-title {
    color: #222;
    display: block;
    font-size: 16px;
    line-height: 1.5;
    width: 100%
}

.dss-menu__item-title--bold {
    font-weight: 700
}

.dss-menu__item-description {
    color: #222;
    display: block;
    font-size: 14px;
    line-height: 1.28571429;
    margin-top: 8px;
    width: 100%
}

.dss-menu__item-description--highlight {
    color: #739e41
}

.dss-menu__submenu-title {
    align-items: center;
    color: #222;
    display: flex;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: 40px;
    padding: 16px
}

.dss-menu-measure {
    display: none
}

.dss-menu,.dss-menu__submenu {
    background-color: #fff;
    border-right: 1px solid #ccc;
    box-shadow: 0 2px 16px -2px rgba(34,34,34,.4);
    font-family: SantanderMicroText,sans-serif;
    font-weight: 400;
    height: 100vh;
    left: -1px;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 0;
    z-index: 1000
}

.dss-menu .dss-divider,.dss-menu__submenu .dss-divider {
    margin: 0 auto;
    width: calc(100% - 32px)
}

.dss-menu--expanded {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-menu-slide-out-right;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-menu--expanded .dss-menu__default {
    animation-delay: .2s;
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-menu-fade-in;
    animation-timing-function: cubic-bezier(.6,0,1,1)
}

.dss-menu--close {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-menu-slide-in-right;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-menu--close .dss-menu__default {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-menu-fade-out;
    animation-timing-function: cubic-bezier(0,0,.2,1)
}

.dss-menu__submenu {
    transform: translateX(-320px)
}

.dss-menu__submenu--expanded {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-submenu-slide-out-right;
    animation-timing-function: cubic-bezier(0,0,.2,1);
    width: 320px
}

.dss-menu__submenu--close {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-submenu-slide-in-right;
    animation-timing-function: cubic-bezier(.6,0,1,1);
    width: 320px
}

.dss-menu__item {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    padding: 16px
}

.dss-menu__item:hover:not(.dss-menu__item--disabled) {
    background-color: #eef6f8
}

.dss-menu__item--go-back~.dss-divider {
    margin-bottom: 40px
}

.dss-menu__item--toggle-menu {
    bottom: 16px;
    position: absolute;
    width: 100%
}

.dss-menu__item--disabled {
    cursor: not-allowed
}

.dss-menu__item--disabled .dss-menu__item-description,.dss-menu__item--disabled .dss-menu__item-icon,.dss-menu__item--disabled .dss-menu__item-icon-arrow,.dss-menu__item--disabled .dss-menu__item-title,.dss-menu__item--disabled .dss-menu__submenu-icon {
    color: #ccc;
    cursor: inherit
}

.dss-menu__item--selected:not(:hover) .dss-menu__item-icon,.dss-menu__item--selected:not(:hover) .dss-menu__item-icon-arrow,.dss-menu__item--selected:not(:hover) .dss-menu__item-title,.dss-menu__item--selected:not(:hover) .dss-menu__submenu-icon {
    color: #c00
}

@keyframes dss-menu-slide-out-right {
    0% {
        left: -1px;
        width: 0
    }

    to {
        left: 0;
        width: 320px
    }
}

@keyframes dss-menu-slide-in-right {
    0% {
        left: 0;
        width: 320px
    }

    to {
        left: -1px;
        width: 0
    }
}

@media (min-width: 768px) {
    .dss-menu__default,.dss-menu__icons {
        height:100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%
    }

    .dss-menu__icons {
        z-index: auto
    }

    .dss-menu__icons .dss-menu__item-icon-arrow {
        display: none
    }

    .dss-menu__default {
        opacity: 0;
        z-index: -1
    }

    .dss-menu__item {
        min-height: 64px;
        outline: 0
    }

    .dss-menu__item:focus-visible {
        box-shadow: 0 0 0 4px #bde3ea
    }

    .dss-menu__item--toggle-menu {
        bottom: 96px
    }

    .dss-menu__item-icon,.dss-menu__submenu-icon {
        align-self: center;
        margin: 0 16px
    }

    .dss-menu__item-icon--item-with-description,.dss-menu__submenu-icon--item-with-description {
        align-self: flex-start;
        margin-top: 4px
    }

    .dss-menu__item-icon-arrow,.dss-menu__wrapper-details {
        overflow: hidden
    }

    .dss-menu-measure {
        display: block;
        flex: 0 0 88px;
        max-width: 88px;
        min-width: 88px;
        transition-duration: .4s;
        transition-property: all;
        transition-timing-function: cubic-bezier(.6,0,.2,1);
        width: 88px
    }

    .dss-menu-measure--expanded {
        flex: 0 0 320px;
        max-width: 320px;
        min-width: 320px;
        width: 320px
    }

    .dss-menu {
        left: 0;
        top: 80px;
        width: 88px
    }

    .dss-menu--expanded .dss-menu__icons {
        animation-duration: .2s;
        animation-fill-mode: both;
        animation-name: dss-menu-fade-out;
        animation-timing-function: cubic-bezier(0,0,.2,1);
        z-index: -1
    }

    .dss-menu--expanded .dss-menu__default {
        z-index: auto
    }

    .dss-menu--close .dss-menu__icons {
        animation-delay: .2s;
        animation-duration: .2s;
        animation-fill-mode: both;
        animation-name: dss-menu-fade-in;
        animation-timing-function: cubic-bezier(.6,0,1,1)
    }

    .dss-menu__submenu {
        top: 80px
    }

    @keyframes dss-menu-slide-out-right {
        0% {
            width: 88px
        }

        to {
            width: 320px
        }
    }

    @keyframes dss-menu-slide-in-right {
        0% {
            width: 320px
        }

        to {
            width: 88px
        }
    }
}

@media (min-width: 1920px) {
    .dss-menu__item-title {
        font-size:16px;
        line-height: 24px
    }

    .dss-menu__item-description {
        font-size: 14px;
        line-height: 18px
    }

    .dss-menu__submenu-title {
        font-size: 16px;
        line-height: 24px
    }
}

@keyframes dss-submenu-slide-out-right {
    0% {
        left: -1px;
        transform: translateX(-320px)
    }

    to {
        left: 0;
        transform: translateX(0)
    }
}

@keyframes dss-submenu-slide-in-right {
    0% {
        left: 0;
        transform: translateX(0)
    }

    to {
        left: -1px;
        transform: translateX(-320px)
    }
}

@keyframes dss-menu-fade-in {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes dss-menu-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.dss-option-button-wrapper {
    display: inline-block;
    position: relative
}

.dss-option-button-wrapper .dss-flyout-menu {
    position: absolute;
    z-index: 1000
}

.dss-option-button-wrapper--bottom-page .dss-flyout-menu {
    bottom: calc(100% + 8px);
    top: auto
}

.dss-option-button-wrapper--change-menu-width .dss-flyout-menu {
    width: auto
}

.dss-option-button-wrapper--template .dss-flyout-menu {
    max-height: 440px
}

.dss-option-button__label--toggle-selection {
    color: #222
}

.dss-option-button__option {
    margin-left: 4px
}

.dss-option-button__count {
    margin-left: 4px;
    margin-right: 4px
}

.dss-option-button {
    appearance: none;
    background-color: #fff;
    border: none;
    border-radius: 4px;
    color: #c00;
    cursor: pointer;
    display: inline-block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    height: 48px;
    line-height: 1.5;
    max-width: 320px;
    min-width: 88px;
    overflow: hidden;
    padding: 8px 16px;
    text-align: center;
    text-overflow: ellipsis;
    transition-duration: .1s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    white-space: nowrap
}

.dss-option-button .dss-option-button__icon:before {
    color: #c00;
    vertical-align: -5px
}

.dss-option-button:disabled {
    color: #ccc;
    cursor: not-allowed
}

.dss-option-button:disabled .dss-option-button__label--toggle-selection {
    color: inherit
}

.dss-option-button:disabled .dss-option-button__icon:before {
    color: #ccc
}

.dss-option-button:focus {
    outline: 0
}

.dss-option-button:focus:not(:disabled) {
    box-shadow: 0 0 0 4px #bde3ea
}

.dss-option-button--active:not(:disabled) {
    background-color: #fde5e5
}

.dss-option-button:hover:not(:disabled) {
    background-color: #fde5e5;
    color: #900
}

.dss-option-button:hover:not(:disabled) .dss-option-button__icon:before,.dss-option-button:hover:not(:disabled) .dss-option-button__label:not(.dss-option-button__label--toggle-selection),.dss-option-button:hover:not(:disabled) .dss-option-button__option {
    color: #900
}

.dss-option-button__action {
    display: block;
    padding: 16px
}

.dss-option-button__action .dss-button {
    width: 100%
}

.dss-option-button__selection {
    display: block;
    max-height: 272px;
    overflow-x: auto;
    padding: 16px
}

.dss-option-button__selection--scroll~.dss-option-button__action {
    box-shadow: 0 2px 8px -2px rgba(34,34,34,.4)
}

.dss-option-button__selection-title {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 16px;
    padding-left: 8px;
    padding-right: 8px
}

@media (min-width: 1920px) {
    .dss-option-button {
        font-size:16px;
        height: 56px;
        line-height: 24px;
        max-width: 360px;
        min-width: 104px
    }
}

.dss-pagination {
    align-items: center;
    background-color: #f0f0f0;
    display: flex;
    justify-content: space-between;
    padding: 24px 16px;
    width: 100%
}

.dss-pagination .dss-option-button:not(.dss-option-button--active):not(:hover) {
    background-color: inherit
}

.dss-pagination .dss-option-button__label {
    display: none
}

.dss-pagination__list {
    align-items: center;
    display: flex;
    list-style: none
}

.dss-pagination__link {
    color: #c00;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-left: 12px;
    margin-right: 12px;
    transition-duration: .1s;
    transition-property: color;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-pagination__link:hover {
    color: #900
}

.dss-pagination__item {
    display: none
}

.dss-pagination__item--active {
    display: inline-block
}

.dss-pagination__item--active .dss-pagination__link {
    color: #222;
    text-decoration: none
}

.dss-pagination__item--disabled {
    cursor: not-allowed
}

.dss-pagination__item--disabled .dss-pagination__link {
    color: #ccc;
    pointer-events: none
}

.dss-pagination__item--disabled .dss-pagination__icon:before {
    color: #ccc
}

.dss-pagination__item:first-of-type,.dss-pagination__item:last-of-type {
    display: inline-block
}

.dss-pagination__item:first-of-type .dss-pagination__link,.dss-pagination__item:last-of-type .dss-pagination__link {
    text-decoration: none
}

.dss-pagination__item:first-of-type .dss-pagination__link {
    margin-left: 0
}

.dss-pagination__item:last-of-type .dss-pagination__link {
    margin-right: 0
}

@media (min-width: 768px) {
    .dss-pagination {
        padding:24px
    }

    .dss-pagination .dss-option-button__label {
        display: inline
    }

    .dss-pagination__item {
        display: inline-block
    }

    .dss-pagination__item:first-of-type .dss-pagination__link {
        margin-right: 20px
    }

    .dss-pagination__item:last-of-type .dss-pagination__link {
        margin-left: 20px
    }
}

@media (min-width: 1920px) {
    .dss-pagination {
        padding:32px
    }
}

.dss-product-card {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    box-shadow: 0 2px 8px -2px rgba(34,34,34,.4);
    display: block;
    max-width: 288px;
    width: 100%
}

.dss-product-card__picture {
    display: flex
}

.dss-product-card__img,.dss-product-card__picture {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px
}

.dss-product-card__img {
    height: auto;
    max-width: 100%
}

.dss-product-card__body {
    display: block;
    margin-bottom: 24px;
    padding: 16px 16px 0
}

.dss-product-card__title {
    color: #222;
    display: block;
    font-family: SantanderHeadline,sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 1.33333333;
    margin-bottom: 16px
}

.dss-product-card__content {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5
}

.dss-product-card__footer {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: 0 16px 16px
}

@media (min-width: 1920px) {
    .dss-product-card {
        max-width:360px
    }

    .dss-product-card__title {
        font-size: 24px;
        line-height: 32px
    }

    .dss-product-card__content {
        font-size: 16px;
        line-height: 24px
    }

    .dss-product-card__body {
        margin-bottom: 32px;
        padding: 24px 24px 0
    }

    .dss-product-card__footer {
        padding: 0 24px 24px
    }
}

.dss-progress-loader__bar {
    background-color: #c00;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    height: 8px;
    left: 0;
    position: absolute;
    top: 0;
    transition-duration: .2s;
    transition-property: width,border-radius;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 0
}

.dss-progress-loader__bar--finished {
    border-radius: 4px
}

.dss-progress-loader__icon {
    margin-right: 8px
}

.dss-progress-loader {
    display: block;
    width: 100%
}

.dss-progress-loader--error .dss-progress-loader__bar {
    background-color: #f14c4c
}

.dss-progress-loader--error .dss-progress-loader__icon {
    color: #f14c4c
}

.dss-progress-loader--success .dss-progress-loader__bar {
    background-color: #739e41
}

.dss-progress-loader--success .dss-progress-loader__icon {
    color: #739e41
}

.dss-progress-loader__bar-wrapper {
    background-color: #ccc;
    border-radius: 4px;
    height: 8px;
    margin-bottom: 8px;
    position: relative;
    width: 100%
}

.dss-progress-loader__content {
    align-items: center;
    color: #444;
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429;
    width: 100%
}

@media (min-width: 1920px) {
    .dss-progress-loader__content {
        font-size:14px;
        line-height: 18px
    }
}

.dss-progress-step {
    display: flex;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    height: 56px;
    line-height: 1.5;
    list-style: none;
    padding-bottom: 8px;
    padding-top: 8px;
    position: relative;
    width: 100%
}

.dss-progress-step__title {
    animation-duration: .3s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    background-color: #fff;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% - 2px))
}

.dss-progress-step__title--active {
    animation-name: dss-progress-step-fade-in
}

.dss-progress-step__title--out {
    animation-name: dss-progress-step-fade-out
}

@media (-ms-high-contrast:none) {
    .dss-progress-step__title {
        top: 24px
    }
}

.dss-progress-step__number {
    margin-right: 8px
}

.dss-progress-step__step {
    background-color: #ccc;
    border-radius: 2px;
    height: 4px;
    position: relative
}

.dss-progress-step__step:after {
    background-color: #c00;
    border-radius: 2px;
    content: "";
    height: 4px;
    left: 0;
    position: absolute;
    top: 0;
    transition-duration: .3s;
    transition-property: width;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 0
}

.dss-progress-step__step--active:after {
    width: 100%
}

.dss-progress-step__item {
    display: inline-flex;
    flex: 1 0 auto;
    flex-direction: column;
    justify-content: flex-end
}

.dss-progress-step__item:first-of-type .dss-progress-step__title--active {
    animation-name: unset;
    opacity: 1
}

.dss-progress-step__item:not(:last-of-type) {
    margin-right: 8px
}

@media (min-width: 768px) {
    .dss-progress-step {
        height:80px;
        padding-bottom: 16px;
        padding-top: 16px
    }
}

@media (min-width: 1920px) {
    .dss-progress-step {
        font-size:16px;
        height: 88px;
        line-height: 24px;
        padding-bottom: 24px;
        padding-top: 24px
    }
}

@keyframes dss-progress-step-fade-in {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

@keyframes dss-progress-step-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.dss-result-state {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    margin: 0 auto;
    max-width: 560px;
    text-align: center;
    width: 100%
}

.dss-result-state__icon {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
    width: 100%
}

.dss-result-state__icon [class*=dss-status-icon] {
    font-size: 24px;
    height: 40px;
    line-height: 24px;
    width: 40px
}

.dss-result-state__icon [class*=dss-status-icon]:before {
    font-size: 24px;
    height: 24px;
    line-height: 24px;
    width: 24px
}

.dss-result-state__title {
    display: block;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: 8px;
    width: 100%
}

.dss-result-state__content {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5
}

.dss-result-state__actions,.dss-result-state__content {
    display: block;
    margin-bottom: 16px;
    width: 100%
}

.dss-result-state__actions .dss-button:not(:first-of-type) {
    margin-left: 16px
}

@media (min-width: 1920px) {
    .dss-result-state {
        max-width:572px
    }

    .dss-result-state__title {
        font-size: 24px;
        line-height: 36px
    }

    .dss-result-state__content {
        font-size: 16px;
        line-height: 24px
    }
}

.dss-page-menu {
    background-color: #fff;
    color: #222
}

.dss-page-menu__columns {
    -webkit-column-count: 1;
    -moz-column-count: 1;
    -webkit-column-gap: 16px;
    -moz-column-gap: 16px;
    grid-column-gap: 16px;
    column-gap: 16px;
    -webkit-column-width: 288px;
    -moz-column-width: 288px;
    columns: 288px 1
}

.dss-page-menu__title {
    display: block;
    font-family: SantanderHeadline,sans-serif;
    font-size: 48px;
    font-weight: 400;
    line-height: 1.25;
    margin-bottom: 32px;
    width: 100%
}

.dss-page-menu__list-description {
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    line-height: 1.28571429;
    margin-bottom: 8px;
    width: 100%
}

.dss-page-menu__list {
    display: inline-block;
    margin-bottom: 56px;
    width: calc(100% - 16px)
}

.dss-page-menu__list>.dss-page-menu__list-description {
    color: #222;
    font-weight: 700
}

.dss-page-menu__list-title {
    font-weight: 700;
    margin-bottom: 8px
}

.dss-page-menu__list-item,.dss-page-menu__list-title {
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    line-height: 1.5;
    width: 100%
}

.dss-page-menu__list-item {
    cursor: pointer;
    font-weight: 400;
    padding: 16px 8px;
    transition-duration: .1s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-page-menu__list-item:hover {
    background-color: #eef6f8
}

.dss-page-menu__list-item>a {
    color: #222;
    text-decoration: none
}

.dss-page-menu__list-item>.dss-page-menu__list-description {
    color: #444;
    font-weight: 400
}

.dss-page-menu__new-item {
    background-color: #739e41;
    border-radius: 4px;
    color: #fff;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.28571429;
    margin-bottom: 4px;
    padding-left: 8px;
    padding-right: 8px;
    text-align: center;
    width: 56px
}

@media (min-width: 768px) {
    .dss-page-menu__columns {
        -webkit-column-count:3;
        -moz-column-count: 3;
        -webkit-column-width: 304px;
        -moz-column-width: 304px;
        columns: 304px 3
    }
}

.dss-status-arrow {
    border-style: solid;
    cursor: pointer;
    display: block;
    height: 0;
    margin: 8px 16px;
    width: 0
}

.dss-status-arrow--top {
    border-color: transparent transparent #767676;
    border-width: 0 8px 8px
}

.dss-status-arrow--top.dss-status-arrow--active {
    border-bottom-color: #c00
}

.dss-status-arrow--top.dss-status-arrow--negative {
    border-bottom-color: #f14c4c
}

.dss-status-arrow--top.dss-status-arrow--positive {
    border-bottom-color: #739e41
}

.dss-status-arrow--top.dss-status-arrow--disabled {
    border-bottom-color: #ccc
}

.dss-status-arrow--top:hover:not(.dss-status-arrow--negative):not(.dss-status-arrow--positive):not(.dss-status-arrow--disabled) {
    border-bottom-color: #222
}

.dss-status-arrow--bottom {
    border-color: #767676 transparent transparent;
    border-width: 8px 8px 0
}

.dss-status-arrow--bottom.dss-status-arrow--active {
    border-top-color: #c00
}

.dss-status-arrow--bottom.dss-status-arrow--negative {
    border-top-color: #f14c4c
}

.dss-status-arrow--bottom.dss-status-arrow--positive {
    border-top-color: #739e41
}

.dss-status-arrow--bottom.dss-status-arrow--disabled {
    border-top-color: #ccc
}

.dss-status-arrow--bottom:hover:not(.dss-status-arrow--negative):not(.dss-status-arrow--positive):not(.dss-status-arrow--disabled) {
    border-top-color: #222
}

.dss-status-arrow--right {
    border-color: transparent transparent transparent #767676;
    border-width: 8px 0 8px 8px
}

.dss-status-arrow--right.dss-status-arrow--active {
    border-left-color: #c00
}

.dss-status-arrow--right.dss-status-arrow--negative {
    border-left-color: #f14c4c
}

.dss-status-arrow--right.dss-status-arrow--positive {
    border-left-color: #739e41
}

.dss-status-arrow--right.dss-status-arrow--disabled {
    border-left-color: #ccc
}

.dss-status-arrow--right:hover:not(.dss-status-arrow--negative):not(.dss-status-arrow--positive):not(.dss-status-arrow--disabled) {
    border-left-color: #222
}

.dss-status-arrow--left {
    border-color: transparent #767676 transparent transparent;
    border-width: 8px 8px 8px 0
}

.dss-status-arrow--left.dss-status-arrow--active {
    border-right-color: #c00
}

.dss-status-arrow--left.dss-status-arrow--negative {
    border-right-color: #f14c4c
}

.dss-status-arrow--left.dss-status-arrow--positive {
    border-right-color: #739e41
}

.dss-status-arrow--left.dss-status-arrow--disabled {
    border-right-color: #ccc
}

.dss-status-arrow--left:hover:not(.dss-status-arrow--negative):not(.dss-status-arrow--positive):not(.dss-status-arrow--disabled) {
    border-right-color: #222
}

.dss-status-bar {
    background-color: #767676;
    border-radius: 50px;
    display: block;
    height: 4px;
    width: 100%
}

.dss-status-bar--active {
    background-color: #c00
}

.dss-status-circle {
    background-color: #999;
    border-radius: 50%;
    display: inline-block;
    height: 16px;
    outline: 0;
    transition-duration: .1s;
    transition-property: background-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    width: 16px
}

.dss-status-circle--active {
    background-color: #c00
}

.dss-status-circle--disabled {
    background-color: #ccc;
    cursor: not-allowed
}

.dss-status-circle:focus:not(.dss-status-circle--disabled) {
    box-shadow: 0 0 0 4px #bde3ea
}

.dss-status-circle:hover:not(.dss-status-circle--disabled) {
    background-color: #900
}

.dss-status-icon {
    align-items: center;
    background-color: transparent;
    border-radius: 50%;
    border-style: solid;
    border-width: 6px;
    display: flex;
    font-size: 20px;
    height: 32px;
    justify-content: center;
    line-height: 20px;
    width: 32px
}

.dss-status-icon:before {
    font-size: 20px;
    height: 20px;
    line-height: 20px;
    width: 20px
}

.dss-status-icon--danger {
    border-color: #f14c4c
}

.dss-status-icon--danger:before {
    color: #f14c4c
}

.dss-status-icon--info {
    border-color: #5ab8ca
}

.dss-status-icon--info:before {
    color: #5ab8ca;
    transform: rotate(180deg)
}

.dss-status-icon--success {
    border-color: #739e41
}

.dss-status-icon--success:before {
    color: #739e41
}

.dss-status-icon--warning {
    border-color: #f2a51a
}

.dss-status-icon--warning:before {
    color: #f2a51a
}

.dss-skeleton {
    display: inline-block
}

.dss-skeleton--width {
    width: 100%
}

.dss-skeleton__item {
    background-color: #f0f0f0;
    border-radius: 4px;
    display: inline-block;
    height: inherit;
    width: 100%
}

.dss-skeleton__item--circle {
    border-radius: 50%
}

.dss-skeleton__item--paragraph {
    margin-bottom: 8px
}

.dss-skeleton__item--animate {
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-name: dss-skeleton-fade;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    background-color: #f0f0f0
}

.dss-skeleton__template-list,.dss-skeleton__template-paragraph {
    list-style: none
}

.dss-skeleton__template-list-item {
    align-items: flex-start;
    display: flex;
    margin-bottom: 16px
}

.dss-skeleton__template-list-icon {
    border-radius: 50%;
    height: 32px;
    margin-right: 16px;
    width: 32px
}

.dss-skeleton__template-list-paragraphs {
    width: 100%
}

.dss-skeleton__template-list-paragraphs .dss-skeleton__item--paragraph {
    height: 8px
}

@keyframes dss-skeleton-fade {
    0% {
        opacity: 1
    }

    50% {
        opacity: .55
    }

    to {
        opacity: 1
    }
}

.dss-statistic__header {
    display: block;
    margin-bottom: 8px;
    width: 100%
}

.dss-statistic__title {
    color: #444;
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429
}

.dss-statistic__value {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.14285714;
    margin-top: 8px
}

.dss-statistic__icon {
    color: #444;
    position: absolute;
    right: 16px;
    top: 16px
}

.dss-statistic__list {
    list-style: none
}

.dss-statistic__item-label {
    flex: 2
}

.dss-statistic__item-value {
    align-items: center;
    display: inline-flex;
    flex: 1;
    justify-content: flex-end;
    text-align: right;
    white-space: nowrap
}

.dss-statistic__item {
    align-items: center;
    color: #444;
    display: flex;
    font-size: 14px;
    font-weight: 400;
    justify-content: space-between;
    line-height: 1.28571429;
    padding-bottom: 8px;
    padding-top: 8px
}

.dss-statistic__item--positive .dss-statistic__item-value {
    color: #739e41
}

.dss-statistic__item--negative .dss-statistic__item-value {
    color: #f14c4c
}

.dss-statistic {
    background-color: #fff;
    font-family: SantanderMicroText,sans-serif;
    position: relative
}

.dss-statistic--icon .dss-statistic__header {
    width: calc(100% - 40px)
}

.dss-statistic--default {
    border-radius: 4px;
    border: 1px solid #ccc;
    display: block;
    margin-bottom: 8px;
    max-width: 288px;
    padding: 16px 16px 24px;
    width: 100%
}

.dss-statistic--default .dss-statistic__item:not(:last-of-type) {
    border-bottom: 1px solid #ccc
}

.dss-statistic--spaced {
    max-width: 288px;
    width: 100%
}

.dss-statistic--spaced .dss-statistic__value {
    border-bottom: 1px solid #ccc;
    display: block;
    max-width: 288px;
    padding-bottom: 8px
}

.dss-statistic--spaced .dss-statistic__item {
    border-bottom: 1px solid #ccc;
    margin-top: 40px
}

.dss-statistic--inline {
    align-items: center;
    border-radius: 4px;
    border: 1px solid #ccc;
    display: inline-flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 16px
}

.dss-statistic--inline .dss-statistic__header {
    flex: 1 0 188px
}

.dss-statistic--inline .dss-statistic__header:not(:last-of-type) {
    border-right: 1px solid #ccc;
    margin-right: 16px
}

@media (min-width: 768px) {
    .dss-statistic--default {
        max-width:360px
    }

    .dss-statistic--inline {
        overflow: initial
    }

    .dss-statistic--inline .dss-statistic__header {
        flex: initial;
        width: 204px
    }
}

.dss-segment-control {
    background-color: #fff;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    width: 100%
}

.dss-segment-control__nav-wrapper {
    display: block;
    overflow-x: auto;
    position: relative;
    width: 100%
}

.dss-segment-control__nav {
    align-items: center;
    border-bottom: 1px solid #ccc;
    color: #222;
    display: flex;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    list-style: none;
    position: relative;
    width: 100%
}

.dss-segment-control__item {
    border-radius: 4px;
    cursor: pointer;
    margin: 4px;
    outline: 0;
    padding: 8px 24px;
    position: relative;
    text-align: center;
    transition-duration: .1s;
    transition-property: background-color,color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    white-space: nowrap
}

.dss-segment-control__item:after {
    background-color: #767676;
    content: "";
    height: 1px;
    left: -4px;
    position: absolute;
    top: calc(100% + 4px);
    width: calc(100% + 8px)
}

.dss-segment-control__item:focus:not(.dss-segment-control__item--disabled) {
    box-shadow: 0 0 0 4px #bde3ea
}

.dss-segment-control__item:hover:not(.dss-segment-control__item--disabled) {
    background-color: #eef6f8
}

.dss-segment-control__item.dss-segment-control__item--active:not(.dss-segment-control__item--disabled) {
    color: #c00
}

.dss-segment-control__item.dss-segment-control__item--disabled {
    color: #ccc;
    cursor: not-allowed
}

.dss-segment-control__item.dss-segment-control__item--disabled:after {
    background-color: #ccc
}

.dss-segment-control__bar {
    background-color: #c00;
    bottom: 0;
    height: 2px;
    left: 0;
    position: absolute;
    transition-duration: .2s;
    transition-property: left,width;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-segment-control__content {
    display: block;
    width: 100%
}

@media (min-width: 768px) {
    .dss-segment-control__nav-wrapper {
        overflow-x:initial
    }

    .dss-segment-control__nav {
        margin-left: 0
    }

    .dss-segment-control__item {
        white-space: normal
    }
}

@media (min-width: 1920px) {
    .dss-segment-control__nav {
        font-size:16px;
        line-height: 24px
    }
}

.dss-search-bar__header-icon:before {
    color: #fff
}

.dss-search-bar__wrapper {
    border-radius: 4px;
    position: relative;
    width: 100%
}

.dss-search-bar__input {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    min-height: 48px;
    outline: 0;
    padding: 8px 56px;
    width: 100%
}

.dss-search-bar__input:hover {
    border-color: #444
}

.dss-search-bar__input:focus {
    border-color: #5ab8ca
}

.dss-search-bar__input:disabled {
    border-color: #ccc;
    color: #ccc;
    cursor: inherit
}

.dss-search-bar__back-icon,.dss-search-bar__search-icon {
    background-color: #fff;
    cursor: pointer;
    left: 16px;
    pointer-events: none;
    position: absolute;
    top: 12px
}

.dss-search-bar {
    position: relative
}

.dss-search-bar--disabled {
    cursor: not-allowed
}

.dss-search-bar--disabled .dss-search-bar__header-icon {
    cursor: inherit
}

.dss-search-bar--disabled .dss-search-bar__header-icon:before,.dss-search-bar--disabled .dss-search-bar__search-icon:before {
    color: #ccc
}

.dss-search-bar--active .dss-search-bar__wrapper {
    box-shadow: 0 2px 8px 0 rgba(34,34,34,.4);
    display: block;
    overflow: hidden
}

.dss-search-bar--active .dss-search-bar__search-icon {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-slide-in-left-search-icon;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    left: calc(100% - 40px)
}

.dss-search-bar--active .dss-search-bar__back-icon {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-fade-in-back-icon;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-search-bar--reverse-animation .dss-search-bar__search-icon {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-slide-out-left-search-icon;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-search-bar--reverse-animation .dss-search-bar__back-icon {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-fade-out-back-icon;
    animation-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-search-bar--header {
    height: 24px;
    width: 24px
}

.dss-search-bar--header .dss-search-bar__wrapper {
    display: none
}

.dss-search-bar--header.dss-search-bar--active {
    bottom: 8px;
    height: auto;
    left: 16px;
    position: absolute;
    right: 16px;
    top: 8px;
    width: auto;
    z-index: 1000
}

.dss-search-bar--header.dss-search-bar--active .dss-search-bar__header-icon {
    display: none
}

.dss-search-bar--header.dss-search-bar--active .dss-search-bar__wrapper {
    animation-duration: .4s;
    animation-fill-mode: both;
    animation-name: dss-slide-in-left-wrapper;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    display: block
}

@media (-ms-high-contrast:none) {
    .dss-search-bar--active .dss-search-bar__back-icon {
        pointer-events: auto
    }
}

.dss-autocomplete {
    position: absolute;
    top: calc(100% + 4px)
}

.dss-autocomplete.dss-flyout-menu {
    max-width: none
}

.dss-autocomplete .dss-flyout-menu__item {
    cursor: pointer;
    padding: 8px 16px
}

.dss-autocomplete .dss-divider {
    margin: 0 auto;
    width: calc(100% - 16px)
}

.dss-autocomplete--bottom-page {
    bottom: 52px;
    top: auto
}

.dss-autocomplete__item-title {
    color: #222;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5
}

.dss-autocomplete__item-title--includes {
    color: #5ab8ca
}

.dss-autocomplete__item-subtitle,.dss-autocomplete__latest-searches {
    color: #444;
    display: block;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429
}

.dss-autocomplete__latest-searches {
    padding: 8px 16px
}

.dss-autocomplete__item-last {
    align-items: center;
    display: flex;
    justify-content: space-between
}

@media (min-width: 768px) {
    .dss-search-bar__header-icon {
        display:none
    }

    .dss-search-bar__back-icon,.dss-search-bar__search-icon {
        animation-name: none
    }

    .dss-search-bar--header {
        height: auto;
        width: auto
    }

    .dss-search-bar--header .dss-search-bar__wrapper {
        display: block
    }

    .dss-search-bar--header.dss-search-bar--active {
        bottom: auto;
        left: auto;
        position: relative;
        right: auto;
        top: auto
    }

    .dss-search-bar--header.dss-search-bar--active .dss-search-bar__wrapper {
        animation-name: none
    }

    .dss-search-bar--header.dss-search-bar--active .dss-search-bar__search-icon {
        animation-name: dss-slide-in-left-search-icon
    }

    .dss-search-bar--header.dss-search-bar--active .dss-search-bar__back-icon {
        animation-name: dss-fade-in-back-icon
    }
}

@media (min-width: 1920px) {
    .dss-search-bar__input {
        font-size:16px;
        line-height: 24px
    }

    .dss-autocomplete .dss-flyout-menu__item {
        padding-bottom: 16px;
        padding-top: 16px
    }

    .dss-autocomplete__item-title {
        font-size: 16px;
        line-height: 24px
    }
}

@keyframes dss-fade-in-back-icon {
    0% {
        opacity: 0
    }

    to {
        opacity: 1;
        pointer-events: auto
    }
}

@keyframes dss-fade-out-back-icon {
    0% {
        opacity: 1
    }

    to {
        opacity: 0;
        pointer-events: none
    }
}

@keyframes dss-slide-in-left-search-icon {
    0% {
        left: 16px;
        opacity: 1
    }

    50% {
        left: 0;
        opacity: 0
    }

    51% {
        left: calc(100% + 40px);
        opacity: 0
    }

    99% {
        left: calc(100% - 40px);
        opacity: 1
    }

    to {
        pointer-events: auto
    }
}

@keyframes dss-slide-out-left-search-icon {
    0% {
        left: calc(100% - 40px);
        opacity: 1
    }

    50% {
        left: calc(100% - 16px);
        opacity: 0
    }

    51% {
        left: 0;
        opacity: 0
    }

    99% {
        left: 16px;
        opacity: 1
    }

    to {
        pointer-events: none
    }
}

@keyframes dss-slide-in-left-wrapper {
    0% {
        transform: translateX(100%);
        width: 0
    }

    to {
        transform: translateX(0);
        width: 100%
    }
}

.dss-table-wrapper {
    overflow-x: auto;
    overflow-y: visible;
    width: 100%
}

.dss-table {
    background-color: #fff;
    border-spacing: 0;
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    width: 100%
}

.dss-table thead th {
    background-color: #f0f0f0;
    border-bottom: 1px solid #ccc;
    font-weight: 700;
    min-width: 100px;
    padding: 21px 24px;
    text-align: left
}

.dss-table thead th:not(.dss-table__fixed-column) {
    white-space: nowrap
}

.dss-table thead th:hover:not(:empty) {
    background-color: #eef6f8
}

.dss-table tbody {
    background-color: inherit
}

.dss-table tbody td {
    border-bottom: 1px solid #ccc;
    min-width: 100px;
    padding: 21px 24px
}

.dss-table tbody td:not(.dss-table__fixed-column) {
    white-space: nowrap
}

.dss-table tbody tr:hover td {
    background-color: #eef6f8
}

.dss-table tbody tr.dss-table__row-selected td {
    background-color: #deedf2
}

.dss-table.dss-table--option tbody tr td:first-of-type,.dss-table.dss-table--option thead tr th:first-of-type {
    min-width: 56px;
    padding-left: 16px;
    padding-right: 16px
}

.dss-table.dss-table--option tbody tr td:first-of-type .dss-checkbox,.dss-table.dss-table--option tbody tr td:first-of-type .dss-radio-group__item,.dss-table.dss-table--option thead tr th:first-of-type .dss-checkbox,.dss-table.dss-table--option thead tr th:first-of-type .dss-radio-group__item {
    display: inline-flex;
    padding-left: 0;
    padding-right: 0;
    width: 24px
}

.dss-table.dss-table--option tbody tr td:first-of-type .dss-checkbox__label:before,.dss-table.dss-table--option tbody tr td:first-of-type .dss-radio-group__label:before,.dss-table.dss-table--option thead tr th:first-of-type .dss-checkbox__label:before,.dss-table.dss-table--option thead tr th:first-of-type .dss-radio-group__label:before {
    margin-right: 0
}

.dss-table.dss-table--actions-inline tbody tr td:last-of-type ul {
    list-style: none
}

.dss-table.dss-table--actions-inline tbody tr td:last-of-type li {
    display: inline-block;
    margin-left: 8px;
    margin-right: 8px
}

.dss-table.dss-table--actions-inline tbody tr td:last-of-type li:first-of-type {
    margin-left: 0
}

.dss-table.dss-table--actions-inline tbody tr td:last-of-type li:last-of-type {
    margin-right: 0
}

.dss-table.dss-table--actions-inline tbody tr td:last-of-type a {
    text-decoration: none
}

.dss-table__fixed-column {
    background-color: #fff;
    z-index: 1
}

.dss-table__fixed-column--last {
    border-right: 1px solid #999
}

.dss-table__container-actions {
    position: absolute;
    right: 0;
    width: 218px;
    z-index: 1000
}

.dss-table__actions {
    list-style: none;
    text-align: center
}

.dss-table__item {
    position: relative
}

.dss-table__link {
    color: inherit;
    display: inline-flex;
    text-decoration: none
}

.dss-table__link:focus {
    border-radius: 4px;
    box-shadow: 0 0 0 4px #bde3ea;
    outline: 0
}

.dss-table__icon {
    cursor: pointer
}

@media (min-width: 1920px) {
    .dss-table {
        font-size:16px;
        line-height: 24px
    }
}

.dss-tag--default .dss-tag__list {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%
}

.dss-tag--input {
    border-radius: 4px;
    position: relative;
    width: 100%
}

.dss-tag--input .dss-tag__list {
    flex-wrap: wrap;
    width: 100%
}

.dss-tag--input .dss-tag__list,.dss-tag__item {
    display: inline-flex
}

.dss-tag__item {
    align-items: center;
    appearance: none;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    color: #444;
    cursor: pointer;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    justify-content: center;
    line-height: 21px;
    margin-bottom: 16px;
    margin-left: 16px;
    margin-top: 16px;
    outline: 0;
    padding: 4px 8px;
    transition-duration: .1s;
    transition-property: border-color;
    transition-timing-function: cubic-bezier(.6,0,.2,1);
    white-space: nowrap
}

.dss-tag__item:not(.dss-tag__item--disabled):focus {
    box-shadow: 0 0 0 4px #bde3ea
}

.dss-tag__item--active {
    background-color: #444;
    color: #fff
}

.dss-tag__item--disabled {
    cursor: not-allowed
}

.dss-tag__item:not(.dss-tag__item--disabled):hover {
    border-color: #444
}

.dss-tag__icon {
    animation-duration: .1s;
    animation-fill-mode: both;
    animation-name: dss-fade-in-tag-icon;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    color: #fff;
    margin-left: 8px
}

.dss-icon--small {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    width: 16px
}

.dss-tag__input-wrapper {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #767676;
    min-height: 138px;
    overflow: hidden
}

.dss-tag__input-wrapper:hover {
    border-color: #444
}

.dss-tag__input {
    appearance: none;
    background-color: #fff;
    border: none;
    border-radius: 4px;
    color: #444;
    display: flex;
    flex: 1 0 150px;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 16px;
    margin-left: 16px;
    margin-top: 16px;
    outline: 0;
    padding: 4px 8px
}

.dss-tag__input:disabled {
    color: #ccc;
    cursor: inherit
}

.dss-tag-list--active~.dss-form-field__label {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-tag-list--focus .dss-tag__input-wrapper {
    border-color: #5ab8ca
}

.dss-tag-list--focus~.dss-form-field__label {
    font-size: 14px;
    line-height: 1.28571429;
    top: -10px
}

.dss-form-field.dss-form-field--disabled .dss-tag--input {
    cursor: not-allowed
}

.dss-form-field.dss-form-field--disabled .dss-tag__input-wrapper {
    border-color: #ccc
}

.dss-form-field.dss-form-field--error .dss-tag__input-wrapper {
    border-color: #f14c4c
}

.dss-form-field.dss-form-field--success .dss-tag__input-wrapper {
    border-color: #739e41
}

.dss-form-field.dss-form-field--right-icon .dss-tag__input-wrapper {
    padding-right: 56px
}

@media (min-width: 768px) {
    .dss-tag--default .dss-tag__list {
        display:block;
        overflow-x: initial;
        overflow-y: initial
    }
}

@media (min-width: 1920px) {
    .dss-tag__item {
        margin-bottom:24px;
        margin-left: 24px;
        margin-top: 24px
    }
}

@keyframes dss-fade-in-tag-icon {
    0% {
        opacity: 0;
        width: 0
    }

    to {
        opacity: 1;
        width: 16px
    }
}

.dss-tooltip__arrow {
    border-style: solid;
    border-width: 1px;
    height: 14px;
    position: absolute;
    transform: rotate(45deg);
    width: 14px
}

.dss-tooltip__text {
    border-radius: 4px;
    border-style: solid;
    border-width: 1px;
    font-family: SantanderMicroText,sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.28571429;
    padding: 8px
}

.dss-tooltip {
    animation-duration: .2s;
    animation-fill-mode: both;
    animation-name: dss-tooltip-fade-in;
    animation-timing-function: cubic-bezier(.6,0,.2,1);
    border-radius: 4px;
    display: none;
    max-width: 184px;
    position: absolute
}

.dss-tooltip--close {
    animation-name: dss-tooltip-fade-out;
    animation-timing-function: cubic-bezier(.8,0,.4,1)
}

.dss-tooltip--right {
    padding: 8px;
    transform-origin: left center
}

.dss-tooltip--right .dss-tooltip__arrow {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 50%;
    left: 2px;
    margin-top: -7px;
    top: 50%
}

.dss-tooltip--right-bottom {
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    transform-origin: left bottom
}

.dss-tooltip--right-bottom .dss-tooltip__arrow {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 50%;
    bottom: 8px;
    left: 2px
}

.dss-tooltip--right-top {
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
    transform-origin: left top
}

.dss-tooltip--right-top .dss-tooltip__arrow {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 50%;
    left: 2px;
    top: 8px
}

.dss-tooltip--left {
    padding: 8px;
    transform-origin: right center
}

.dss-tooltip--left .dss-tooltip__arrow {
    border-bottom-left-radius: 50%;
    border-top-right-radius: 4px;
    margin-top: -7px;
    right: 2px;
    top: 50%
}

.dss-tooltip--left-bottom {
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    transform-origin: right bottom
}

.dss-tooltip--left-bottom .dss-tooltip__arrow {
    border-bottom-left-radius: 50%;
    border-top-right-radius: 4px;
    bottom: 8px;
    right: 2px
}

.dss-tooltip--left-top {
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
    transform-origin: right top
}

.dss-tooltip--left-top .dss-tooltip__arrow {
    border-bottom-left-radius: 50%;
    border-top-right-radius: 4px;
    right: 2px;
    top: 8px
}

.dss-tooltip--top {
    padding: 8px;
    transform-origin: bottom center
}

.dss-tooltip--top .dss-tooltip__arrow {
    border-bottom-right-radius: 4px;
    border-top-left-radius: 50%;
    bottom: 2px;
    left: 50%;
    margin-left: -7px
}

.dss-tooltip--top-left {
    padding-bottom: 8px;
    padding-right: 8px;
    padding-top: 8px;
    transform-origin: bottom left
}

.dss-tooltip--top-left .dss-tooltip__arrow {
    border-bottom-right-radius: 4px;
    border-top-left-radius: 50%;
    bottom: 2px;
    left: 16px
}

.dss-tooltip--top-right {
    padding-bottom: 8px;
    padding-left: 8px;
    padding-top: 8px;
    transform-origin: bottom right
}

.dss-tooltip--top-right .dss-tooltip__arrow {
    border-bottom-right-radius: 4px;
    border-top-left-radius: 50%;
    bottom: 2px;
    right: 16px
}

.dss-tooltip--bottom {
    padding: 8px;
    transform-origin: top center
}

.dss-tooltip--bottom .dss-tooltip__arrow {
    border-bottom-right-radius: 50%;
    border-top-left-radius: 4px;
    left: 50%;
    margin-left: -7px;
    top: 2px
}

.dss-tooltip--bottom-left {
    padding-bottom: 8px;
    padding-right: 8px;
    padding-top: 8px;
    transform-origin: top left
}

.dss-tooltip--bottom-left .dss-tooltip__arrow {
    border-bottom-right-radius: 50%;
    border-top-left-radius: 4px;
    left: 16px;
    top: 2px
}

.dss-tooltip--bottom-right {
    padding-bottom: 8px;
    padding-left: 8px;
    padding-top: 8px;
    transform-origin: top right
}

.dss-tooltip--bottom-right .dss-tooltip__arrow {
    border-bottom-right-radius: 50%;
    border-top-left-radius: 4px;
    right: 16px;
    top: 2px
}

.dss-tooltip--dark .dss-tooltip__arrow {
    background-color: #444
}

.dss-tooltip--dark.dss-tooltip--right .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--right-bottom .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--right-top .dss-tooltip__arrow {
    border-color: transparent transparent #444 #444
}

.dss-tooltip--dark.dss-tooltip--left .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--left-bottom .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--left-top .dss-tooltip__arrow {
    border-color: #444 #444 transparent transparent
}

.dss-tooltip--dark.dss-tooltip--top .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--top-left .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--top-right .dss-tooltip__arrow {
    border-color: transparent #444 #444 transparent
}

.dss-tooltip--dark.dss-tooltip--bottom .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--bottom-left .dss-tooltip__arrow,.dss-tooltip--dark.dss-tooltip--bottom-right .dss-tooltip__arrow {
    border-color: #444 transparent transparent #444
}

.dss-tooltip--dark .dss-tooltip__text {
    background-color: #444;
    border-color: #444;
    color: #fff
}

.dss-tooltip--light .dss-tooltip__arrow {
    background-color: #fff
}

.dss-tooltip--light.dss-tooltip--right .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--right-bottom .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--right-top .dss-tooltip__arrow {
    border-color: transparent transparent #ccc #ccc
}

.dss-tooltip--light.dss-tooltip--left .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--left-bottom .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--left-top .dss-tooltip__arrow {
    border-color: #ccc #ccc transparent transparent
}

.dss-tooltip--light.dss-tooltip--top .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--top-left .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--top-right .dss-tooltip__arrow {
    border-color: transparent #ccc #ccc transparent
}

.dss-tooltip--light.dss-tooltip--bottom .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--bottom-left .dss-tooltip__arrow,.dss-tooltip--light.dss-tooltip--bottom-right .dss-tooltip__arrow {
    border-color: #ccc transparent transparent #ccc
}

.dss-tooltip--light .dss-tooltip__text {
    background-color: #fff;
    border-color: #ccc;
    color: #444
}

@keyframes dss-tooltip-fade-in {
    0% {
        opacity: 0;
        transform: scale(.6)
    }

    to {
        opacity: 1;
        transform: scale(1)
    }
}

@keyframes dss-tooltip-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.dss-treeview-container {
    background-color: #fff;
    display: block;
    padding: 24px 16px 8px
}

.dss-treeview {
    color: #222;
    font-family: SantanderMicroText,sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    list-style: none
}

.dss-treeview--margin {
    margin-left: 40px;
    margin-top: 16px
}

.dss-treeview__container-item {
    align-items: center;
    display: flex
}

.dss-treeview__icon {
    cursor: pointer;
    margin-right: 8px;
    outline: 0;
    transition-duration: .2s;
    transition-property: transform;
    transition-timing-function: cubic-bezier(.6,0,.2,1)
}

.dss-treeview__item {
    margin-bottom: 16px
}

.dss-treeview__item--opened>.dss-treeview__container-item .dss-treeview__icon {
    transform: rotate(180deg)
}

.dss-rate__icon {
    color: #ccc;
    float: right;
    font-size: 32px!important
}

.dss-rate {
    display: inline-block;
    list-style: none
}

.dss-rate__item {
    cursor: pointer;
    display: inline-block;
    padding-right: 8px
}

.dss-rate__item--hover .dss-rate__icon {
    color: #deedf2
}

.dss-rate__item--selected .dss-rate__icon {
    color: #9bc3d3
}

@media (min-width: 768px) {
    .dss-rate__icon {
        font-size:24px!important
    }
}
`;

export default styles;